export default [
	{
		value: '010105 - Oficial general da aeronáutica',
		label: '010105 - Oficial general da aeronáutica',
	},
	{
		value: '010110 - Oficial general do exército',
		label: '010110 - Oficial general do exército',
	},
	{
		value: '010115 - Oficial general da marinha',
		label: '010115 - Oficial general da marinha',
	},
	{
		value: '010215 - Oficial da marinha',
		label: '010215 - Oficial da marinha',
	},
	{
		value: '010210 - Oficial do exército',
		label: '010210 - Oficial do exército',
	},
	{
		value: '010205 - Oficial da aeronáutica',
		label: '010205 - Oficial da aeronáutica',
	},
	{
		value: '010310 - Praça do exército',
		label: '010310 - Praça do exército',
	},
	{ value: '010315 - Praça da marinha', label: '010315 - Praça da marinha' },
	{
		value: '010305 - Praça da aeronáutica',
		label: '010305 - Praça da aeronáutica',
	},
	{
		value: '020115 - Major da polícia militar',
		label: '020115 - Major da polícia militar',
	},
	{
		value: '020105 - Coronel da polícia militar',
		label: '020105 - Coronel da polícia militar',
	},
	{
		value: '020110 - Tenente-coronel da polícia militar',
		label: '020110 - Tenente-coronel da polícia militar',
	},
	{
		value: '020205 - Capitão da polícia militar',
		label: '020205 - Capitão da polícia militar',
	},
	{
		value: '020305 - Primeiro tenente de polícia militar',
		label: '020305 - Primeiro tenente de polícia militar',
	},
	{
		value: '020310 - Segundo tenente de polícia militar',
		label: '020310 - Segundo tenente de polícia militar',
	},
	{
		value: '021105 - Subtenente da policia militar',
		label: '021105 - Subtenente da policia militar',
	},
	{
		value: '021110 - Sargento da policia militar',
		label: '021110 - Sargento da policia militar',
	},
	{
		value: '021205 - Cabo da polícia militar',
		label: '021205 - Cabo da polícia militar',
	},
	{
		value: '021210 - Soldado da polícia militar',
		label: '021210 - Soldado da polícia militar',
	},
	{
		value: '030115 - Tenente-coronel bombeiro militar',
		label: '030115 - Tenente-coronel bombeiro militar',
	},
	{
		value: '030105 - Coronel bombeiro militar',
		label: '030105 - Coronel bombeiro militar',
	},
	{
		value: '030110 - Major bombeiro militar',
		label: '030110 - Major bombeiro militar',
	},
	{
		value: '030205 - Capitão bombeiro militar',
		label: '030205 - Capitão bombeiro militar',
	},
	{
		value: '030305 - Tenente do corpo de bombeiros militar',
		label: '030305 - Tenente do corpo de bombeiros militar',
	},
	{
		value: '031105 - Subtenente bombeiro militar',
		label: '031105 - Subtenente bombeiro militar',
	},
	{
		value: '031110 - Sargento bombeiro militar',
		label: '031110 - Sargento bombeiro militar',
	},
	{
		value: '031210 - Soldado bombeiro militar',
		label: '031210 - Soldado bombeiro militar',
	},
	{
		value: '031205 - Cabo bombeiro militar',
		label: '031205 - Cabo bombeiro militar',
	},
	{ value: '111120 - Vereador', label: '111120 - Vereador' },
	{
		value: '111115 - Deputado estadual e distrital',
		label: '111115 - Deputado estadual e distrital',
	},
	{ value: '111110 - Deputado federal', label: '111110 - Deputado federal' },
	{ value: '111105 - Senador', label: '111105 - Senador' },
	{
		value: '111220 - Secretário - executivo',
		label: '111220 - Secretário - executivo',
	},
	{
		value: '111215 - Ministro de estado',
		label: '111215 - Ministro de estado',
	},
	{ value: '111255 - Vice-prefeito', label: '111255 - Vice-prefeito' },
	{ value: '111250 - Prefeito', label: '111250 - Prefeito' },
	{
		value: '111245 - Vice-governador do distrito federal',
		label: '111245 - Vice-governador do distrito federal',
	},
	{
		value: '111205 - Presidente da república',
		label: '111205 - Presidente da república',
	},
	{
		value: '111225 - Membro superior do poder executivo',
		label: '111225 - Membro superior do poder executivo',
	},
	{
		value: '111230 - Governador de estado',
		label: '111230 - Governador de estado',
	},
	{
		value: '111210 - Vice-presidente da república',
		label: '111210 - Vice-presidente da república',
	},
	{
		value: '111240 - Vice-governador de estado',
		label: '111240 - Vice-governador de estado',
	},
	{
		value: '111235 - Governador do distrito federal',
		label: '111235 - Governador do distrito federal',
	},
	{ value: '111345 - Juiz do trabalho', label: '111345 - Juiz do trabalho' },
	{
		value: '111340 - Juiz auditor estadual - justiça militar',
		label: '111340 - Juiz auditor estadual - justiça militar',
	},
	{
		value: '111335 - Juiz auditor federal - justiça militar',
		label: '111335 - Juiz auditor federal - justiça militar',
	},
	{ value: '111330 - Juiz federal', label: '111330 - Juiz federal' },
	{ value: '111325 - Juiz de direito', label: '111325 - Juiz de direito' },
	{
		value: '111320 - Ministro do  superior tribunal do trabalho',
		label: '111320 - Ministro do  superior tribunal do trabalho',
	},
	{
		value: '111310 - Ministro do superior tribunal de justiça',
		label: '111310 - Ministro do superior tribunal de justiça',
	},
	{
		value: '111315 - Ministro do  superior tribunal militar',
		label: '111315 - Ministro do  superior tribunal militar',
	},
	{
		value: '111305 - Ministro do supremo tribunal federal',
		label: '111305 - Ministro do supremo tribunal federal',
	},
	{
		value: '111405 - Dirigente do serviço público federal',
		label: '111405 - Dirigente do serviço público federal',
	},
	{
		value: '111410 - Dirigente do serviço público estadual e distrital',
		label: '111410 - Dirigente do serviço público estadual e distrital',
	},
	{
		value: '111415 - Dirigente do serviço público municipal',
		label: '111415 - Dirigente do serviço público municipal',
	},
	{
		value: '111505 - Especialista de políticas públicas e gestão governamental - eppgg',
		label: '111505 - Especialista de políticas públicas e gestão governamental - eppgg',
	},
	{
		value: '111510 - Analista de planejamento e orçamento - apo',
		label: '111510 - Analista de planejamento e orçamento - apo',
	},
	{
		value: '113015 - Membro de liderança quilombola',
		label: '113015 - Membro de liderança quilombola',
	},
	{ value: '113005 - Cacique', label: '113005 - Cacique' },
	{
		value: '113010 - Líder de comunidade caiçara',
		label: '113010 - Líder de comunidade caiçara',
	},
	{
		value: '114105 - Dirigente de partido político',
		label: '114105 - Dirigente de partido político',
	},
	{
		value: '114210 - Dirigentes de entidades patronais',
		label: '114210 - Dirigentes de entidades patronais',
	},
	{
		value: '114205 - Dirigentes de entidades de trabalhadores',
		label: '114205 - Dirigentes de entidades de trabalhadores',
	},
	{
		value: '114305 - Dirigente e administrador de organização religiosa',
		label: '114305 - Dirigente e administrador de organização religiosa',
	},
	{
		value: '114405 - Dirigente e administrador de organização da sociedade civil sem fins lucrativos',
		label: '114405 - Dirigente e administrador de organização da sociedade civil sem fins lucrativos',
	},
	{
		value: '121005 - Diretor de planejamento estratégico',
		label: '121005 - Diretor de planejamento estratégico',
	},
	{
		value: '121010 - Diretor geral de empresa e organizações (exceto de interesse público)',
		label: '121010 - Diretor geral de empresa e organizações (exceto de interesse público)',
	},
	{
		value: '122120 - Diretor de produção e operações em empresa pesqueira',
		label: '122120 - Diretor de produção e operações em empresa pesqueira',
	},
	{
		value: '122115 - Diretor de produção e operações em empresa florestal',
		label: '122115 - Diretor de produção e operações em empresa florestal',
	},
	{
		value: '122105 - Diretor de produção e operações em empresa agropecuária',
		label: '122105 - Diretor de produção e operações em empresa agropecuária',
	},
	{
		value: '122110 - Diretor de produção e operações em empresa aqüícola',
		label: '122110 - Diretor de produção e operações em empresa aqüícola',
	},
	{
		value: '122205 - Diretor de produção e operações da indústria de transformação, extração mineral e utilidades',
		label: '122205 - Diretor de produção e operações da indústria de transformação, extração mineral e utilidades',
	},
	{
		value: '122305 - Diretor de operações de obras pública e civil',
		label: '122305 - Diretor de operações de obras pública e civil',
	},
	{
		value: '122405 - Diretor de operações comerciais (comércio atacadista e varejista)',
		label: '122405 - Diretor de operações comerciais (comércio atacadista e varejista)',
	},
	{
		value: '122515 - Diretor de  produção e operações de turismo',
		label: '122515 - Diretor de  produção e operações de turismo',
	},
	{ value: '122520 - Turismólogo', label: '122520 - Turismólogo' },
	{
		value: '122505 - Diretor de  produção e operações de alimentação',
		label: '122505 - Diretor de  produção e operações de alimentação',
	},
	{
		value: '122510 - Diretor de  produção e operações de hotel',
		label: '122510 - Diretor de  produção e operações de hotel',
	},
	{
		value: '122620 - Diretor de operações de serviços de transporte',
		label: '122620 - Diretor de operações de serviços de transporte',
	},
	{
		value: '122615 - Diretor de operações de serviços de telecomunicações',
		label: '122615 - Diretor de operações de serviços de telecomunicações',
	},
	{
		value: '122605 - Diretor de operações de correios',
		label: '122605 - Diretor de operações de correios',
	},
	{
		value: '122610 - Diretor de operações de serviços de armazenamento',
		label: '122610 - Diretor de operações de serviços de armazenamento',
	},
	{
		value: '122705 - Diretor comercial em operações de intermediação financeira',
		label: '122705 - Diretor comercial em operações de intermediação financeira',
	},
	{
		value: '122710 - Diretor de produtos bancários',
		label: '122710 - Diretor de produtos bancários',
	},
	{
		value: '122715 - Diretor de crédito rural',
		label: '122715 - Diretor de crédito rural',
	},
	{
		value: '122720 - Diretor de câmbio e comércio exterior',
		label: '122720 - Diretor de câmbio e comércio exterior',
	},
	{
		value: '122725 - Diretor de compliance',
		label: '122725 - Diretor de compliance',
	},
	{
		value: '122730 - Diretor de crédito (exceto crédito imobiliário)',
		label: '122730 - Diretor de crédito (exceto crédito imobiliário)',
	},
	{
		value: '122735 - Diretor de crédito imobiliário',
		label: '122735 - Diretor de crédito imobiliário',
	},
	{
		value: '122740 - Diretor de leasing',
		label: '122740 - Diretor de leasing',
	},
	{
		value: '122745 - Diretor de mercado de capitais',
		label: '122745 - Diretor de mercado de capitais',
	},
	{
		value: '122750 - Diretor de recuperação de créditos em operações de intermediação financeira',
		label: '122750 - Diretor de recuperação de créditos em operações de intermediação financeira',
	},
	{
		value: '122755 - Diretor de riscos de mercado',
		label: '122755 - Diretor de riscos de mercado',
	},
	{
		value: '123105 - Diretor administrativo',
		label: '123105 - Diretor administrativo',
	},
	{
		value: '123110 - Diretor administrativo e financeiro',
		label: '123110 - Diretor administrativo e financeiro',
	},
	{
		value: '123115 - Diretor financeiro',
		label: '123115 - Diretor financeiro',
	},
	{
		value: '123205 - Diretor de recursos humanos',
		label: '123205 - Diretor de recursos humanos',
	},
	{
		value: '123210 - Diretor de relações de trabalho',
		label: '123210 - Diretor de relações de trabalho',
	},
	{
		value: '123305 - Diretor comercial',
		label: '123305 - Diretor comercial',
	},
	{
		value: '123310 - Diretor de marketing',
		label: '123310 - Diretor de marketing',
	},
	{
		value: '123405 - Diretor de suprimentos',
		label: '123405 - Diretor de suprimentos',
	},
	{
		value: '123410 - Diretor de suprimentos no serviço público',
		label: '123410 - Diretor de suprimentos no serviço público',
	},
	{
		value: '123605 - Diretor de serviços de informática',
		label: '123605 - Diretor de serviços de informática',
	},
	{
		value: '123705 - Diretor de pesquisa e desenvolvimento (p&d)',
		label: '123705 - Diretor de pesquisa e desenvolvimento (p&d)',
	},
	{
		value: '123805 - Diretor de manutenção',
		label: '123805 - Diretor de manutenção',
	},
	{
		value: '131105 - Diretor de serviços culturais',
		label: '131105 - Diretor de serviços culturais',
	},
	{
		value: '131120 - Gerente de serviços sociais',
		label: '131120 - Gerente de serviços sociais',
	},
	{
		value: '131115 - Gerente de serviços culturais',
		label: '131115 - Gerente de serviços culturais',
	},
	{
		value: '131110 - Diretor de serviços sociais',
		label: '131110 - Diretor de serviços sociais',
	},
	{
		value: '131205 - Diretor de serviços de saúde',
		label: '131205 - Diretor de serviços de saúde',
	},
	{
		value: '131210 - Gerente de serviços de saúde',
		label: '131210 - Gerente de serviços de saúde',
	},
	{
		value: '131215 - Tecnólogo em gestão hospitalar',
		label: '131215 - Tecnólogo em gestão hospitalar',
	},
	{ value: '131225 - Sanitarista', label: '131225 - Sanitarista' },
	{ value: '131220 - Gerontólogo', label: '131220 - Gerontólogo' },
	{
		value: '131320 - Gerente de serviços educacionais da área pública',
		label: '131320 - Gerente de serviços educacionais da área pública',
	},
	{
		value: '131310 - Diretor de instituição educacional pública',
		label: '131310 - Diretor de instituição educacional pública',
	},
	{
		value: '131315 - Gerente de instituição educacional da área privada',
		label: '131315 - Gerente de instituição educacional da área privada',
	},
	{
		value: '131305 - Diretor de instituição educacional da área privada',
		label: '131305 - Diretor de instituição educacional da área privada',
	},
	{
		value: '141105 - Gerente de produção e operações  aqüícolas',
		label: '141105 - Gerente de produção e operações  aqüícolas',
	},
	{
		value: '141120 - Gerente de produção e operações pesqueiras',
		label: '141120 - Gerente de produção e operações pesqueiras',
	},
	{
		value: '141115 - Gerente de produção e operações agropecuárias',
		label: '141115 - Gerente de produção e operações agropecuárias',
	},
	{
		value: '141110 - Gerente de produção e operações  florestais',
		label: '141110 - Gerente de produção e operações  florestais',
	},
	{
		value: '141205 - Gerente de produção e operações',
		label: '141205 - Gerente de produção e operações',
	},
	{
		value: '141305 - Gerente de produção e operações da construção civil e obras públicas',
		label: '141305 - Gerente de produção e operações da construção civil e obras públicas',
	},
	{
		value: '141405 - Comerciante atacadista',
		label: '141405 - Comerciante atacadista',
	},
	{
		value: '141410 - Comerciante varejista',
		label: '141410 - Comerciante varejista',
	},
	{
		value: '141415 - Gerente de loja e supermercado',
		label: '141415 - Gerente de loja e supermercado',
	},
	{
		value: '141420 - Gerente de operações de serviços de assistência técnica',
		label: '141420 - Gerente de operações de serviços de assistência técnica',
	},
	{ value: '141505 - Gerente de hotel', label: '141505 - Gerente de hotel' },
	{
		value: '141525 - Gerente de turismo',
		label: '141525 - Gerente de turismo',
	},
	{
		value: '141510 - Gerente de restaurante',
		label: '141510 - Gerente de restaurante',
	},
	{
		value: '141520 - Gerente de pensão',
		label: '141520 - Gerente de pensão',
	},
	{ value: '141515 - Gerente de bar', label: '141515 - Gerente de bar' },
	{
		value: '141615 - Gerente de logística (armazenagem e distribuição)',
		label: '141615 - Gerente de logística (armazenagem e distribuição)',
	},
	{
		value: '141605 - Gerente de operações de transportes',
		label: '141605 - Gerente de operações de transportes',
	},
	{
		value: '141610 - Gerente de operações de correios e telecomunicações',
		label: '141610 - Gerente de operações de correios e telecomunicações',
	},
	{
		value: '141720 - Gerente de crédito e cobrança',
		label: '141720 - Gerente de crédito e cobrança',
	},
	{
		value: '141705 - Gerente de produtos bancários',
		label: '141705 - Gerente de produtos bancários',
	},
	{
		value: '141710 - Gerente de agência',
		label: '141710 - Gerente de agência',
	},
	{
		value: '141735 - Gerente de recuperação de crédito',
		label: '141735 - Gerente de recuperação de crédito',
	},
	{
		value: '141730 - Gerente de crédito rural',
		label: '141730 - Gerente de crédito rural',
	},
	{
		value: '141725 - Gerente de crédito imobiliário',
		label: '141725 - Gerente de crédito imobiliário',
	},
	{
		value: '141715 - Gerente de câmbio e comércio exterior',
		label: '141715 - Gerente de câmbio e comércio exterior',
	},
	{
		value: '142110 - Gerente de riscos',
		label: '142110 - Gerente de riscos',
	},
	{
		value: '142120 - Tecnólogo em gestão administrativo- financeira',
		label: '142120 - Tecnólogo em gestão administrativo- financeira',
	},
	{
		value: '142105 - Gerente administrativo',
		label: '142105 - Gerente administrativo',
	},
	{
		value: '142115 - Gerente financeiro',
		label: '142115 - Gerente financeiro',
	},
	{
		value: '142205 - Gerente de recursos humanos',
		label: '142205 - Gerente de recursos humanos',
	},
	{
		value: '142210 - Gerente de departamento pessoal',
		label: '142210 - Gerente de departamento pessoal',
	},
	{
		value: '142330 - Analista de negócios',
		label: '142330 - Analista de negócios',
	},
	{
		value: '142325 - Relações públicas',
		label: '142325 - Relações públicas',
	},
	{ value: '142340 - Ouvidor', label: '142340 - Ouvidor' },
	{
		value: '142335 - Analista de pesquisa de mercado',
		label: '142335 - Analista de pesquisa de mercado',
	},
	{
		value: '142320 - Gerente de vendas',
		label: '142320 - Gerente de vendas',
	},
	{
		value: '142315 - Gerente de marketing',
		label: '142315 - Gerente de marketing',
	},
	{
		value: '142310 - Gerente de comunicação',
		label: '142310 - Gerente de comunicação',
	},
	{
		value: '142305 - Gerente comercial',
		label: '142305 - Gerente comercial',
	},
	{
		value: '142415 - Gerente de almoxarifado',
		label: '142415 - Gerente de almoxarifado',
	},
	{
		value: '142405 - Gerente de compras',
		label: '142405 - Gerente de compras',
	},
	{
		value: '142410 - Gerente de suprimentos',
		label: '142410 - Gerente de suprimentos',
	},
	{
		value: '142530 - Gerente de suporte técnico de tecnologia da informação',
		label: '142530 - Gerente de suporte técnico de tecnologia da informação',
	},
	{ value: '142505 - Gerente de rede', label: '142505 - Gerente de rede' },
	{
		value: '142520 - Gerente de projetos de tecnologia da informação',
		label: '142520 - Gerente de projetos de tecnologia da informação',
	},
	{
		value: '142515 - Gerente de produção de tecnologia da informação',
		label: '142515 - Gerente de produção de tecnologia da informação',
	},
	{
		value: '142535 - Tecnólogo em gestão da tecnologia da informação',
		label: '142535 - Tecnólogo em gestão da tecnologia da informação',
	},
	{
		value: '142525 - Gerente de segurança de tecnologia da informação',
		label: '142525 - Gerente de segurança de tecnologia da informação',
	},
	{
		value: '142510 - Gerente de desenvolvimento de sistemas',
		label: '142510 - Gerente de desenvolvimento de sistemas',
	},
	{
		value: '142605 - Gerente de pesquisa e desenvolvimento (p&d)',
		label: '142605 - Gerente de pesquisa e desenvolvimento (p&d)',
	},
	{
		value: '142610 - Especialista em desenvolvimento de cigarros',
		label: '142610 - Especialista em desenvolvimento de cigarros',
	},
	{
		value: '142710 - Tecnólogo em sistemas biomédicos',
		label: '142710 - Tecnólogo em sistemas biomédicos',
	},
	{
		value: '142705 - Gerente de projetos e serviços de manutenção',
		label: '142705 - Gerente de projetos e serviços de manutenção',
	},
	{ value: '201105 - Bioengenheiro', label: '201105 - Bioengenheiro' },
	{ value: '201110 - Biotecnologista', label: '201110 - Biotecnologista' },
	{ value: '201115 - Geneticista', label: '201115 - Geneticista' },
	{
		value: '201220 - Especialista em instrumentação metrológica',
		label: '201220 - Especialista em instrumentação metrológica',
	},
	{
		value: '201215 - Especialista em ensaios metrológicos',
		label: '201215 - Especialista em ensaios metrológicos',
	},
	{
		value: '201210 - Especialista em calibrações metrológicas',
		label: '201210 - Especialista em calibrações metrológicas',
	},
	{
		value: '201225 - Especialista em materiais de referência metrológica',
		label: '201225 - Especialista em materiais de referência metrológica',
	},
	{
		value: '201205 - Pesquisador em metrologia',
		label: '201205 - Pesquisador em metrologia',
	},
	{
		value: '202115 - Tecnólogo em mecatrônica',
		label: '202115 - Tecnólogo em mecatrônica',
	},
	{
		value: '202120 - Tecnólogo em automação industrial',
		label: '202120 - Tecnólogo em automação industrial',
	},
	{
		value: '202110 - Engenheiro de controle e automação',
		label: '202110 - Engenheiro de controle e automação',
	},
	{
		value: '202105 - Engenheiro mecatrônico',
		label: '202105 - Engenheiro mecatrônico',
	},
	{
		value: '203005 - Pesquisador em biologia ambiental',
		label: '203005 - Pesquisador em biologia ambiental',
	},
	{
		value: '203010 - Pesquisador em biologia animal',
		label: '203010 - Pesquisador em biologia animal',
	},
	{
		value: '203015 - Pesquisador em biologia de microorganismos e parasitas',
		label: '203015 - Pesquisador em biologia de microorganismos e parasitas',
	},
	{
		value: '203020 - Pesquisador em biologia humana',
		label: '203020 - Pesquisador em biologia humana',
	},
	{
		value: '203025 - Pesquisador em biologia vegetal',
		label: '203025 - Pesquisador em biologia vegetal',
	},
	{
		value: '203115 - Pesquisador em física',
		label: '203115 - Pesquisador em física',
	},
	{
		value: '203110 - Pesquisador em ciências da terra e meio ambiente',
		label: '203110 - Pesquisador em ciências da terra e meio ambiente',
	},
	{
		value: '203105 - Pesquisador em ciências da computação e informática',
		label: '203105 - Pesquisador em ciências da computação e informática',
	},
	{
		value: '203120 - Pesquisador em matemática',
		label: '203120 - Pesquisador em matemática',
	},
	{
		value: '203125 - Pesquisador em química',
		label: '203125 - Pesquisador em química',
	},
	{
		value: '203215 - Pesquisador de engenharia elétrica e eletrônica',
		label: '203215 - Pesquisador de engenharia elétrica e eletrônica',
	},
	{
		value: '203210 - Pesquisador de engenharia e tecnologia (outras áreas da engenharia)',
		label: '203210 - Pesquisador de engenharia e tecnologia (outras áreas da engenharia)',
	},
	{
		value: '203205 - Pesquisador de engenharia civil',
		label: '203205 - Pesquisador de engenharia civil',
	},
	{
		value: '203220 - Pesquisador de engenharia mecânica',
		label: '203220 - Pesquisador de engenharia mecânica',
	},
	{
		value: '203225 - Pesquisador de engenharia metalúrgica, de minas e de materiais',
		label: '203225 - Pesquisador de engenharia metalúrgica, de minas e de materiais',
	},
	{
		value: '203230 - Pesquisador de engenharia química',
		label: '203230 - Pesquisador de engenharia química',
	},
	{
		value: '203315 - Pesquisador em medicina veterinária',
		label: '203315 - Pesquisador em medicina veterinária',
	},
	{
		value: '203310 - Pesquisador de medicina básica',
		label: '203310 - Pesquisador de medicina básica',
	},
	{
		value: '203305 - Pesquisador de clínica médica',
		label: '203305 - Pesquisador de clínica médica',
	},
	{
		value: '203320 - Pesquisador em saúde coletiva',
		label: '203320 - Pesquisador em saúde coletiva',
	},
	{
		value: '203405 - Pesquisador em ciências agronômicas',
		label: '203405 - Pesquisador em ciências agronômicas',
	},
	{
		value: '203410 - Pesquisador em ciências da pesca e aqüicultura',
		label: '203410 - Pesquisador em ciências da pesca e aqüicultura',
	},
	{
		value: '203415 - Pesquisador em ciências da zootecnia',
		label: '203415 - Pesquisador em ciências da zootecnia',
	},
	{
		value: '203420 - Pesquisador em ciências florestais',
		label: '203420 - Pesquisador em ciências florestais',
	},
	{
		value: '203505 - Pesquisador em ciências sociais e humanas',
		label: '203505 - Pesquisador em ciências sociais e humanas',
	},
	{
		value: '203510 - Pesquisador em economia',
		label: '203510 - Pesquisador em economia',
	},
	{
		value: '203515 - Pesquisador em ciências da educação',
		label: '203515 - Pesquisador em ciências da educação',
	},
	{
		value: '203520 - Pesquisador em história',
		label: '203520 - Pesquisador em história',
	},
	{
		value: '203525 - Pesquisador em psicologia',
		label: '203525 - Pesquisador em psicologia',
	},
	{ value: '204105 - Perito criminal', label: '204105 - Perito criminal' },
	{
		value: '211120 - Matemático aplicado',
		label: '211120 - Matemático aplicado',
	},
	{ value: '211105 - Atuário', label: '211105 - Atuário' },
	{
		value: '211110 - Especialista em pesquisa operacional',
		label: '211110 - Especialista em pesquisa operacional',
	},
	{ value: '211115 - Matemático', label: '211115 - Matemático' },
	{
		value: '211215 - Estatístico teórico',
		label: '211215 - Estatístico teórico',
	},
	{ value: '211205 - Estatístico', label: '211205 - Estatístico' },
	{
		value: '211210 - Estatístico (estatística aplicada)',
		label: '211210 - Estatístico (estatística aplicada)',
	},
	{
		value: '212210 - Engenheiro de equipamentos em computação',
		label: '212210 - Engenheiro de equipamentos em computação',
	},
	{
		value: '212205 - Engenheiro de aplicativos em computação',
		label: '212205 - Engenheiro de aplicativos em computação',
	},
	{
		value: '212215 - Engenheiros de sistemas operacionais em computação',
		label: '212215 - Engenheiros de sistemas operacionais em computação',
	},
	{
		value: '212320 - Administrador em segurança da informação',
		label: '212320 - Administrador em segurança da informação',
	},
	{
		value: '212310 - Administrador de redes',
		label: '212310 - Administrador de redes',
	},
	{
		value: '212305 - Administrador de banco de dados',
		label: '212305 - Administrador de banco de dados',
	},
	{
		value: '212315 - Administrador de sistemas operacionais',
		label: '212315 - Administrador de sistemas operacionais',
	},
	{
		value: '212415 - Analista de sistemas de automação',
		label: '212415 - Analista de sistemas de automação',
	},
	{
		value: '212420 - Analista de suporte computacional',
		label: '212420 - Analista de suporte computacional',
	},
	{
		value: '212410 - Analista de redes e de comunicação de dados',
		label: '212410 - Analista de redes e de comunicação de dados',
	},
	{
		value: '212405 - Analista de desenvolvimento de sistemas',
		label: '212405 - Analista de desenvolvimento de sistemas',
	},
	{
		value: '213110 - Físico (acústica)',
		label: '213110 - Físico (acústica)',
	},
	{ value: '213170 - Físico (plasma)', label: '213170 - Físico (plasma)' },
	{ value: '213175 - Físico (térmica)', label: '213175 - Físico (térmica)' },
	{
		value: '213165 - Físico (partículas e campos)',
		label: '213165 - Físico (partículas e campos)',
	},
	{ value: '213160 - Físico (óptica)', label: '213160 - Físico (óptica)' },
	{
		value: '213155 - Físico (nuclear e reatores)',
		label: '213155 - Físico (nuclear e reatores)',
	},
	{
		value: '213150 - Físico (medicina)',
		label: '213150 - Físico (medicina)',
	},
	{
		value: '213145 - Físico (materiais)',
		label: '213145 - Físico (materiais)',
	},
	{
		value: '213125 - Físico (estatística e matemática)',
		label: '213125 - Físico (estatística e matemática)',
	},
	{
		value: '213140 - Físico (matéria condensada)',
		label: '213140 - Físico (matéria condensada)',
	},
	{ value: '213105 - Físico', label: '213105 - Físico' },
	{
		value: '213115 - Físico (atômica e molecular)',
		label: '213115 - Físico (atômica e molecular)',
	},
	{
		value: '213120 - Físico (cosmologia)',
		label: '213120 - Físico (cosmologia)',
	},
	{ value: '213130 - Físico (fluidos)', label: '213130 - Físico (fluidos)' },
	{
		value: '213135 - Físico (instrumentação)',
		label: '213135 - Físico (instrumentação)',
	},
	{
		value: '213215 - Tecnólogo em processos químicos',
		label: '213215 - Tecnólogo em processos químicos',
	},
	{
		value: '213210 - Químico industrial',
		label: '213210 - Químico industrial',
	},
	{ value: '213205 - Químico', label: '213205 - Químico' },
	{ value: '213305 - Astrônomo', label: '213305 - Astrônomo' },
	{ value: '213315 - Meteorologista', label: '213315 - Meteorologista' },
	{
		value: '213310 - Geofísico espacial',
		label: '213310 - Geofísico espacial',
	},
	{ value: '213440 - Oceanógrafo', label: '213440 - Oceanógrafo' },
	{ value: '213425 - Hidrogeólogo', label: '213425 - Hidrogeólogo' },
	{ value: '213420 - Geoquímico', label: '213420 - Geoquímico' },
	{ value: '213415 - Geofísico', label: '213415 - Geofísico' },
	{
		value: '213410 - Geólogo de engenharia',
		label: '213410 - Geólogo de engenharia',
	},
	{ value: '213435 - Petrógrafo', label: '213435 - Petrógrafo' },
	{ value: '213430 - Paleontólogo', label: '213430 - Paleontólogo' },
	{ value: '213405 - Geólogo', label: '213405 - Geólogo' },
	{
		value: '214010 - Tecnólogo em meio ambiente',
		label: '214010 - Tecnólogo em meio ambiente',
	},
	{
		value: '214005 - Engenheiro ambiental',
		label: '214005 - Engenheiro ambiental',
	},
	{
		value: '214105 - Arquiteto de edificações',
		label: '214105 - Arquiteto de edificações',
	},
	{
		value: '214120 - Arquiteto paisagista',
		label: '214120 - Arquiteto paisagista',
	},
	{
		value: '214115 - Arquiteto de patrimônio',
		label: '214115 - Arquiteto de patrimônio',
	},
	{
		value: '214110 - Arquiteto de interiores',
		label: '214110 - Arquiteto de interiores',
	},
	{ value: '214130 - Urbanista', label: '214130 - Urbanista' },
	{
		value: '214125 - Arquiteto urbanista',
		label: '214125 - Arquiteto urbanista',
	},
	{ value: '214205 - Engenheiro civil', label: '214205 - Engenheiro civil' },
	{
		value: '214210 - Engenheiro civil (aeroportos)',
		label: '214210 - Engenheiro civil (aeroportos)',
	},
	{
		value: '214215 - Engenheiro civil (edificações)',
		label: '214215 - Engenheiro civil (edificações)',
	},
	{
		value: '214220 - Engenheiro civil (estruturas metálicas)',
		label: '214220 - Engenheiro civil (estruturas metálicas)',
	},
	{
		value: '214225 - Engenheiro civil (ferrovias e metrovias)',
		label: '214225 - Engenheiro civil (ferrovias e metrovias)',
	},
	{
		value: '214230 - Engenheiro civil (geotécnia)',
		label: '214230 - Engenheiro civil (geotécnia)',
	},
	{
		value: '214235 - Engenheiro civil (hidrologia)',
		label: '214235 - Engenheiro civil (hidrologia)',
	},
	{
		value: '214240 - Engenheiro civil (hidráulica)',
		label: '214240 - Engenheiro civil (hidráulica)',
	},
	{
		value: '214245 - Engenheiro civil (pontes e viadutos)',
		label: '214245 - Engenheiro civil (pontes e viadutos)',
	},
	{
		value: '214250 - Engenheiro civil (portos e vias navegáveis)',
		label: '214250 - Engenheiro civil (portos e vias navegáveis)',
	},
	{
		value: '214255 - Engenheiro civil (rodovias)',
		label: '214255 - Engenheiro civil (rodovias)',
	},
	{
		value: '214260 - Engenheiro civil (saneamento)',
		label: '214260 - Engenheiro civil (saneamento)',
	},
	{
		value: '214265 - Engenheiro civil (túneis)',
		label: '214265 - Engenheiro civil (túneis)',
	},
	{
		value: '214270 - Engenheiro civil (transportes e trânsito)',
		label: '214270 - Engenheiro civil (transportes e trânsito)',
	},
	{
		value: '214280 - Tecnólogo em construção civil',
		label: '214280 - Tecnólogo em construção civil',
	},
	{
		value: '214330 - Engenheiro eletrônico de projetos',
		label: '214330 - Engenheiro eletrônico de projetos',
	},
	{
		value: '214315 - Engenheiro eletricista de manutenção',
		label: '214315 - Engenheiro eletricista de manutenção',
	},
	{
		value: '214320 - Engenheiro eletricista de projetos',
		label: '214320 - Engenheiro eletricista de projetos',
	},
	{
		value: '214325 - Engenheiro eletrônico de manutenção',
		label: '214325 - Engenheiro eletrônico de manutenção',
	},
	{
		value: '214335 - Engenheiro de manutenção de telecomunicações',
		label: '214335 - Engenheiro de manutenção de telecomunicações',
	},
	{
		value: '214340 - Engenheiro de telecomunicações',
		label: '214340 - Engenheiro de telecomunicações',
	},
	{
		value: '214345 - Engenheiro projetista de telecomunicações',
		label: '214345 - Engenheiro projetista de telecomunicações',
	},
	{
		value: '214350 - Engenheiro de redes de comunicação',
		label: '214350 - Engenheiro de redes de comunicação',
	},
	{
		value: '214360 - Tecnólogo em eletricidade',
		label: '214360 - Tecnólogo em eletricidade',
	},
	{
		value: '214365 - Tecnólogo em eletrônica',
		label: '214365 - Tecnólogo em eletrônica',
	},
	{
		value: '214310 - Engenheiro eletrônico',
		label: '214310 - Engenheiro eletrônico',
	},
	{
		value: '214305 - Engenheiro eletricista',
		label: '214305 - Engenheiro eletricista',
	},
	{
		value: '214370 - Tecnólogo em telecomunicações',
		label: '214370 - Tecnólogo em telecomunicações',
	},
	{
		value: '214425 - Engenheiro aeronáutico',
		label: '214425 - Engenheiro aeronáutico',
	},
	{
		value: '214420 - Engenheiro mecânico industrial',
		label: '214420 - Engenheiro mecânico industrial',
	},
	{
		value: '214415 - Engenheiro mecânico (energia nuclear)',
		label: '214415 - Engenheiro mecânico (energia nuclear)',
	},
	{
		value: '214410 - Engenheiro mecânico automotivo',
		label: '214410 - Engenheiro mecânico automotivo',
	},
	{
		value: '214405 - Engenheiro mecânico',
		label: '214405 - Engenheiro mecânico',
	},
	{ value: '214430 - Engenheiro naval', label: '214430 - Engenheiro naval' },
	{
		value: '214435 - Tecnólogo em fabricação mecânica',
		label: '214435 - Tecnólogo em fabricação mecânica',
	},
	{
		value: '214535 - Tecnólogo em produção sulcroalcooleira',
		label: '214535 - Tecnólogo em produção sulcroalcooleira',
	},
	{
		value: '214520 - Engenheiro químico (papel e celulose)',
		label: '214520 - Engenheiro químico (papel e celulose)',
	},
	{
		value: '214525 - Engenheiro químico (petróleo e borracha)',
		label: '214525 - Engenheiro químico (petróleo e borracha)',
	},
	{
		value: '214530 - Engenheiro químico (utilidades e meio ambiente)',
		label: '214530 - Engenheiro químico (utilidades e meio ambiente)',
	},
	{
		value: '214515 - Engenheiro químico (mineração, metalurgia, siderurgia, cimenteira e cerâmica)',
		label: '214515 - Engenheiro químico (mineração, metalurgia, siderurgia, cimenteira e cerâmica)',
	},
	{
		value: '214510 - Engenheiro químico (indústria química)',
		label: '214510 - Engenheiro químico (indústria química)',
	},
	{
		value: '214505 - Engenheiro químico',
		label: '214505 - Engenheiro químico',
	},
	{
		value: '214605 - Engenheiro de materiais',
		label: '214605 - Engenheiro de materiais',
	},
	{
		value: '214615 - Tecnólogo em metalurgia',
		label: '214615 - Tecnólogo em metalurgia',
	},
	{
		value: '214610 - Engenheiro metalurgista',
		label: '214610 - Engenheiro metalurgista',
	},
	{
		value: '214730 - Engenheiro de minas (planejamento)',
		label: '214730 - Engenheiro de minas (planejamento)',
	},
	{
		value: '214735 - Engenheiro de minas (processo)',
		label: '214735 - Engenheiro de minas (processo)',
	},
	{
		value: '214750 - Tecnólogo em rochas ornamentais',
		label: '214750 - Tecnólogo em rochas ornamentais',
	},
	{
		value: '214745 - Tecnólogo em petróleo e gás',
		label: '214745 - Tecnólogo em petróleo e gás',
	},
	{
		value: '214740 - Engenheiro de minas (projeto)',
		label: '214740 - Engenheiro de minas (projeto)',
	},
	{
		value: '214705 - Engenheiro de minas',
		label: '214705 - Engenheiro de minas',
	},
	{
		value: '214710 - Engenheiro de minas (beneficiamento)',
		label: '214710 - Engenheiro de minas (beneficiamento)',
	},
	{
		value: '214715 - Engenheiro de minas (lavra a céu aberto)',
		label: '214715 - Engenheiro de minas (lavra a céu aberto)',
	},
	{
		value: '214720 - Engenheiro de minas (lavra subterrânea)',
		label: '214720 - Engenheiro de minas (lavra subterrânea)',
	},
	{
		value: '214725 - Engenheiro de minas (pesquisa mineral)',
		label: '214725 - Engenheiro de minas (pesquisa mineral)',
	},
	{
		value: '214810 - Engenheiro cartógrafo',
		label: '214810 - Engenheiro cartógrafo',
	},
	{
		value: '214805 - Engenheiro agrimensor',
		label: '214805 - Engenheiro agrimensor',
	},
	{
		value: '214935 - Tecnólogo em segurança do trabalho',
		label: '214935 - Tecnólogo em segurança do trabalho',
	},
	{
		value: '214930 - Tecnólogo em produção industrial',
		label: '214930 - Tecnólogo em produção industrial',
	},
	{
		value: '214925 - Engenheiro de tempos e movimentos',
		label: '214925 - Engenheiro de tempos e movimentos',
	},
	{
		value: '214905 - Engenheiro de produção',
		label: '214905 - Engenheiro de produção',
	},
	{
		value: '214910 - Engenheiro de controle de qualidade',
		label: '214910 - Engenheiro de controle de qualidade',
	},
	{
		value: '214940 - Higienista ocupacional',
		label: '214940 - Higienista ocupacional',
	},
	{
		value: '214920 - Engenheiro de riscos',
		label: '214920 - Engenheiro de riscos',
	},
	{
		value: '214915 - Engenheiro de segurança do trabalho',
		label: '214915 - Engenheiro de segurança do trabalho',
	},
	{
		value: '215105 - Agente de manobra e docagem',
		label: '215105 - Agente de manobra e docagem',
	},
	{
		value: '215110 - Capitão de manobra da marinha mercante',
		label: '215110 - Capitão de manobra da marinha mercante',
	},
	{
		value: '215150 - Vistoriador naval',
		label: '215150 - Vistoriador naval',
	},
	{
		value: '215145 - Prático de portos da marinha mercante',
		label: '215145 - Prático de portos da marinha mercante',
	},
	{
		value: '215140 - Oficial de quarto de navegação da marinha mercante',
		label: '215140 - Oficial de quarto de navegação da marinha mercante',
	},
	{ value: '215135 - Inspetor naval', label: '215135 - Inspetor naval' },
	{
		value: '215130 - Inspetor de terminal',
		label: '215130 - Inspetor de terminal',
	},
	{
		value: '215125 - Imediato da marinha mercante',
		label: '215125 - Imediato da marinha mercante',
	},
	{
		value: '215115 - Comandante da marinha mercante',
		label: '215115 - Comandante da marinha mercante',
	},
	{
		value: '215120 - Coordenador de operações de combate à poluição no meio aquaviário',
		label: '215120 - Coordenador de operações de combate à poluição no meio aquaviário',
	},
	{
		value: '215220 - Superintendente técnico no transporte aquaviário',
		label: '215220 - Superintendente técnico no transporte aquaviário',
	},
	{
		value: '215215 - Segundo oficial de máquinas da marinha mercante',
		label: '215215 - Segundo oficial de máquinas da marinha mercante',
	},
	{
		value: '215210 - Primeiro oficial de máquinas da marinha mercante',
		label: '215210 - Primeiro oficial de máquinas da marinha mercante',
	},
	{
		value: '215205 - Oficial superior de máquinas da marinha mercante',
		label: '215205 - Oficial superior de máquinas da marinha mercante',
	},
	{
		value: '215310 - Piloto de ensaios em vôo',
		label: '215310 - Piloto de ensaios em vôo',
	},
	{
		value: '215305 - Piloto de aeronaves',
		label: '215305 - Piloto de aeronaves',
	},
	{ value: '215315 - Instrutor de vôo', label: '215315 - Instrutor de vôo' },
	{ value: '221105 - Biólogo', label: '221105 - Biólogo' },
	{ value: '221205 - Biomédico', label: '221205 - Biomédico' },
	{
		value: '222105 - Engenheiro agrícola',
		label: '222105 - Engenheiro agrícola',
	},
	{
		value: '222110 - Engenheiro agrônomo',
		label: '222110 - Engenheiro agrônomo',
	},
	{
		value: '222115 - Engenheiro de pesca',
		label: '222115 - Engenheiro de pesca',
	},
	{
		value: '222120 - Engenheiro florestal',
		label: '222120 - Engenheiro florestal',
	},
	{
		value: '222205 - Engenheiro de alimentos',
		label: '222205 - Engenheiro de alimentos',
	},
	{
		value: '222215 - Tecnólogo em alimentos',
		label: '222215 - Tecnólogo em alimentos',
	},
	{
		value: '223264 - Cirurgião dentista - reabilitador oral',
		label: '223264 - Cirurgião dentista - reabilitador oral',
	},
	{
		value: '223268 - Cirurgião dentista - traumatologista bucomaxilofacial',
		label: '223268 - Cirurgião dentista - traumatologista bucomaxilofacial',
	},
	{
		value: '223272 - Cirurgião dentista de saúde coletiva',
		label: '223272 - Cirurgião dentista de saúde coletiva',
	},
	{
		value: '223276 - Cirurgião dentista - odontologia do trabalho',
		label: '223276 - Cirurgião dentista - odontologia do trabalho',
	},
	{
		value: '223280 - Cirurgião dentista - dentística',
		label: '223280 - Cirurgião dentista - dentística',
	},
	{
		value: '223284 - Cirurgião dentista - disfunção temporomandibular e dor orofacial',
		label: '223284 - Cirurgião dentista - disfunção temporomandibular e dor orofacial',
	},
	{
		value: '223288 - Cirurgião dentista - odontologia para pacientes com necessidades especiais',
		label: '223288 - Cirurgião dentista - odontologia para pacientes com necessidades especiais',
	},
	{
		value: '223293 - Cirurgião-dentista da estratégia de saúde da família',
		label: '223293 - Cirurgião-dentista da estratégia de saúde da família',
	},
	{
		value: '223260 - Cirurgião dentista - radiologista',
		label: '223260 - Cirurgião dentista - radiologista',
	},
	{
		value: '223256 - Cirurgião dentista - protesista',
		label: '223256 - Cirurgião dentista - protesista',
	},
	{
		value: '223252 - Cirurgião dentista - protesiólogo bucomaxilofacial',
		label: '223252 - Cirurgião dentista - protesiólogo bucomaxilofacial',
	},
	{
		value: '223248 - Cirurgião dentista - periodontista',
		label: '223248 - Cirurgião dentista - periodontista',
	},
	{
		value: '223244 - Cirurgião dentista - patologista bucal',
		label: '223244 - Cirurgião dentista - patologista bucal',
	},
	{
		value: '223240 - Cirurgião dentista - ortopedista e ortodontista',
		label: '223240 - Cirurgião dentista - ortopedista e ortodontista',
	},
	{
		value: '223236 - Cirurgião dentista - odontopediatra',
		label: '223236 - Cirurgião dentista - odontopediatra',
	},
	{
		value: '223228 - Cirurgião dentista - odontogeriatra',
		label: '223228 - Cirurgião dentista - odontogeriatra',
	},
	{
		value: '223232 - Cirurgião dentista - odontologista legal',
		label: '223232 - Cirurgião dentista - odontologista legal',
	},
	{
		value: '223224 - Cirurgião dentista - implantodontista',
		label: '223224 - Cirurgião dentista - implantodontista',
	},
	{
		value: '223220 - Cirurgião dentista - estomatologista',
		label: '223220 - Cirurgião dentista - estomatologista',
	},
	{
		value: '223216 - Cirurgião dentista - epidemiologista',
		label: '223216 - Cirurgião dentista - epidemiologista',
	},
	{
		value: '223212 - Cirurgião dentista - endodontista',
		label: '223212 - Cirurgião dentista - endodontista',
	},
	{
		value: '223208 - Cirurgião dentista - clínico geral',
		label: '223208 - Cirurgião dentista - clínico geral',
	},
	{
		value: '223204 - Cirurgião dentista - auditor',
		label: '223204 - Cirurgião dentista - auditor',
	},
	{
		value: '223305 - Médico veterinário',
		label: '223305 - Médico veterinário',
	},
	{ value: '223310 - Zootecnista', label: '223310 - Zootecnista' },
	{
		value: '223415 - Farmacêutico analista clínico',
		label: '223415 - Farmacêutico analista clínico',
	},
	{ value: '223405 - Farmacêutico', label: '223405 - Farmacêutico' },
	{
		value: '223440 - Farmacêutico toxicologista',
		label: '223440 - Farmacêutico toxicologista',
	},
	{
		value: '223435 - Farmacêutico industrial',
		label: '223435 - Farmacêutico industrial',
	},
	{
		value: '223445 - Farmacêutico hospitalar e clínico',
		label: '223445 - Farmacêutico hospitalar e clínico',
	},
	{
		value: '223425 - Farmacêutico práticas integrativas e complementares',
		label: '223425 - Farmacêutico práticas integrativas e complementares',
	},
	{
		value: '223430 - Farmacêutico em saúde pública',
		label: '223430 - Farmacêutico em saúde pública',
	},
	{
		value: '223420 - Farmacêutico de alimentos',
		label: '223420 - Farmacêutico de alimentos',
	},
	{
		value: '223555 - Enfermeiro puericultor e pediátrico',
		label: '223555 - Enfermeiro puericultor e pediátrico',
	},
	{
		value: '223560 - Enfermeiro sanitarista',
		label: '223560 - Enfermeiro sanitarista',
	},
	{
		value: '223565 - Enfermeiro da estratégia de saúde da família',
		label: '223565 - Enfermeiro da estratégia de saúde da família',
	},
	{
		value: '223550 - Enfermeiro psiquiátrico',
		label: '223550 - Enfermeiro psiquiátrico',
	},
	{
		value: '223545 - Enfermeiro obstétrico',
		label: '223545 - Enfermeiro obstétrico',
	},
	{
		value: '223540 - Enfermeiro neonatologista',
		label: '223540 - Enfermeiro neonatologista',
	},
	{
		value: '223535 - Enfermeiro nefrologista',
		label: '223535 - Enfermeiro nefrologista',
	},
	{
		value: '223530 - Enfermeiro do trabalho',
		label: '223530 - Enfermeiro do trabalho',
	},
	{
		value: '223525 - Enfermeiro de terapia intensiva',
		label: '223525 - Enfermeiro de terapia intensiva',
	},
	{
		value: '223520 - Enfermeiro de centro cirúrgico',
		label: '223520 - Enfermeiro de centro cirúrgico',
	},
	{ value: '223570 - Perfusionista', label: '223570 - Perfusionista' },
	{ value: '223505 - Enfermeiro', label: '223505 - Enfermeiro' },
	{
		value: '223515 - Enfermeiro de bordo',
		label: '223515 - Enfermeiro de bordo',
	},
	{
		value: '223510 - Enfermeiro auditor',
		label: '223510 - Enfermeiro auditor',
	},
	{
		value: '223655 - Fisioterapeuta esportivo',
		label: '223655 - Fisioterapeuta esportivo',
	},
	{
		value: '223660 - Fisioterapeuta  do trabalho',
		label: '223660 - Fisioterapeuta  do trabalho',
	},
	{
		value: '223645 - Fisioterapeuta quiropraxista',
		label: '223645 - Fisioterapeuta quiropraxista',
	},
	{
		value: '223640 - Fisioterapeuta osteopata',
		label: '223640 - Fisioterapeuta osteopata',
	},
	{
		value: '223635 - Fisioterapeuta traumato-ortopédica funcional',
		label: '223635 - Fisioterapeuta traumato-ortopédica funcional',
	},
	{
		value: '223630 - Fisioterapeuta neurofuncional',
		label: '223630 - Fisioterapeuta neurofuncional',
	},
	{
		value: '223650 - Fisioterapeuta acupunturista',
		label: '223650 - Fisioterapeuta acupunturista',
	},
	{
		value: '223625 - Fisioterapeuta respiratória',
		label: '223625 - Fisioterapeuta respiratória',
	},
	{
		value: '223605 - Fisioterapeuta geral',
		label: '223605 - Fisioterapeuta geral',
	},
	{ value: '223705 - Dietista', label: '223705 - Dietista' },
	{ value: '223710 - Nutricionista', label: '223710 - Nutricionista' },
	{
		value: '223810 - Fonoaudiólogo geral',
		label: '223810 - Fonoaudiólogo geral',
	},
	{
		value: '223825 - Fonoaudiólogo em disfagia',
		label: '223825 - Fonoaudiólogo em disfagia',
	},
	{
		value: '223830 - Fonoaudiólogo em linguagem',
		label: '223830 - Fonoaudiólogo em linguagem',
	},
	{
		value: '223835 - Fonoaudiólogo em motricidade orofacial',
		label: '223835 - Fonoaudiólogo em motricidade orofacial',
	},
	{
		value: '223820 - Fonoaudiólogo em audiologia',
		label: '223820 - Fonoaudiólogo em audiologia',
	},
	{
		value: '223845 - Fonoaudiólogo em voz',
		label: '223845 - Fonoaudiólogo em voz',
	},
	{
		value: '223840 - Fonoaudiólogo em saúde coletiva',
		label: '223840 - Fonoaudiólogo em saúde coletiva',
	},
	{
		value: '223815 - Fonoaudiólogo educacional',
		label: '223815 - Fonoaudiólogo educacional',
	},
	{ value: '223910 - Ortoptista', label: '223910 - Ortoptista' },
	{
		value: '223905 - Terapeuta ocupacional',
		label: '223905 - Terapeuta ocupacional',
	},
	{ value: '224110 - Ludomotricista', label: '224110 - Ludomotricista' },
	{
		value: '224115 - Preparador de atleta',
		label: '224115 - Preparador de atleta',
	},
	{
		value: '224120 - Preparador físico',
		label: '224120 - Preparador físico',
	},
	{ value: '224105 - Avaliador físico', label: '224105 - Avaliador físico' },
	{
		value: '224130 - Técnico de laboratório e fiscalização desportiva',
		label: '224130 - Técnico de laboratório e fiscalização desportiva',
	},
	{
		value: '224135 - Treinador profissional de futebol',
		label: '224135 - Treinador profissional de futebol',
	},
	{
		value: '224125 - Técnico de desporto individual e coletivo (exceto futebol)',
		label: '224125 - Técnico de desporto individual e coletivo (exceto futebol)',
	},
	{
		value: '225118 - Médico nutrologista',
		label: '225118 - Médico nutrologista',
	},
	{
		value: '225185 - Médico hematologista',
		label: '225185 - Médico hematologista',
	},
	{ value: '225180 - Médico geriatra', label: '225180 - Médico geriatra' },
	{
		value: '225175 - Médico geneticista',
		label: '225175 - Médico geneticista',
	},
	{
		value: '225170 - Médico generalista',
		label: '225170 - Médico generalista',
	},
	{
		value: '225165 - Médico gastroenterologista',
		label: '225165 - Médico gastroenterologista',
	},
	{ value: '225160 - Médico fisiatra', label: '225160 - Médico fisiatra' },
	{
		value: '225155 - Médico endocrinologista e metabologista',
		label: '225155 - Médico endocrinologista e metabologista',
	},
	{
		value: '225154 - Médico antroposófico',
		label: '225154 - Médico antroposófico',
	},
	{
		value: '225151 - Médico anestesiologista',
		label: '225151 - Médico anestesiologista',
	},
	{
		value: '225150 - Médico em medicina intensiva',
		label: '225150 - Médico em medicina intensiva',
	},
	{
		value: '225148 - Médico anatomopatologista',
		label: '225148 - Médico anatomopatologista',
	},
	{
		value: '225145 - Médico em medicina de tráfego',
		label: '225145 - Médico em medicina de tráfego',
	},
	{
		value: '225142 - Médico da estratégia de saúde da família',
		label: '225142 - Médico da estratégia de saúde da família',
	},
	{
		value: '225140 - Médico do trabalho',
		label: '225140 - Médico do trabalho',
	},
	{
		value: '225139 - Médico sanitarista',
		label: '225139 - Médico sanitarista',
	},
	{
		value: '225136 - Médico reumatologista',
		label: '225136 - Médico reumatologista',
	},
	{
		value: '225135 - Médico dermatologista',
		label: '225135 - Médico dermatologista',
	},
	{
		value: '225103 - Médico infectologista',
		label: '225103 - Médico infectologista',
	},
	{
		value: '225105 - Médico acupunturista',
		label: '225105 - Médico acupunturista',
	},
	{ value: '225106 - Médico legista', label: '225106 - Médico legista' },
	{
		value: '225109 - Médico nefrologista',
		label: '225109 - Médico nefrologista',
	},
	{
		value: '225110 - Médico alergista e imunologista',
		label: '225110 - Médico alergista e imunologista',
	},
	{
		value: '225112 - Médico neurologista',
		label: '225112 - Médico neurologista',
	},
	{
		value: '225115 - Médico angiologista',
		label: '225115 - Médico angiologista',
	},
	{ value: '225195 - Médico homeopata', label: '225195 - Médico homeopata' },
	{
		value: '225120 - Médico cardiologista',
		label: '225120 - Médico cardiologista',
	},
	{
		value: '225121 - Médico oncologista clínico',
		label: '225121 - Médico oncologista clínico',
	},
	{
		value: '225122 - Médico cancerologista pediátrico',
		label: '225122 - Médico cancerologista pediátrico',
	},
	{ value: '225124 - Médico pediatra', label: '225124 - Médico pediatra' },
	{ value: '225125 - Médico clínico', label: '225125 - Médico clínico' },
	{
		value: '225127 - Médico pneumologista',
		label: '225127 - Médico pneumologista',
	},
	{
		value: '225130 - Médico de família e comunidade',
		label: '225130 - Médico de família e comunidade',
	},
	{
		value: '225133 - Médico psiquiatra',
		label: '225133 - Médico psiquiatra',
	},
	{
		value: '225220 - Médico cirurgião do aparelho digestivo',
		label: '225220 - Médico cirurgião do aparelho digestivo',
	},
	{
		value: '225225 - Médico cirurgião geral',
		label: '225225 - Médico cirurgião geral',
	},
	{
		value: '225210 - Médico cirurgião cardiovascular',
		label: '225210 - Médico cirurgião cardiovascular',
	},
	{
		value: '225203 - Médico em cirurgia vascular',
		label: '225203 - Médico em cirurgia vascular',
	},
	{
		value: '225295 - Médico cirurgião da mão',
		label: '225295 - Médico cirurgião da mão',
	},
	{
		value: '225290 - Médico cancerologista cirurgíco',
		label: '225290 - Médico cancerologista cirurgíco',
	},
	{
		value: '225285 - Médico urologista',
		label: '225285 - Médico urologista',
	},
	{
		value: '225280 - Médico coloproctologista',
		label: '225280 - Médico coloproctologista',
	},
	{
		value: '225275 - Médico otorrinolaringologista',
		label: '225275 - Médico otorrinolaringologista',
	},
	{
		value: '225270 - Médico ortopedista e traumatologista',
		label: '225270 - Médico ortopedista e traumatologista',
	},
	{
		value: '225265 - Médico oftalmologista',
		label: '225265 - Médico oftalmologista',
	},
	{
		value: '225260 - Médico neurocirurgião',
		label: '225260 - Médico neurocirurgião',
	},
	{
		value: '225255 - Médico mastologista',
		label: '225255 - Médico mastologista',
	},
	{
		value: '225250 - Médico ginecologista e obstetra',
		label: '225250 - Médico ginecologista e obstetra',
	},
	{
		value: '225240 - Médico cirurgião torácico',
		label: '225240 - Médico cirurgião torácico',
	},
	{
		value: '225235 - Médico cirurgião plástico',
		label: '225235 - Médico cirurgião plástico',
	},
	{
		value: '225230 - Médico cirurgião pediátrico',
		label: '225230 - Médico cirurgião pediátrico',
	},
	{
		value: '225215 - Médico cirurgião de cabeça e pescoço',
		label: '225215 - Médico cirurgião de cabeça e pescoço',
	},
	{
		value: '225305 - Médico citopatologista',
		label: '225305 - Médico citopatologista',
	},
	{
		value: '225310 - Médico em endoscopia',
		label: '225310 - Médico em endoscopia',
	},
	{
		value: '225315 - Médico em medicina nuclear',
		label: '225315 - Médico em medicina nuclear',
	},
	{
		value: '225320 - Médico em radiologia e diagnóstico por imagem',
		label: '225320 - Médico em radiologia e diagnóstico por imagem',
	},
	{
		value: '225325 - Médico patologista',
		label: '225325 - Médico patologista',
	},
	{
		value: '225330 - Médico radioterapeuta',
		label: '225330 - Médico radioterapeuta',
	},
	{
		value: '225335 - Médico patologista clínico / medicina laboratorial',
		label: '225335 - Médico patologista clínico / medicina laboratorial',
	},
	{
		value: '225340 - Médico hemoterapeuta',
		label: '225340 - Médico hemoterapeuta',
	},
	{
		value: '225345 - Médico hiperbarista',
		label: '225345 - Médico hiperbarista',
	},
	{
		value: '225350 - Médico neurofisiologista clínico',
		label: '225350 - Médico neurofisiologista clínico',
	},
	{ value: '226105 - Quiropraxista', label: '226105 - Quiropraxista' },
	{ value: '226110 - Osteopata', label: '226110 - Osteopata' },
	{ value: '226315 - Equoterapeuta', label: '226315 - Equoterapeuta' },
	{ value: '226305 - Musicoterapeuta', label: '226305 - Musicoterapeuta' },
	{ value: '226320 - Naturólogo', label: '226320 - Naturólogo' },
	{ value: '226310 - Arteterapeuta', label: '226310 - Arteterapeuta' },
	{
		value: '231110 - Professor de nível superior na educação infantil (zero a três anos)',
		label: '231110 - Professor de nível superior na educação infantil (zero a três anos)',
	},
	{
		value: '231105 - Professor de nível superior na educação infantil (quatro a seis anos)',
		label: '231105 - Professor de nível superior na educação infantil (quatro a seis anos)',
	},
	{
		value: '231205 - Professor da  educação de jovens e adultos do ensino fundamental (primeira a quarta série)',
		label: '231205 - Professor da  educação de jovens e adultos do ensino fundamental (primeira a quarta série)',
	},
	{
		value: '231210 - Professor de nível superior do ensino fundamental (primeira a quarta série)',
		label: '231210 - Professor de nível superior do ensino fundamental (primeira a quarta série)',
	},
	{
		value: '231320 - Professor de geografia do ensino fundamental',
		label: '231320 - Professor de geografia do ensino fundamental',
	},
	{
		value: '231325 - Professor de história do ensino fundamental',
		label: '231325 - Professor de história do ensino fundamental',
	},
	{
		value: '231330 - Professor de língua estrangeira moderna do ensino fundamental',
		label: '231330 - Professor de língua estrangeira moderna do ensino fundamental',
	},
	{
		value: '231315 - Professor de educação física do ensino fundamental',
		label: '231315 - Professor de educação física do ensino fundamental',
	},
	{
		value: '231310 - Professor de educação artística do ensino fundamental',
		label: '231310 - Professor de educação artística do ensino fundamental',
	},
	{
		value: '231335 - Professor de língua portuguesa do ensino fundamental',
		label: '231335 - Professor de língua portuguesa do ensino fundamental',
	},
	{
		value: '231340 - Professor de matemática do ensino fundamental',
		label: '231340 - Professor de matemática do ensino fundamental',
	},
	{
		value: '231305 - Professor de ciências exatas e naturais do ensino fundamental',
		label: '231305 - Professor de ciências exatas e naturais do ensino fundamental',
	},
	{
		value: '232105 - Professor de artes no ensino médio',
		label: '232105 - Professor de artes no ensino médio',
	},
	{
		value: '232120 - Professor de educação física no ensino médio',
		label: '232120 - Professor de educação física no ensino médio',
	},
	{
		value: '232125 - Professor de filosofia no ensino médio',
		label: '232125 - Professor de filosofia no ensino médio',
	},
	{
		value: '232130 - Professor de física no ensino médio',
		label: '232130 - Professor de física no ensino médio',
	},
	{
		value: '232135 - Professor de geografia no ensino médio',
		label: '232135 - Professor de geografia no ensino médio',
	},
	{
		value: '232145 - Professor de língua e literatura brasileira no ensino médio',
		label: '232145 - Professor de língua e literatura brasileira no ensino médio',
	},
	{
		value: '232165 - Professor de química no ensino médio',
		label: '232165 - Professor de química no ensino médio',
	},
	{
		value: '232170 - Professor de sociologia no ensino médio',
		label: '232170 - Professor de sociologia no ensino médio',
	},
	{
		value: '232110 - Professor de biologia no ensino médio',
		label: '232110 - Professor de biologia no ensino médio',
	},
	{
		value: '232115 - Professor de disciplinas pedagógicas no ensino médio',
		label: '232115 - Professor de disciplinas pedagógicas no ensino médio',
	},
	{
		value: '232140 - Professor de história no ensino médio',
		label: '232140 - Professor de história no ensino médio',
	},
	{
		value: '232150 - Professor de língua estrangeira moderna no ensino médio',
		label: '232150 - Professor de língua estrangeira moderna no ensino médio',
	},
	{
		value: '232160 - Professor de psicologia no ensino médio',
		label: '232160 - Professor de psicologia no ensino médio',
	},
	{
		value: '232155 - Professor de matemática no ensino médio',
		label: '232155 - Professor de matemática no ensino médio',
	},
	{
		value: '233105 - Professor da área de meio ambiente',
		label: '233105 - Professor da área de meio ambiente',
	},
	{
		value: '233110 - Professor de desenho técnico',
		label: '233110 - Professor de desenho técnico',
	},
	{
		value: '233115 - Professor de técnicas agrícolas',
		label: '233115 - Professor de técnicas agrícolas',
	},
	{
		value: '233120 - Professor de técnicas comerciais e secretariais',
		label: '233120 - Professor de técnicas comerciais e secretariais',
	},
	{
		value: '233125 - Professor de técnicas de enfermagem',
		label: '233125 - Professor de técnicas de enfermagem',
	},
	{
		value: '233130 - Professor de técnicas industriais',
		label: '233130 - Professor de técnicas industriais',
	},
	{
		value: '233135 - Professor de tecnologia e cálculo técnico',
		label: '233135 - Professor de tecnologia e cálculo técnico',
	},
	{
		value: '233205 - Instrutor de aprendizagem e treinamento agropecuário',
		label: '233205 - Instrutor de aprendizagem e treinamento agropecuário',
	},
	{
		value: '233210 - Instrutor de aprendizagem e treinamento industrial',
		label: '233210 - Instrutor de aprendizagem e treinamento industrial',
	},
	{
		value: '233215 - Instrutor de aprendizagem e treinamento comercial',
		label: '233215 - Instrutor de aprendizagem e treinamento comercial',
	},
	{
		value: '233220 - Professor instrutor de ensino e aprendizagem agroflorestal',
		label: '233220 - Professor instrutor de ensino e aprendizagem agroflorestal',
	},
	{
		value: '233225 - Professor instrutor de ensino e aprendizagem em serviços',
		label: '233225 - Professor instrutor de ensino e aprendizagem em serviços',
	},
	{
		value: '234105 - Professor de matemática aplicada (no ensino superior)',
		label: '234105 - Professor de matemática aplicada (no ensino superior)',
	},
	{
		value: '234110 - Professor de matemática pura (no ensino superior)',
		label: '234110 - Professor de matemática pura (no ensino superior)',
	},
	{
		value: '234115 - Professor de estatística (no ensino superior)',
		label: '234115 - Professor de estatística (no ensino superior)',
	},
	{
		value: '234120 - Professor de computação (no ensino superior)',
		label: '234120 - Professor de computação (no ensino superior)',
	},
	{
		value: '234125 - Professor de pesquisa operacional (no ensino superior)',
		label: '234125 - Professor de pesquisa operacional (no ensino superior)',
	},
	{
		value: '234205 - Professor de física (ensino superior)',
		label: '234205 - Professor de física (ensino superior)',
	},
	{
		value: '234215 - Professor de astronomia (ensino superior)',
		label: '234215 - Professor de astronomia (ensino superior)',
	},
	{
		value: '234210 - Professor de química (ensino superior)',
		label: '234210 - Professor de química (ensino superior)',
	},
	{
		value: '234305 - Professor de arquitetura',
		label: '234305 - Professor de arquitetura',
	},
	{
		value: '234315 - Professor de geofísica',
		label: '234315 - Professor de geofísica',
	},
	{
		value: '234310 - Professor de engenharia',
		label: '234310 - Professor de engenharia',
	},
	{
		value: '234320 - Professor de geologia',
		label: '234320 - Professor de geologia',
	},
	{
		value: '234405 - Professor de ciências biológicas do ensino superior',
		label: '234405 - Professor de ciências biológicas do ensino superior',
	},
	{
		value: '234415 - Professor de enfermagem do ensino superior',
		label: '234415 - Professor de enfermagem do ensino superior',
	},
	{
		value: '234450 - Professor de odontologia',
		label: '234450 - Professor de odontologia',
	},
	{
		value: '234445 - Professor de nutrição',
		label: '234445 - Professor de nutrição',
	},
	{
		value: '234440 - Professor de medicina veterinária',
		label: '234440 - Professor de medicina veterinária',
	},
	{
		value: '234410 - Professor de educação física no ensino superior',
		label: '234410 - Professor de educação física no ensino superior',
	},
	{
		value: '234455 - Professor de terapia ocupacional',
		label: '234455 - Professor de terapia ocupacional',
	},
	{
		value: '234460 - Professor de zootecnia do ensino superior',
		label: '234460 - Professor de zootecnia do ensino superior',
	},
	{
		value: '234420 - Professor de farmácia e bioquímica',
		label: '234420 - Professor de farmácia e bioquímica',
	},
	{
		value: '234425 - Professor de fisioterapia',
		label: '234425 - Professor de fisioterapia',
	},
	{
		value: '234430 - Professor de fonoaudiologia',
		label: '234430 - Professor de fonoaudiologia',
	},
	{
		value: '234435 - Professor de medicina',
		label: '234435 - Professor de medicina',
	},
	{
		value: '234510 - Professor de ensino superior na área de orientação educacional',
		label: '234510 - Professor de ensino superior na área de orientação educacional',
	},
	{
		value: '234505 - Professor de ensino superior na área de didática',
		label: '234505 - Professor de ensino superior na área de didática',
	},
	{
		value: '234515 - Professor de ensino superior na área de pesquisa educacional',
		label: '234515 - Professor de ensino superior na área de pesquisa educacional',
	},
	{
		value: '234520 - Professor de ensino superior na área de prática de ensino',
		label: '234520 - Professor de ensino superior na área de prática de ensino',
	},
	{
		value: '234628 - Professor de literatura brasileira',
		label: '234628 - Professor de literatura brasileira',
	},
	{
		value: '234632 - Professor de literatura portuguesa',
		label: '234632 - Professor de literatura portuguesa',
	},
	{
		value: '234640 - Professor de literatura comparada',
		label: '234640 - Professor de literatura comparada',
	},
	{
		value: '234660 - Professor de literatura de línguas estrangeiras modernas',
		label: '234660 - Professor de literatura de línguas estrangeiras modernas',
	},
	{
		value: '234668 - Professor de línguas estrangeiras modernas',
		label: '234668 - Professor de línguas estrangeiras modernas',
	},
	{
		value: '234672 - Professor de lingüística e lingüística aplicada',
		label: '234672 - Professor de lingüística e lingüística aplicada',
	},
	{
		value: '234676 - Professor de filologia e crítica textual',
		label: '234676 - Professor de filologia e crítica textual',
	},
	{
		value: '234680 - Professor de semiótica',
		label: '234680 - Professor de semiótica',
	},
	{
		value: '234684 - Professor de teoria da literatura',
		label: '234684 - Professor de teoria da literatura',
	},
	{
		value: '234604 - Professor de língua alemã',
		label: '234604 - Professor de língua alemã',
	},
	{
		value: '234608 - Professor de língua italiana',
		label: '234608 - Professor de língua italiana',
	},
	{
		value: '234612 - Professor de língua francesa',
		label: '234612 - Professor de língua francesa',
	},
	{
		value: '234616 - Professor de língua inglesa',
		label: '234616 - Professor de língua inglesa',
	},
	{
		value: '234620 - Professor de língua espanhola',
		label: '234620 - Professor de língua espanhola',
	},
	{
		value: '234636 - Professor de literatura alemã',
		label: '234636 - Professor de literatura alemã',
	},
	{
		value: '234644 - Professor de literatura espanhola',
		label: '234644 - Professor de literatura espanhola',
	},
	{
		value: '234648 - Professor de literatura francesa',
		label: '234648 - Professor de literatura francesa',
	},
	{
		value: '234652 - Professor de literatura inglesa',
		label: '234652 - Professor de literatura inglesa',
	},
	{
		value: '234656 - Professor de literatura italiana',
		label: '234656 - Professor de literatura italiana',
	},
	{
		value: '234664 - Professor de outras línguas e literaturas',
		label: '234664 - Professor de outras línguas e literaturas',
	},
	{
		value: '234624 - Professor de língua portuguesa',
		label: '234624 - Professor de língua portuguesa',
	},
	{
		value: '234705 - Professor de antropologia do ensino superior',
		label: '234705 - Professor de antropologia do ensino superior',
	},
	{
		value: '234710 - Professor de arquivologia do ensino superior',
		label: '234710 - Professor de arquivologia do ensino superior',
	},
	{
		value: '234770 - Professor de sociologia do ensino superior',
		label: '234770 - Professor de sociologia do ensino superior',
	},
	{
		value: '234765 - Professor de serviço social do ensino superior',
		label: '234765 - Professor de serviço social do ensino superior',
	},
	{
		value: '234760 - Professor de psicologia do ensino superior',
		label: '234760 - Professor de psicologia do ensino superior',
	},
	{
		value: '234755 - Professor de museologia do ensino superior',
		label: '234755 - Professor de museologia do ensino superior',
	},
	{
		value: '234715 - Professor de biblioteconomia do ensino superior',
		label: '234715 - Professor de biblioteconomia do ensino superior',
	},
	{
		value: '234745 - Professor de história do ensino superior',
		label: '234745 - Professor de história do ensino superior',
	},
	{
		value: '234740 - Professor de geografia do ensino superior',
		label: '234740 - Professor de geografia do ensino superior',
	},
	{
		value: '234735 - Professor de filosofia do ensino superior',
		label: '234735 - Professor de filosofia do ensino superior',
	},
	{
		value: '234730 - Professor de direito do ensino superior',
		label: '234730 - Professor de direito do ensino superior',
	},
	{
		value: '234725 - Professor de comunicação social do ensino superior',
		label: '234725 - Professor de comunicação social do ensino superior',
	},
	{
		value: '234720 - Professor de ciência política do ensino superior',
		label: '234720 - Professor de ciência política do ensino superior',
	},
	{
		value: '234750 - Professor de jornalismo',
		label: '234750 - Professor de jornalismo',
	},
	{
		value: '234815 - Professor de contabilidade',
		label: '234815 - Professor de contabilidade',
	},
	{
		value: '234805 - Professor de economia',
		label: '234805 - Professor de economia',
	},
	{
		value: '234810 - Professor de administração',
		label: '234810 - Professor de administração',
	},
	{
		value: '234915 - Professor de música no ensino superior',
		label: '234915 - Professor de música no ensino superior',
	},
	{
		value: '234910 - Professor de artes visuais no ensino superior (artes plásticas e multimídia)',
		label: '234910 - Professor de artes visuais no ensino superior (artes plásticas e multimídia)',
	},
	{
		value: '234905 - Professor de artes do espetáculo no ensino superior',
		label: '234905 - Professor de artes do espetáculo no ensino superior',
	},
	{
		value: '239205 - Professor de alunos com deficiência auditiva e surdos',
		label: '239205 - Professor de alunos com deficiência auditiva e surdos',
	},
	{
		value: '239210 - Professor de alunos com deficiência física',
		label: '239210 - Professor de alunos com deficiência física',
	},
	{
		value: '239220 - Professor de alunos com deficiência múltipla',
		label: '239220 - Professor de alunos com deficiência múltipla',
	},
	{
		value: '239225 - Professor de alunos com deficiência visual',
		label: '239225 - Professor de alunos com deficiência visual',
	},
	{
		value: '239215 - Professor de alunos com deficiência mental',
		label: '239215 - Professor de alunos com deficiência mental',
	},
	{ value: '239415 - Pedagogo', label: '239415 - Pedagogo' },
	{
		value: '239410 - Orientador educacional',
		label: '239410 - Orientador educacional',
	},
	{
		value: '239405 - Coordenador pedagógico',
		label: '239405 - Coordenador pedagógico',
	},
	{ value: '239425 - Psicopedagogo', label: '239425 - Psicopedagogo' },
	{
		value: '239430 - Supervisor de ensino',
		label: '239430 - Supervisor de ensino',
	},
	{
		value: '239435 - Designer educacional',
		label: '239435 - Designer educacional',
	},
	{
		value: '239420 - Professor de técnicas e recursos audiovisuais',
		label: '239420 - Professor de técnicas e recursos audiovisuais',
	},
	{
		value: '241040 - Consultor jurídico',
		label: '241040 - Consultor jurídico',
	},
	{
		value: '241035 - Advogado (direito do trabalho)',
		label: '241035 - Advogado (direito do trabalho)',
	},
	{
		value: '241030 - Advogado (áreas especiais)',
		label: '241030 - Advogado (áreas especiais)',
	},
	{
		value: '241025 - Advogado (direito penal)',
		label: '241025 - Advogado (direito penal)',
	},
	{
		value: '241020 - Advogado (direito público)',
		label: '241020 - Advogado (direito público)',
	},
	{
		value: '241015 - Advogado (direito civil)',
		label: '241015 - Advogado (direito civil)',
	},
	{
		value: '241010 - Advogado de empresa',
		label: '241010 - Advogado de empresa',
	},
	{ value: '241005 - Advogado', label: '241005 - Advogado' },
	{
		value: '241225 - Procurador do município',
		label: '241225 - Procurador do município',
	},
	{
		value: '241205 - Advogado da união',
		label: '241205 - Advogado da união',
	},
	{
		value: '241235 - Procurador fundacional',
		label: '241235 - Procurador fundacional',
	},
	{
		value: '241230 - Procurador federal',
		label: '241230 - Procurador federal',
	},
	{
		value: '241210 - Procurador autárquico',
		label: '241210 - Procurador autárquico',
	},
	{
		value: '241220 - Procurador do estado',
		label: '241220 - Procurador do estado',
	},
	{
		value: '241215 - Procurador da fazenda nacional',
		label: '241215 - Procurador da fazenda nacional',
	},
	{
		value: '241315 - Oficial do registro civil de pessoas naturais',
		label: '241315 - Oficial do registro civil de pessoas naturais',
	},
	{
		value: '241340 - Tabelião de protestos',
		label: '241340 - Tabelião de protestos',
	},
	{
		value: '241320 - Oficial do registro de distribuições',
		label: '241320 - Oficial do registro de distribuições',
	},
	{
		value: '241325 - Oficial do registro de imóveis',
		label: '241325 - Oficial do registro de imóveis',
	},
	{
		value: '241330 - Oficial do registro de títulos e documentos',
		label: '241330 - Oficial do registro de títulos e documentos',
	},
	{
		value: '241305 - Oficial de registro de contratos marítimos',
		label: '241305 - Oficial de registro de contratos marítimos',
	},
	{
		value: '241310 - Oficial do registro civil de pessoas jurídicas',
		label: '241310 - Oficial do registro civil de pessoas jurídicas',
	},
	{
		value: '241335 - Tabelião de notas',
		label: '241335 - Tabelião de notas',
	},
	{
		value: '242220 - Procurador do trabalho',
		label: '242220 - Procurador do trabalho',
	},
	{
		value: '242250 - Subprocurador-geral do trabalho',
		label: '242250 - Subprocurador-geral do trabalho',
	},
	{
		value: '242235 - Promotor de justiça',
		label: '242235 - Promotor de justiça',
	},
	{
		value: '242210 - Procurador de justiça',
		label: '242210 - Procurador de justiça',
	},
	{
		value: '242245 - Subprocurador-geral da república',
		label: '242245 - Subprocurador-geral da república',
	},
	{
		value: '242240 - Subprocurador de justiça militar',
		label: '242240 - Subprocurador de justiça militar',
	},
	{
		value: '242205 - Procurador da república',
		label: '242205 - Procurador da república',
	},
	{
		value: '242230 - Procurador regional do trabalho',
		label: '242230 - Procurador regional do trabalho',
	},
	{
		value: '242225 - Procurador regional da república',
		label: '242225 - Procurador regional da república',
	},
	{
		value: '242215 - Procurador de justiça militar',
		label: '242215 - Procurador de justiça militar',
	},
	{
		value: '242305 - Delegado de polícia',
		label: '242305 - Delegado de polícia',
	},
	{
		value: '242410 - Procurador da assistência judiciária',
		label: '242410 - Procurador da assistência judiciária',
	},
	{ value: '242405 - Defensor público', label: '242405 - Defensor público' },
	{
		value: '242910 - Oficial técnico de inteligência',
		label: '242910 - Oficial técnico de inteligência',
	},
	{
		value: '242905 - Oficial de inteligência',
		label: '242905 - Oficial de inteligência',
	},
	{ value: '251120 - Sociólogo', label: '251120 - Sociólogo' },
	{
		value: '251115 - Cientista político',
		label: '251115 - Cientista político',
	},
	{ value: '251105 - Antropólogo', label: '251105 - Antropólogo' },
	{ value: '251110 - Arqueólogo', label: '251110 - Arqueólogo' },
	{
		value: '251210 - Economista agroindustrial',
		label: '251210 - Economista agroindustrial',
	},
	{ value: '251205 - Economista', label: '251205 - Economista' },
	{
		value: '251215 - Economista financeiro',
		label: '251215 - Economista financeiro',
	},
	{
		value: '251225 - Economista do setor público',
		label: '251225 - Economista do setor público',
	},
	{
		value: '251230 - Economista ambiental',
		label: '251230 - Economista ambiental',
	},
	{
		value: '251235 - Economista regional e urbano',
		label: '251235 - Economista regional e urbano',
	},
	{
		value: '251220 - Economista industrial',
		label: '251220 - Economista industrial',
	},
	{ value: '251305 - Geógrafo', label: '251305 - Geógrafo' },
	{ value: '251405 - Filósofo', label: '251405 - Filósofo' },
	{
		value: '251505 - Psicólogo educacional',
		label: '251505 - Psicólogo educacional',
	},
	{
		value: '251515 - Psicólogo do esporte',
		label: '251515 - Psicólogo do esporte',
	},
	{
		value: '251510 - Psicólogo clínico',
		label: '251510 - Psicólogo clínico',
	},
	{
		value: '251520 - Psicólogo hospitalar',
		label: '251520 - Psicólogo hospitalar',
	},
	{
		value: '251525 - Psicólogo jurídico',
		label: '251525 - Psicólogo jurídico',
	},
	{ value: '251530 - Psicólogo social', label: '251530 - Psicólogo social' },
	{
		value: '251535 - Psicólogo do trânsito',
		label: '251535 - Psicólogo do trânsito',
	},
	{
		value: '251540 - Psicólogo do trabalho',
		label: '251540 - Psicólogo do trabalho',
	},
	{
		value: '251555 - Psicólogo acupunturista',
		label: '251555 - Psicólogo acupunturista',
	},
	{ value: '251550 - Psicanalista', label: '251550 - Psicanalista' },
	{ value: '251545 - Neuropsicólogo', label: '251545 - Neuropsicólogo' },
	{
		value: '251610 - Economista doméstico',
		label: '251610 - Economista doméstico',
	},
	{
		value: '251605 - Assistente social',
		label: '251605 - Assistente social',
	},
	{ value: '252105 - Administrador', label: '252105 - Administrador' },
	{
		value: '252205 - Auditor (contadores e afins)',
		label: '252205 - Auditor (contadores e afins)',
	},
	{ value: '252210 - Contador', label: '252210 - Contador' },
	{ value: '252215 - Perito contábil', label: '252215 - Perito contábil' },
	{
		value: '252320 - Tecnólogo em secretariado escolar',
		label: '252320 - Tecnólogo em secretariado escolar',
	},
	{
		value: '252310 - Secretário  bilíngüe',
		label: '252310 - Secretário  bilíngüe',
	},
	{
		value: '252305 - Secretária(o) executiva(o)',
		label: '252305 - Secretária(o) executiva(o)',
	},
	{
		value: '252315 - Secretária trilíngüe',
		label: '252315 - Secretária trilíngüe',
	},
	{
		value: '252405 - Analista de recursos humanos',
		label: '252405 - Analista de recursos humanos',
	},
	{
		value: '252530 - Analista de crédito rural',
		label: '252530 - Analista de crédito rural',
	},
	{
		value: '252525 - Analista de crédito (instituições financeiras)',
		label: '252525 - Analista de crédito (instituições financeiras)',
	},
	{
		value: '252535 - Analista de leasing',
		label: '252535 - Analista de leasing',
	},
	{
		value: '252515 - Analista de cobrança (instituições financeiras)',
		label: '252515 - Analista de cobrança (instituições financeiras)',
	},
	{
		value: '252545 - Analista financeiro (instituições financeiras)',
		label: '252545 - Analista financeiro (instituições financeiras)',
	},
	{
		value: '252550 - Profissional de relações com investidores',
		label: '252550 - Profissional de relações com investidores',
	},
	{
		value: '252540 - Analista de produtos bancários',
		label: '252540 - Analista de produtos bancários',
	},
	{
		value: '252505 - Administrador de fundos e carteiras de investimento',
		label: '252505 - Administrador de fundos e carteiras de investimento',
	},
	{
		value: '252510 - Analista de câmbio',
		label: '252510 - Analista de câmbio',
	},
	{
		value: '252605 - Gestor em segurança',
		label: '252605 - Gestor em segurança',
	},
	{
		value: '252705 - Analista de pcp (programação e controle da produção)',
		label: '252705 - Analista de pcp (programação e controle da produção)',
	},
	{
		value: '252710 - Analista de planejamento de materias',
		label: '252710 - Analista de planejamento de materias',
	},
	{
		value: '252720 - Analista de projetos logisticos',
		label: '252720 - Analista de projetos logisticos',
	},
	{
		value: '252725 - Analista de gestão de estoque',
		label: '252725 - Analista de gestão de estoque',
	},
	{
		value: '252715 - Analista de logistica',
		label: '252715 - Analista de logistica',
	},
	{ value: '253115 - Publicitário', label: '253115 - Publicitário' },
	{
		value: '253120 - Diretor de mídia (publicidade)',
		label: '253120 - Diretor de mídia (publicidade)',
	},
	{
		value: '253125 - Diretor de arte (publicidade)',
		label: '253125 - Diretor de arte (publicidade)',
	},
	{
		value: '253130 - Diretor de criação',
		label: '253130 - Diretor de criação',
	},
	{
		value: '253135 - Diretor de contas (publicidade)',
		label: '253135 - Diretor de contas (publicidade)',
	},
	{
		value: '253140 - Agenciador de propaganda',
		label: '253140 - Agenciador de propaganda',
	},
	{
		value: '253110 - Redator de publicidade',
		label: '253110 - Redator de publicidade',
	},
	{
		value: '253215 - Gerente de contas - pessoa física e jurídica',
		label: '253215 - Gerente de contas - pessoa física e jurídica',
	},
	{
		value: '253220 - Gerente de grandes contas (corporate)',
		label: '253220 - Gerente de grandes contas (corporate)',
	},
	{
		value: '253225 - Operador de negócios',
		label: '253225 - Operador de negócios',
	},
	{
		value: '253205 - Gerente de captação (fundos e investimentos institucionais)',
		label: '253205 - Gerente de captação (fundos e investimentos institucionais)',
	},
	{
		value: '253210 - Gerente de clientes especiais (private)',
		label: '253210 - Gerente de clientes especiais (private)',
	},
	{
		value: '253305 - Corretor de valores, ativos financeiros, mercadorias e derivativos',
		label: '253305 - Corretor de valores, ativos financeiros, mercadorias e derivativos',
	},
	{
		value: '254105 - Auditor-fiscal da receita federal',
		label: '254105 - Auditor-fiscal da receita federal',
	},
	{
		value: '254110 - Técnico da receita federal',
		label: '254110 - Técnico da receita federal',
	},
	{
		value: '254205 - Auditor-fiscal da previdência social',
		label: '254205 - Auditor-fiscal da previdência social',
	},
	{
		value: '254305 - Auditor-fiscal do trabalho',
		label: '254305 - Auditor-fiscal do trabalho',
	},
	{
		value: '254310 - Agente de higiene e segurança',
		label: '254310 - Agente de higiene e segurança',
	},
	{
		value: '254405 - Fiscal de tributos estadual',
		label: '254405 - Fiscal de tributos estadual',
	},
	{
		value: '254410 - Fiscal de tributos municipal',
		label: '254410 - Fiscal de tributos municipal',
	},
	{
		value: '254415 - Técnico de tributos estadual',
		label: '254415 - Técnico de tributos estadual',
	},
	{
		value: '254420 - Técnico de tributos municipal',
		label: '254420 - Técnico de tributos municipal',
	},
	{
		value: '254505 - Fiscal de atividades urbanas',
		label: '254505 - Fiscal de atividades urbanas',
	},
	{ value: '261125 - Jornalista', label: '261125 - Jornalista' },
	{
		value: '261110 - Assessor de imprensa',
		label: '261110 - Assessor de imprensa',
	},
	{
		value: '261115 - Diretor de redação',
		label: '261115 - Diretor de redação',
	},
	{ value: '261120 - Editor', label: '261120 - Editor' },
	{
		value: '261105 - Arquivista pesquisador (jornalismo)',
		label: '261105 - Arquivista pesquisador (jornalismo)',
	},
	{
		value: '261130 - Produtor de texto',
		label: '261130 - Produtor de texto',
	},
	{
		value: '261135 - Repórter (exclusive rádio e televisão)',
		label: '261135 - Repórter (exclusive rádio e televisão)',
	},
	{ value: '261140 - Revisor de texto', label: '261140 - Revisor de texto' },
	{
		value: '261215 - Analista de informações (pesquisador de informações de rede)',
		label: '261215 - Analista de informações (pesquisador de informações de rede)',
	},
	{ value: '261210 - Documentalista', label: '261210 - Documentalista' },
	{ value: '261205 - Bibliotecário', label: '261205 - Bibliotecário' },
	{ value: '261305 - Arquivista', label: '261305 - Arquivista' },
	{ value: '261310 - Museólogo', label: '261310 - Museólogo' },
	{ value: '261405 - Filólogo', label: '261405 - Filólogo' },
	{ value: '261430 - Audiodescritor', label: '261430 - Audiodescritor' },
	{
		value: '261425 - Intérprete de língua de sinais',
		label: '261425 - Intérprete de língua de sinais',
	},
	{ value: '261420 - Tradutor', label: '261420 - Tradutor' },
	{ value: '261415 - Lingüista', label: '261415 - Lingüista' },
	{ value: '261410 - Intérprete', label: '261410 - Intérprete' },
	{
		value: '261520 - Escritor de não ficção',
		label: '261520 - Escritor de não ficção',
	},
	{
		value: '261515 - Escritor de ficção',
		label: '261515 - Escritor de ficção',
	},
	{
		value: '261530 - Redator de textos técnicos',
		label: '261530 - Redator de textos técnicos',
	},
	{ value: '261525 - Poeta', label: '261525 - Poeta' },
	{ value: '261510 - Crítico', label: '261510 - Crítico' },
	{ value: '261505 - Autor-roteirista', label: '261505 - Autor-roteirista' },
	{ value: '261610 - Editor de livro', label: '261610 - Editor de livro' },
	{
		value: '261615 - Editor de mídia eletrônica',
		label: '261615 - Editor de mídia eletrônica',
	},
	{
		value: '261625 - Editor de revista científica',
		label: '261625 - Editor de revista científica',
	},
	{
		value: '261620 - Editor de revista',
		label: '261620 - Editor de revista',
	},
	{ value: '261605 - Editor de jornal', label: '261605 - Editor de jornal' },
	{
		value: '261715 - Locutor de rádio e televisão',
		label: '261715 - Locutor de rádio e televisão',
	},
	{
		value: '261710 - Comentarista de rádio e televisão',
		label: '261710 - Comentarista de rádio e televisão',
	},
	{
		value: '261730 - Repórter de rádio e televisão',
		label: '261730 - Repórter de rádio e televisão',
	},
	{
		value: '261725 - Narrador em programas de rádio e televisão',
		label: '261725 - Narrador em programas de rádio e televisão',
	},
	{
		value: '261720 - Locutor publicitário de rádio e televisão',
		label: '261720 - Locutor publicitário de rádio e televisão',
	},
	{
		value: '261705 - Âncora de rádio e televisão',
		label: '261705 - Âncora de rádio e televisão',
	},
	{
		value: '261820 - Repórter fotográfico',
		label: '261820 - Repórter fotográfico',
	},
	{
		value: '261815 - Fotógrafo retratista',
		label: '261815 - Fotógrafo retratista',
	},
	{ value: '261805 - Fotógrafo', label: '261805 - Fotógrafo' },
	{
		value: '261810 - Fotógrafo publicitário',
		label: '261810 - Fotógrafo publicitário',
	},
	{
		value: '262130 - Tecnólogo em produção fonográfica',
		label: '262130 - Tecnólogo em produção fonográfica',
	},
	{
		value: '262125 - Produtor de televisão',
		label: '262125 - Produtor de televisão',
	},
	{
		value: '262120 - Produtor de teatro',
		label: '262120 - Produtor de teatro',
	},
	{
		value: '262115 - Produtor de rádio',
		label: '262115 - Produtor de rádio',
	},
	{
		value: '262110 - Produtor cinematográfico',
		label: '262110 - Produtor cinematográfico',
	},
	{
		value: '262135 - Tecnólogo em produção audiovisual',
		label: '262135 - Tecnólogo em produção audiovisual',
	},
	{
		value: '262105 - Produtor cultural',
		label: '262105 - Produtor cultural',
	},
	{
		value: '262205 - Diretor de cinema',
		label: '262205 - Diretor de cinema',
	},
	{
		value: '262210 - Diretor de programas de rádio',
		label: '262210 - Diretor de programas de rádio',
	},
	{
		value: '262215 - Diretor de programas de televisão',
		label: '262215 - Diretor de programas de televisão',
	},
	{ value: '262220 - Diretor teatral', label: '262220 - Diretor teatral' },
	{
		value: '262305 - Cenógrafo carnavalesco e festas populares',
		label: '262305 - Cenógrafo carnavalesco e festas populares',
	},
	{
		value: '262310 - Cenógrafo de cinema',
		label: '262310 - Cenógrafo de cinema',
	},
	{
		value: '262315 - Cenógrafo de eventos',
		label: '262315 - Cenógrafo de eventos',
	},
	{
		value: '262320 - Cenógrafo de teatro',
		label: '262320 - Cenógrafo de teatro',
	},
	{ value: '262325 - Cenógrafo de tv', label: '262325 - Cenógrafo de tv' },
	{ value: '262330 - Diretor de arte', label: '262330 - Diretor de arte' },
	{
		value: '262420 - Desenhista industrial de produto (designer de produto)',
		label: '262420 - Desenhista industrial de produto (designer de produto)',
	},
	{
		value: '262425 - Desenhista industrial de produto de moda (designer de moda)',
		label: '262425 - Desenhista industrial de produto de moda (designer de moda)',
	},
	{
		value: '262405 - Artista (artes visuais)',
		label: '262405 - Artista (artes visuais)',
	},
	{
		value: '262415 - Conservador-restaurador de bens  culturais',
		label: '262415 - Conservador-restaurador de bens  culturais',
	},
	{
		value: '262410 - Desenhista industrial gráfico (designer gráfico)',
		label: '262410 - Desenhista industrial gráfico (designer gráfico)',
	},
	{ value: '262505 - Ator', label: '262505 - Ator' },
	{ value: '262620 - Musicólogo', label: '262620 - Musicólogo' },
	{ value: '262615 - Músico regente', label: '262615 - Músico regente' },
	{
		value: '262610 - Músico arranjador',
		label: '262610 - Músico arranjador',
	},
	{ value: '262605 - Compositor', label: '262605 - Compositor' },
	{
		value: '262705 - Músico intérprete cantor',
		label: '262705 - Músico intérprete cantor',
	},
	{
		value: '262710 - Músico intérprete instrumentista',
		label: '262710 - Músico intérprete instrumentista',
	},
	{
		value: '262805 - Assistente de coreografia',
		label: '262805 - Assistente de coreografia',
	},
	{
		value: '262810 - Bailarino (exceto danças populares)',
		label: '262810 - Bailarino (exceto danças populares)',
	},
	{ value: '262815 - Coreógrafo', label: '262815 - Coreógrafo' },
	{
		value: '262820 - Dramaturgo de dança',
		label: '262820 - Dramaturgo de dança',
	},
	{
		value: '262825 - Ensaiador de dança',
		label: '262825 - Ensaiador de dança',
	},
	{
		value: '262830 - Professor de dança',
		label: '262830 - Professor de dança',
	},
	{
		value: '262905 - Decorador de interiores de nível superior',
		label: '262905 - Decorador de interiores de nível superior',
	},
	{ value: '263115 - Teólogo', label: '263115 - Teólogo' },
	{ value: '263110 - Missionário', label: '263110 - Missionário' },
	{
		value: '263105 - Ministro de culto religioso',
		label: '263105 - Ministro de culto religioso',
	},
	{
		value: '271110 - Tecnólogo em gastronomia',
		label: '271110 - Tecnólogo em gastronomia',
	},
	{ value: '271105 - Chefe de cozinha', label: '271105 - Chefe de cozinha' },
	{
		value: '300105 - Técnico em mecatrônica - automação da manufatura',
		label: '300105 - Técnico em mecatrônica - automação da manufatura',
	},
	{
		value: '300110 - Técnico em mecatrônica - robótica',
		label: '300110 - Técnico em mecatrônica - robótica',
	},
	{
		value: '300305 - Técnico em eletromecânica',
		label: '300305 - Técnico em eletromecânica',
	},
	{
		value: '301105 - Técnico de laboratório industrial',
		label: '301105 - Técnico de laboratório industrial',
	},
	{
		value: '301110 - Técnico de laboratório de análises físico-químicas (materiais de construção)',
		label: '301110 - Técnico de laboratório de análises físico-químicas (materiais de construção)',
	},
	{
		value: '301115 - Técnico químico de petróleo',
		label: '301115 - Técnico químico de petróleo',
	},
	{
		value: '301205 - Técnico de apoio à bioengenharia',
		label: '301205 - Técnico de apoio à bioengenharia',
	},
	{
		value: '311115 - Técnico em curtimento',
		label: '311115 - Técnico em curtimento',
	},
	{
		value: '311110 - Técnico de celulose e papel',
		label: '311110 - Técnico de celulose e papel',
	},
	{ value: '311105 - Técnico químico', label: '311105 - Técnico químico' },
	{
		value: '311205 - Técnico em petroquímica',
		label: '311205 - Técnico em petroquímica',
	},
	{
		value: '311305 - Técnico em materiais, produtos cerâmicos e vidros',
		label: '311305 - Técnico em materiais, produtos cerâmicos e vidros',
	},
	{
		value: '311405 - Técnico em borracha',
		label: '311405 - Técnico em borracha',
	},
	{
		value: '311410 - Técnico em plástico',
		label: '311410 - Técnico em plástico',
	},
	{
		value: '311515 - Técnico de utilidade (produção e distribuição de vapor, gases, óleos, combustíveis, energia)',
		label: '311515 - Técnico de utilidade (produção e distribuição de vapor, gases, óleos, combustíveis, energia)',
	},
	{
		value: '311510 - Técnico de meteorologia',
		label: '311510 - Técnico de meteorologia',
	},
	{
		value: '311505 - Técnico de controle de meio ambiente',
		label: '311505 - Técnico de controle de meio ambiente',
	},
	{
		value: '311520 - Técnico em tratamento de efluentes',
		label: '311520 - Técnico em tratamento de efluentes',
	},
	{ value: '311605 - Técnico têxtil', label: '311605 - Técnico têxtil' },
	{
		value: '311610 - Técnico têxtil (tratamentos químicos)',
		label: '311610 - Técnico têxtil (tratamentos químicos)',
	},
	{
		value: '311615 - Técnico têxtil de fiação',
		label: '311615 - Técnico têxtil de fiação',
	},
	{
		value: '311620 - Técnico têxtil de malharia',
		label: '311620 - Técnico têxtil de malharia',
	},
	{
		value: '311625 - Técnico têxtil de tecelagem',
		label: '311625 - Técnico têxtil de tecelagem',
	},
	{
		value: '311705 - Colorista de papel',
		label: '311705 - Colorista de papel',
	},
	{ value: '311710 - Colorista têxtil', label: '311710 - Colorista têxtil' },
	{
		value: '311715 - Preparador de tintas',
		label: '311715 - Preparador de tintas',
	},
	{
		value: '311720 - Preparador de tintas (fábrica de tecidos)',
		label: '311720 - Preparador de tintas (fábrica de tecidos)',
	},
	{
		value: '311725 - Tingidor de couros e peles',
		label: '311725 - Tingidor de couros e peles',
	},
	{
		value: '312105 - Técnico de obras civis',
		label: '312105 - Técnico de obras civis',
	},
	{
		value: '312210 - Técnico de saneamento',
		label: '312210 - Técnico de saneamento',
	},
	{
		value: '312205 - Técnico de estradas',
		label: '312205 - Técnico de estradas',
	},
	{
		value: '312315 - Técnico em hidrografia',
		label: '312315 - Técnico em hidrografia',
	},
	{
		value: '312310 - Técnico em geodésia e cartografia',
		label: '312310 - Técnico em geodésia e cartografia',
	},
	{ value: '312320 - Topógrafo', label: '312320 - Topógrafo' },
	{
		value: '312305 - Técnico em agrimensura',
		label: '312305 - Técnico em agrimensura',
	},
	{
		value: '313130 - Técnico eletricista',
		label: '313130 - Técnico eletricista',
	},
	{
		value: '313125 - Técnico de manutenção elétrica de máquina',
		label: '313125 - Técnico de manutenção elétrica de máquina',
	},
	{
		value: '313120 - Técnico de manutenção elétrica',
		label: '313120 - Técnico de manutenção elétrica',
	},
	{
		value: '313115 - Eletrotécnico na fabricação, montagem e instalação de máquinas e equipamentos',
		label: '313115 - Eletrotécnico na fabricação, montagem e instalação de máquinas e equipamentos',
	},
	{
		value: '313110 - Eletrotécnico (produção de energia)',
		label: '313110 - Eletrotécnico (produção de energia)',
	},
	{ value: '313105 - Eletrotécnico', label: '313105 - Eletrotécnico' },
	{
		value: '313215 - Técnico eletrônico',
		label: '313215 - Técnico eletrônico',
	},
	{
		value: '313220 - Técnico em manutenção de equipamentos de informática',
		label: '313220 - Técnico em manutenção de equipamentos de informática',
	},
	{
		value: '313210 - Técnico de manutenção eletrônica (circuitos de máquinas com comando numérico)',
		label: '313210 - Técnico de manutenção eletrônica (circuitos de máquinas com comando numérico)',
	},
	{
		value: '313205 - Técnico de manutenção eletrônica',
		label: '313205 - Técnico de manutenção eletrônica',
	},
	{
		value: '313320 - Técnico de transmissão (telecomunicações)',
		label: '313320 - Técnico de transmissão (telecomunicações)',
	},
	{
		value: '313315 - Técnico de telecomunicações (telefonia)',
		label: '313315 - Técnico de telecomunicações (telefonia)',
	},
	{
		value: '313310 - Técnico de rede (telecomunicações)',
		label: '313310 - Técnico de rede (telecomunicações)',
	},
	{
		value: '313305 - Técnico de comunicação de dados',
		label: '313305 - Técnico de comunicação de dados',
	},
	{
		value: '313405 - Técnico em calibração',
		label: '313405 - Técnico em calibração',
	},
	{
		value: '313410 - Técnico em instrumentação',
		label: '313410 - Técnico em instrumentação',
	},
	{
		value: '313415 - Encarregado de manutenção de instrumentos de controle, medição e similares',
		label: '313415 - Encarregado de manutenção de instrumentos de controle, medição e similares',
	},
	{
		value: '313505 - Técnico em fotônica',
		label: '313505 - Técnico em fotônica',
	},
	{
		value: '314105 - Técnico em mecânica de precisão',
		label: '314105 - Técnico em mecânica de precisão',
	},
	{ value: '314110 - Técnico mecânico', label: '314110 - Técnico mecânico' },
	{
		value: '314115 - Técnico mecânico (calefação, ventilação e refrigeração)',
		label: '314115 - Técnico mecânico (calefação, ventilação e refrigeração)',
	},
	{
		value: '314120 - Técnico mecânico (máquinas)',
		label: '314120 - Técnico mecânico (máquinas)',
	},
	{
		value: '314125 - Técnico mecânico (motores)',
		label: '314125 - Técnico mecânico (motores)',
	},
	{
		value: '314205 - Técnico mecânico na fabricação de ferramentas',
		label: '314205 - Técnico mecânico na fabricação de ferramentas',
	},
	{
		value: '314210 - Técnico mecânico na manutenção de ferramentas',
		label: '314210 - Técnico mecânico na manutenção de ferramentas',
	},
	{
		value: '314305 - Técnico em automobilística',
		label: '314305 - Técnico em automobilística',
	},
	{
		value: '314310 - Técnico mecânico (aeronaves)',
		label: '314310 - Técnico mecânico (aeronaves)',
	},
	{
		value: '314315 - Técnico mecânico (embarcações)',
		label: '314315 - Técnico mecânico (embarcações)',
	},
	{
		value: '314405 - Técnico de manutenção de sistemas e instrumentos',
		label: '314405 - Técnico de manutenção de sistemas e instrumentos',
	},
	{
		value: '314410 - Técnico em manutenção de máquinas',
		label: '314410 - Técnico em manutenção de máquinas',
	},
	{
		value: '314620 - Técnico em soldagem',
		label: '314620 - Técnico em soldagem',
	},
	{
		value: '314615 - Técnico em estruturas metálicas',
		label: '314615 - Técnico em estruturas metálicas',
	},
	{
		value: '314610 - Técnico em caldeiraria',
		label: '314610 - Técnico em caldeiraria',
	},
	{
		value: '314605 - Inspetor de soldagem',
		label: '314605 - Inspetor de soldagem',
	},
	{
		value: '314625 - Tecnólogo em soldagem',
		label: '314625 - Tecnólogo em soldagem',
	},
	{
		value: '314725 - Técnico de redução na siderurgia (primeira fusão)',
		label: '314725 - Técnico de redução na siderurgia (primeira fusão)',
	},
	{
		value: '314720 - Técnico de laminação em siderurgia',
		label: '314720 - Técnico de laminação em siderurgia',
	},
	{
		value: '314715 - Técnico de fundição em siderurgia',
		label: '314715 - Técnico de fundição em siderurgia',
	},
	{
		value: '314710 - Técnico de aciaria em siderurgia',
		label: '314710 - Técnico de aciaria em siderurgia',
	},
	{
		value: '314705 - Técnico de acabamento em siderurgia',
		label: '314705 - Técnico de acabamento em siderurgia',
	},
	{
		value: '314730 - Técnico de refratário em siderurgia',
		label: '314730 - Técnico de refratário em siderurgia',
	},
	{
		value: '316115 - Técnico em geoquímica',
		label: '316115 - Técnico em geoquímica',
	},
	{
		value: '316110 - Técnico em geologia',
		label: '316110 - Técnico em geologia',
	},
	{
		value: '316105 - Técnico em geofísica',
		label: '316105 - Técnico em geofísica',
	},
	{
		value: '316120 - Técnico em geotecnia',
		label: '316120 - Técnico em geotecnia',
	},
	{
		value: '316325 - Técnico de produção em refino de petróleo',
		label: '316325 - Técnico de produção em refino de petróleo',
	},
	{
		value: '316330 - Técnico em planejamento de lavra de minas',
		label: '316330 - Técnico em planejamento de lavra de minas',
	},
	{
		value: '316335 - Desincrustador (poços de petróleo)',
		label: '316335 - Desincrustador (poços de petróleo)',
	},
	{
		value: '316320 - Técnico em pesquisa mineral',
		label: '316320 - Técnico em pesquisa mineral',
	},
	{
		value: '316315 - Técnico em processamento mineral (exceto petróleo)',
		label: '316315 - Técnico em processamento mineral (exceto petróleo)',
	},
	{
		value: '316340 - Cimentador (poços de petróleo)',
		label: '316340 - Cimentador (poços de petróleo)',
	},
	{
		value: '316305 - Técnico de mineração',
		label: '316305 - Técnico de mineração',
	},
	{
		value: '316310 - Técnico de mineração (óleo e petróleo)',
		label: '316310 - Técnico de mineração (óleo e petróleo)',
	},
	{
		value: '317105 - Programador de internet',
		label: '317105 - Programador de internet',
	},
	{
		value: '317110 - Programador de sistemas de informação',
		label: '317110 - Programador de sistemas de informação',
	},
	{
		value: '317115 - Programador de máquinas - ferramenta com comando numérico',
		label: '317115 - Programador de máquinas - ferramenta com comando numérico',
	},
	{
		value: '317120 - Programador de multimídia',
		label: '317120 - Programador de multimídia',
	},
	{
		value: '317205 - Operador de computador (inclusive microcomputador)',
		label: '317205 - Operador de computador (inclusive microcomputador)',
	},
	{
		value: '317210 - Técnico de apoio ao usuário de informática (helpdesk)',
		label: '317210 - Técnico de apoio ao usuário de informática (helpdesk)',
	},
	{
		value: '318005 - Desenhista técnico',
		label: '318005 - Desenhista técnico',
	},
	{
		value: '318015 - Desenhista detalhista',
		label: '318015 - Desenhista detalhista',
	},
	{
		value: '318010 - Desenhista copista',
		label: '318010 - Desenhista copista',
	},
	{
		value: '318120 - Desenhista técnico (instalações hidrossanitárias)',
		label: '318120 - Desenhista técnico (instalações hidrossanitárias)',
	},
	{
		value: '318105 - Desenhista técnico (arquitetura)',
		label: '318105 - Desenhista técnico (arquitetura)',
	},
	{
		value: '318110 - Desenhista técnico (cartografia)',
		label: '318110 - Desenhista técnico (cartografia)',
	},
	{
		value: '318115 - Desenhista técnico (construção civil)',
		label: '318115 - Desenhista técnico (construção civil)',
	},
	{
		value: '318215 - Desenhista técnico naval',
		label: '318215 - Desenhista técnico naval',
	},
	{
		value: '318210 - Desenhista técnico aeronáutico',
		label: '318210 - Desenhista técnico aeronáutico',
	},
	{
		value: '318205 - Desenhista técnico mecânico',
		label: '318205 - Desenhista técnico mecânico',
	},
	{
		value: '318310 - Desenhista técnico (calefação, ventilação e refrigeração)',
		label: '318310 - Desenhista técnico (calefação, ventilação e refrigeração)',
	},
	{
		value: '318305 - Desenhista técnico (eletricidade e eletrônica)',
		label: '318305 - Desenhista técnico (eletricidade e eletrônica)',
	},
	{
		value: '318425 - Desenhista técnico (mobiliário)',
		label: '318425 - Desenhista técnico (mobiliário)',
	},
	{
		value: '318420 - Desenhista técnico (indústria têxtil)',
		label: '318420 - Desenhista técnico (indústria têxtil)',
	},
	{
		value: '318415 - Desenhista técnico (ilustrações técnicas)',
		label: '318415 - Desenhista técnico (ilustrações técnicas)',
	},
	{
		value: '318410 - Desenhista técnico (ilustrações artísticas)',
		label: '318410 - Desenhista técnico (ilustrações artísticas)',
	},
	{
		value: '318430 - Desenhista técnico de embalagens, maquetes e leiautes',
		label: '318430 - Desenhista técnico de embalagens, maquetes e leiautes',
	},
	{
		value: '318405 - Desenhista técnico (artes gráficas)',
		label: '318405 - Desenhista técnico (artes gráficas)',
	},
	{
		value: '318505 - Desenhista projetista de arquitetura',
		label: '318505 - Desenhista projetista de arquitetura',
	},
	{
		value: '318510 - Desenhista projetista de construção civil',
		label: '318510 - Desenhista projetista de construção civil',
	},
	{
		value: '318605 - Desenhista projetista de máquinas',
		label: '318605 - Desenhista projetista de máquinas',
	},
	{
		value: '318610 - Desenhista projetista mecânico',
		label: '318610 - Desenhista projetista mecânico',
	},
	{
		value: '318705 - Desenhista projetista de eletricidade',
		label: '318705 - Desenhista projetista de eletricidade',
	},
	{
		value: '318710 - Desenhista projetista eletrônico',
		label: '318710 - Desenhista projetista eletrônico',
	},
	{
		value: '318805 - Projetista de móveis',
		label: '318805 - Projetista de móveis',
	},
	{
		value: '318815 - Modelista de calçados',
		label: '318815 - Modelista de calçados',
	},
	{
		value: '318810 - Modelista de roupas',
		label: '318810 - Modelista de roupas',
	},
	{
		value: '319110 - Técnico em confecções do vestuário',
		label: '319110 - Técnico em confecções do vestuário',
	},
	{
		value: '319105 - Técnico em calçados e artefatos de couro',
		label: '319105 - Técnico em calçados e artefatos de couro',
	},
	{
		value: '319205 - Técnico do mobiliário',
		label: '319205 - Técnico do mobiliário',
	},
	{
		value: '320110 - Técnico em histologia',
		label: '320110 - Técnico em histologia',
	},
	{
		value: '320105 - Técnico em bioterismo',
		label: '320105 - Técnico em bioterismo',
	},
	{ value: '321105 - Técnico agrícola', label: '321105 - Técnico agrícola' },
	{
		value: '321110 - Técnico agropecuário',
		label: '321110 - Técnico agropecuário',
	},
	{
		value: '321210 - Técnico florestal',
		label: '321210 - Técnico florestal',
	},
	{
		value: '321205 - Técnico em madeira',
		label: '321205 - Técnico em madeira',
	},
	{
		value: '321315 - Técnico em mitilicultura',
		label: '321315 - Técnico em mitilicultura',
	},
	{
		value: '321310 - Técnico em carcinicultura',
		label: '321310 - Técnico em carcinicultura',
	},
	{
		value: '321305 - Técnico em piscicultura',
		label: '321305 - Técnico em piscicultura',
	},
	{
		value: '321320 - Técnico em ranicultura',
		label: '321320 - Técnico em ranicultura',
	},
	{
		value: '322125 - Terapeuta holístico',
		label: '322125 - Terapeuta holístico',
	},
	{ value: '322135 - Doula', label: '322135 - Doula' },
	{ value: '322120 - Massoterapeuta', label: '322120 - Massoterapeuta' },
	{
		value: '322115 - Técnico em quiropraxia',
		label: '322115 - Técnico em quiropraxia',
	},
	{ value: '322110 - Podólogo', label: '322110 - Podólogo' },
	{
		value: '322105 - Técnico em acupuntura',
		label: '322105 - Técnico em acupuntura',
	},
	{ value: '322130 - Esteticista', label: '322130 - Esteticista' },
	{
		value: '322215 - Técnico de enfermagem do trabalho',
		label: '322215 - Técnico de enfermagem do trabalho',
	},
	{
		value: '322250 - Auxiliar de enfermagem da estratégia de saúde da família',
		label: '322250 - Auxiliar de enfermagem da estratégia de saúde da família',
	},
	{
		value: '322245 - Técnico de enfermagem da estratégia de saúde da família',
		label: '322245 - Técnico de enfermagem da estratégia de saúde da família',
	},
	{
		value: '322240 - Auxiliar de saúde (navegação marítima)',
		label: '322240 - Auxiliar de saúde (navegação marítima)',
	},
	{
		value: '322235 - Auxiliar de enfermagem do trabalho',
		label: '322235 - Auxiliar de enfermagem do trabalho',
	},
	{
		value: '322230 - Auxiliar de enfermagem',
		label: '322230 - Auxiliar de enfermagem',
	},
	{
		value: '322225 - Instrumentador cirúrgico',
		label: '322225 - Instrumentador cirúrgico',
	},
	{
		value: '322220 - Técnico de enfermagem psiquiátrica',
		label: '322220 - Técnico de enfermagem psiquiátrica',
	},
	{
		value: '322210 - Técnico de enfermagem de terapia intensiva',
		label: '322210 - Técnico de enfermagem de terapia intensiva',
	},
	{
		value: '322205 - Técnico de enfermagem',
		label: '322205 - Técnico de enfermagem',
	},
	{
		value: '322305 - Técnico em óptica e optometria',
		label: '322305 - Técnico em óptica e optometria',
	},
	{
		value: '322410 - Protético dentário',
		label: '322410 - Protético dentário',
	},
	{
		value: '322415 - Auxiliar em saúde bucal',
		label: '322415 - Auxiliar em saúde bucal',
	},
	{
		value: '322420 - Auxiliar de prótese dentária',
		label: '322420 - Auxiliar de prótese dentária',
	},
	{
		value: '322425 - Técnico em saúde bucal da estratégia de saúde da família',
		label: '322425 - Técnico em saúde bucal da estratégia de saúde da família',
	},
	{
		value: '322430 - Auxiliar em saúde bucal da estratégia de saúde da família',
		label: '322430 - Auxiliar em saúde bucal da estratégia de saúde da família',
	},
	{
		value: '322405 - Técnico em saúde bucal',
		label: '322405 - Técnico em saúde bucal',
	},
	{
		value: '322505 - Técnico de ortopedia',
		label: '322505 - Técnico de ortopedia',
	},
	{
		value: '322605 - Técnico de imobilização ortopédica',
		label: '322605 - Técnico de imobilização ortopédica',
	},
	{
		value: '323105 - Técnico em pecuária',
		label: '323105 - Técnico em pecuária',
	},
	{
		value: '324130 - Técnico em espirometria',
		label: '324130 - Técnico em espirometria',
	},
	{
		value: '324125 - Tecnólogo oftálmico',
		label: '324125 - Tecnólogo oftálmico',
	},
	{
		value: '324120 - Tecnólogo em radiologia',
		label: '324120 - Tecnólogo em radiologia',
	},
	{
		value: '324115 - Técnico em radiologia e imagenologia',
		label: '324115 - Técnico em radiologia e imagenologia',
	},
	{
		value: '324105 - Técnico em métodos eletrográficos em encefalografia',
		label: '324105 - Técnico em métodos eletrográficos em encefalografia',
	},
	{
		value: '324110 - Técnico em métodos gráficos em cardiologia',
		label: '324110 - Técnico em métodos gráficos em cardiologia',
	},
	{
		value: '324205 - Técnico em patologia clínica',
		label: '324205 - Técnico em patologia clínica',
	},
	{ value: '324215 - Citotécnico', label: '324215 - Citotécnico' },
	{
		value: '324220 - Técnico em hemoterapia',
		label: '324220 - Técnico em hemoterapia',
	},
	{ value: '325015 - Perfumista', label: '325015 - Perfumista' },
	{ value: '325010 - Aromista', label: '325010 - Aromista' },
	{ value: '325005 - Enólogo', label: '325005 - Enólogo' },
	{
		value: '325110 - Técnico em laboratório de farmácia',
		label: '325110 - Técnico em laboratório de farmácia',
	},
	{
		value: '325105 - Auxiliar técnico em laboratório de farmácia',
		label: '325105 - Auxiliar técnico em laboratório de farmácia',
	},
	{
		value: '325115 - Técnico em farmácia',
		label: '325115 - Técnico em farmácia',
	},
	{
		value: '325205 - Técnico de alimentos',
		label: '325205 - Técnico de alimentos',
	},
	{
		value: '325210 - Técnico em nutrição e dietética',
		label: '325210 - Técnico em nutrição e dietética',
	},
	{
		value: '325305 - Técnico em biotecnologia',
		label: '325305 - Técnico em biotecnologia',
	},
	{
		value: '325310 - Técnico em imunobiológicos',
		label: '325310 - Técnico em imunobiológicos',
	},
	{ value: '328110 - Taxidermista', label: '328110 - Taxidermista' },
	{ value: '328105 - Embalsamador', label: '328105 - Embalsamador' },
	{
		value: '331105 - Professor de nível médio na educação infantil',
		label: '331105 - Professor de nível médio na educação infantil',
	},
	{
		value: '331110 - Auxiliar de desenvolvimento infantil',
		label: '331110 - Auxiliar de desenvolvimento infantil',
	},
	{
		value: '331205 - Professor de nível médio no ensino fundamental',
		label: '331205 - Professor de nível médio no ensino fundamental',
	},
	{
		value: '331305 - Professor de nível médio no ensino profissionalizante',
		label: '331305 - Professor de nível médio no ensino profissionalizante',
	},
	{
		value: '332105 - Professor leigo no ensino fundamental',
		label: '332105 - Professor leigo no ensino fundamental',
	},
	{
		value: '332205 - Professor prático no ensino profissionalizante',
		label: '332205 - Professor prático no ensino profissionalizante',
	},
	{
		value: '333105 - Instrutor de auto-escola',
		label: '333105 - Instrutor de auto-escola',
	},
	{
		value: '333110 - Instrutor de cursos livres',
		label: '333110 - Instrutor de cursos livres',
	},
	{
		value: '333115 - Professores de cursos livres',
		label: '333115 - Professores de cursos livres',
	},
	{
		value: '334110 - Inspetor de alunos de escola pública',
		label: '334110 - Inspetor de alunos de escola pública',
	},
	{
		value: '334105 - Inspetor de alunos de escola privada',
		label: '334105 - Inspetor de alunos de escola privada',
	},
	{
		value: '334115 - Monitor de transporte escolar',
		label: '334115 - Monitor de transporte escolar',
	},
	{ value: '341120 - Piloto agrícola', label: '341120 - Piloto agrícola' },
	{ value: '341115 - Mecânico de vôo', label: '341115 - Mecânico de vôo' },
	{
		value: '341110 - Piloto comercial de helicóptero (exceto linhas aéreas)',
		label: '341110 - Piloto comercial de helicóptero (exceto linhas aéreas)',
	},
	{
		value: '341105 - Piloto comercial (exceto linhas aéreas)',
		label: '341105 - Piloto comercial (exceto linhas aéreas)',
	},
	{
		value: '341250 - Auxiliar técnico de sinalização nautica',
		label: '341250 - Auxiliar técnico de sinalização nautica',
	},
	{ value: '341230 - Piloto fluvial', label: '341230 - Piloto fluvial' },
	{
		value: '341225 - Patrão de pesca na navegação interior',
		label: '341225 - Patrão de pesca na navegação interior',
	},
	{
		value: '341220 - Patrão de pesca de alto-mar',
		label: '341220 - Patrão de pesca de alto-mar',
	},
	{ value: '341215 - Mestre fluvial', label: '341215 - Mestre fluvial' },
	{
		value: '341210 - Mestre de cabotagem',
		label: '341210 - Mestre de cabotagem',
	},
	{
		value: '341205 - Contramestre de cabotagem',
		label: '341205 - Contramestre de cabotagem',
	},
	{
		value: '341235 - Ténico em sinalização nautica',
		label: '341235 - Ténico em sinalização nautica',
	},
	{
		value: '341245 - Técnico em sinais navais',
		label: '341245 - Técnico em sinais navais',
	},
	{
		value: '341240 - Técnicos em manobras em equipamentos de convés',
		label: '341240 - Técnicos em manobras em equipamentos de convés',
	},
	{
		value: '341305 - Condutor maquinista motorista fluvial',
		label: '341305 - Condutor maquinista motorista fluvial',
	},
	{
		value: '341320 - Condutor de máquinas (bombeador)',
		label: '341320 - Condutor de máquinas (bombeador)',
	},
	{
		value: '341310 - Condutor de máquinas',
		label: '341310 - Condutor de máquinas',
	},
	{
		value: '341315 - Eletricista de bordo',
		label: '341315 - Eletricista de bordo',
	},
	{
		value: '341325 - Condutor de máquinas (mecânico)',
		label: '341325 - Condutor de máquinas (mecânico)',
	},
	{
		value: '342105 - Analista de transporte em comércio exterior',
		label: '342105 - Analista de transporte em comércio exterior',
	},
	{
		value: '342110 - Operador de transporte multimodal',
		label: '342110 - Operador de transporte multimodal',
	},
	{
		value: '342115 - Controlador de serviços de máquinas e veículos',
		label: '342115 - Controlador de serviços de máquinas e veículos',
	},
	{ value: '342120 - Afretador', label: '342120 - Afretador' },
	{
		value: '342125 - Tecnólogo em logística de transporte',
		label: '342125 - Tecnólogo em logística de transporte',
	},
	{
		value: '342215 - Analista de desembaraço aduaneiro',
		label: '342215 - Analista de desembaraço aduaneiro',
	},
	{
		value: '342205 - Ajudante de despachante aduaneiro',
		label: '342205 - Ajudante de despachante aduaneiro',
	},
	{
		value: '342210 - Despachante aduaneiro',
		label: '342210 - Despachante aduaneiro',
	},
	{
		value: '342315 - Supervisor de carga e descarga',
		label: '342315 - Supervisor de carga e descarga',
	},
	{
		value: '342305 - Chefe de serviço de transporte rodoviário (passageiros e cargas)',
		label: '342305 - Chefe de serviço de transporte rodoviário (passageiros e cargas)',
	},
	{
		value: '342310 - Inspetor de serviços de transportes rodoviários (passageiros e cargas)',
		label: '342310 - Inspetor de serviços de transportes rodoviários (passageiros e cargas)',
	},
	{
		value: '342405 - Agente de estação (ferrovia e metrô)',
		label: '342405 - Agente de estação (ferrovia e metrô)',
	},
	{
		value: '342410 - Operador de centro de controle (ferrovia e metrô)',
		label: '342410 - Operador de centro de controle (ferrovia e metrô)',
	},
	{
		value: '342515 - Fiscal de aviação civil (fac)',
		label: '342515 - Fiscal de aviação civil (fac)',
	},
	{
		value: '342510 - Despachante operacional de vôo',
		label: '342510 - Despachante operacional de vôo',
	},
	{
		value: '342505 - Controlador de tráfego aéreo',
		label: '342505 - Controlador de tráfego aéreo',
	},
	{
		value: '342550 - Agente de proteção de aviação civil',
		label: '342550 - Agente de proteção de aviação civil',
	},
	{
		value: '342545 - Supervisor de empresa aérea em aeroportos',
		label: '342545 - Supervisor de empresa aérea em aeroportos',
	},
	{
		value: '342540 - Supervisor da administração de aeroportos',
		label: '342540 - Supervisor da administração de aeroportos',
	},
	{
		value: '342535 - Operador de atendimento aeroviário',
		label: '342535 - Operador de atendimento aeroviário',
	},
	{
		value: '342520 - Gerente da administração de aeroportos',
		label: '342520 - Gerente da administração de aeroportos',
	},
	{
		value: '342525 - Gerente de empresa aérea em aeroportos',
		label: '342525 - Gerente de empresa aérea em aeroportos',
	},
	{
		value: '342530 - Inspetor de aviação civil',
		label: '342530 - Inspetor de aviação civil',
	},
	{
		value: '342605 - Chefe de estação portuária',
		label: '342605 - Chefe de estação portuária',
	},
	{
		value: '342610 - Supervisor de operações portuárias',
		label: '342610 - Supervisor de operações portuárias',
	},
	{
		value: '351105 - Técnico de contabilidade',
		label: '351105 - Técnico de contabilidade',
	},
	{
		value: '351110 - Chefe de contabilidade (técnico)',
		label: '351110 - Chefe de contabilidade (técnico)',
	},
	{
		value: '351115 - Consultor contábil (técnico)',
		label: '351115 - Consultor contábil (técnico)',
	},
	{
		value: '351305 - Técnico em administração',
		label: '351305 - Técnico em administração',
	},
	{
		value: '351310 - Técnico em administração de comércio exterior',
		label: '351310 - Técnico em administração de comércio exterior',
	},
	{
		value: '351315 - Agente de recrutamento e seleção',
		label: '351315 - Agente de recrutamento e seleção',
	},
	{ value: '351405 - Escrevente', label: '351405 - Escrevente' },
	{
		value: '351410 - Escrivão judicial',
		label: '351410 - Escrivão judicial',
	},
	{
		value: '351430 - Auxiliar de serviços jurídicos',
		label: '351430 - Auxiliar de serviços jurídicos',
	},
	{
		value: '351425 - Oficial de justiça',
		label: '351425 - Oficial de justiça',
	},
	{
		value: '351415 - Escrivão extra - judicial',
		label: '351415 - Escrivão extra - judicial',
	},
	{
		value: '351420 - Escrivão de polícia',
		label: '351420 - Escrivão de polícia',
	},
	{ value: '351510 - Taquígrafo', label: '351510 - Taquígrafo' },
	{
		value: '351505 - Técnico em secretariado',
		label: '351505 - Técnico em secretariado',
	},
	{ value: '351515 - Estenotipista', label: '351515 - Estenotipista' },
	{
		value: '351610 - Técnico em higiene ocupacional',
		label: '351610 - Técnico em higiene ocupacional',
	},
	{
		value: '351605 - Técnico em segurança do trabalho',
		label: '351605 - Técnico em segurança do trabalho',
	},
	{
		value: '351705 - Analista de seguros (técnico)',
		label: '351705 - Analista de seguros (técnico)',
	},
	{
		value: '351725 - Inspetor de risco',
		label: '351725 - Inspetor de risco',
	},
	{
		value: '351740 - Técnico de seguros',
		label: '351740 - Técnico de seguros',
	},
	{
		value: '351735 - Técnico de resseguros',
		label: '351735 - Técnico de resseguros',
	},
	{
		value: '351730 - Inspetor de sinistros',
		label: '351730 - Inspetor de sinistros',
	},
	{
		value: '351720 - Assistente técnico de seguros',
		label: '351720 - Assistente técnico de seguros',
	},
	{
		value: '351715 - Assistente comercial de seguros',
		label: '351715 - Assistente comercial de seguros',
	},
	{
		value: '351710 - Analista de sinistros',
		label: '351710 - Analista de sinistros',
	},
	{
		value: '351810 - Investigador de polícia',
		label: '351810 - Investigador de polícia',
	},
	{
		value: '351805 - Detetive profissional',
		label: '351805 - Detetive profissional',
	},
	{
		value: '351815 - Papiloscopista policial',
		label: '351815 - Papiloscopista policial',
	},
	{
		value: '351910 - Agente técnico de inteligência',
		label: '351910 - Agente técnico de inteligência',
	},
	{
		value: '351905 - Agente de inteligência',
		label: '351905 - Agente de inteligência',
	},
	{
		value: '352205 - Agente de defesa ambiental',
		label: '352205 - Agente de defesa ambiental',
	},
	{
		value: '352210 - Agente de saúde pública',
		label: '352210 - Agente de saúde pública',
	},
	{ value: '352305 - Metrologista', label: '352305 - Metrologista' },
	{
		value: '352315 - Agente fiscal metrológico',
		label: '352315 - Agente fiscal metrológico',
	},
	{
		value: '352310 - Agente fiscal de qualidade',
		label: '352310 - Agente fiscal de qualidade',
	},
	{
		value: '352320 - Agente fiscal têxtil',
		label: '352320 - Agente fiscal têxtil',
	},
	{
		value: '352410 - Avaliador de produtos do meio de comunicação',
		label: '352410 - Avaliador de produtos do meio de comunicação',
	},
	{
		value: '352405 - Agente de direitos autorais',
		label: '352405 - Agente de direitos autorais',
	},
	{
		value: '352420 - Técnico em direitos autorais',
		label: '352420 - Técnico em direitos autorais',
	},
	{
		value: '353215 - Técnico de operações e serviços bancários - crédito rural',
		label: '353215 - Técnico de operações e serviços bancários - crédito rural',
	},
	{
		value: '353220 - Técnico de operações e serviços bancários - leasing',
		label: '353220 - Técnico de operações e serviços bancários - leasing',
	},
	{
		value: '353225 - Técnico de operações e serviços bancários - renda fixa e variável',
		label: '353225 - Técnico de operações e serviços bancários - renda fixa e variável',
	},
	{
		value: '353210 - Técnico de operações e serviços bancários - crédito imobiliário',
		label: '353210 - Técnico de operações e serviços bancários - crédito imobiliário',
	},
	{
		value: '353235 - Chefe de serviços bancários',
		label: '353235 - Chefe de serviços bancários',
	},
	{
		value: '353230 - Tesoureiro de banco',
		label: '353230 - Tesoureiro de banco',
	},
	{
		value: '353205 - Técnico de operações e serviços bancários - câmbio',
		label: '353205 - Técnico de operações e serviços bancários - câmbio',
	},
	{
		value: '354140 - Técnico em atendimento e vendas',
		label: '354140 - Técnico em atendimento e vendas',
	},
	{
		value: '354135 - Técnico de vendas',
		label: '354135 - Técnico de vendas',
	},
	{
		value: '354130 - Promotor de vendas especializado',
		label: '354130 - Promotor de vendas especializado',
	},
	{
		value: '354125 - Assistente de vendas',
		label: '354125 - Assistente de vendas',
	},
	{
		value: '354120 - Agente de vendas de serviços',
		label: '354120 - Agente de vendas de serviços',
	},
	{
		value: '354145 - Vendedor pracista',
		label: '354145 - Vendedor pracista',
	},
	{
		value: '354150 - Propagandista de produtos famacêuticos',
		label: '354150 - Propagandista de produtos famacêuticos',
	},
	{ value: '354205 - Comprador', label: '354205 - Comprador' },
	{
		value: '354210 - Supervisor de compras',
		label: '354210 - Supervisor de compras',
	},
	{
		value: '354305 - Analista de exportação e importação',
		label: '354305 - Analista de exportação e importação',
	},
	{
		value: '354410 - Avaliador de imóveis',
		label: '354410 - Avaliador de imóveis',
	},
	{
		value: '354415 - Avaliador de bens móveis',
		label: '354415 - Avaliador de bens móveis',
	},
	{ value: '354405 - Leiloeiro', label: '354405 - Leiloeiro' },
	{
		value: '354505 - Corretor de seguros',
		label: '354505 - Corretor de seguros',
	},
	{
		value: '354605 - Corretor de imóveis',
		label: '354605 - Corretor de imóveis',
	},
	{
		value: '354705 - Representante comercial autônomo',
		label: '354705 - Representante comercial autônomo',
	},
	{
		value: '354820 - Organizador de evento',
		label: '354820 - Organizador de evento',
	},
	{ value: '354815 - Agente de viagem', label: '354815 - Agente de viagem' },
	{
		value: '354810 - Operador de turismo',
		label: '354810 - Operador de turismo',
	},
	{
		value: '354805 - Técnico em turismo',
		label: '354805 - Técnico em turismo',
	},
	{ value: '354825 - Cerimonialista', label: '354825 - Cerimonialista' },
	{
		value: '371105 - Auxiliar de biblioteca',
		label: '371105 - Auxiliar de biblioteca',
	},
	{
		value: '371110 - Técnico em biblioteconomia',
		label: '371110 - Técnico em biblioteconomia',
	},
	{
		value: '371210 - Técnico em museologia',
		label: '371210 - Técnico em museologia',
	},
	{
		value: '371205 - Colecionador de selos e moedas',
		label: '371205 - Colecionador de selos e moedas',
	},
	{
		value: '371305 - Técnico em programação visual',
		label: '371305 - Técnico em programação visual',
	},
	{ value: '371310 - Técnico gráfico', label: '371310 - Técnico gráfico' },
	{
		value: '371405 - Recreador de acantonamento',
		label: '371405 - Recreador de acantonamento',
	},
	{ value: '371410 - Recreador', label: '371410 - Recreador' },
	{
		value: '372105 - Diretor de fotografia',
		label: '372105 - Diretor de fotografia',
	},
	{
		value: '372110 - Iluminador (televisão)',
		label: '372110 - Iluminador (televisão)',
	},
	{
		value: '372115 - Operador de câmera de televisão',
		label: '372115 - Operador de câmera de televisão',
	},
	{
		value: '372205 - Operador de rede de teleprocessamento',
		label: '372205 - Operador de rede de teleprocessamento',
	},
	{
		value: '372210 - Radiotelegrafista',
		label: '372210 - Radiotelegrafista',
	},
	{
		value: '373105 - Operador de áudio de continuidade (rádio)',
		label: '373105 - Operador de áudio de continuidade (rádio)',
	},
	{
		value: '373110 - Operador de central de rádio',
		label: '373110 - Operador de central de rádio',
	},
	{
		value: '373115 - Operador de externa (rádio)',
		label: '373115 - Operador de externa (rádio)',
	},
	{
		value: '373120 - Operador de gravação de rádio',
		label: '373120 - Operador de gravação de rádio',
	},
	{
		value: '373125 - Operador de transmissor de rádio',
		label: '373125 - Operador de transmissor de rádio',
	},
	{
		value: '373205 - Técnico em operação de equipamentos de produção para televisão  e produtoras de vídeo',
		label: '373205 - Técnico em operação de equipamentos de produção para televisão  e produtoras de vídeo',
	},
	{
		value: '373210 - Técnico em operação de equipamento de exibição de televisão',
		label: '373210 - Técnico em operação de equipamento de exibição de televisão',
	},
	{
		value: '373215 - Técnico em operação de equipamentos de transmissão/recepção de televisão',
		label: '373215 - Técnico em operação de equipamentos de transmissão/recepção de televisão',
	},
	{
		value: '373220 - Supervisor técnico operacional de sistemas de televisão e produtoras de vídeo',
		label: '373220 - Supervisor técnico operacional de sistemas de televisão e produtoras de vídeo',
	},
	{
		value: '374105 - Técnico em gravação de áudio',
		label: '374105 - Técnico em gravação de áudio',
	},
	{
		value: '374110 - Técnico em instalação de equipamentos de áudio',
		label: '374110 - Técnico em instalação de equipamentos de áudio',
	},
	{ value: '374145 - Dj (disc jockey)', label: '374145 - Dj (disc jockey)' },
	{ value: '374140 - Microfonista', label: '374140 - Microfonista' },
	{
		value: '374135 - Projetista de sistemas de áudio',
		label: '374135 - Projetista de sistemas de áudio',
	},
	{
		value: '374130 - Técnico em mixagem de áudio',
		label: '374130 - Técnico em mixagem de áudio',
	},
	{
		value: '374125 - Técnico em sonorização',
		label: '374125 - Técnico em sonorização',
	},
	{
		value: '374120 - Projetista de som',
		label: '374120 - Projetista de som',
	},
	{
		value: '374115 - Técnico em masterização de áudio',
		label: '374115 - Técnico em masterização de áudio',
	},
	{
		value: '374205 - Cenotécnico (cinema, vídeo, televisão, teatro e espetáculos)',
		label: '374205 - Cenotécnico (cinema, vídeo, televisão, teatro e espetáculos)',
	},
	{
		value: '374210 - Maquinista de cinema e vídeo',
		label: '374210 - Maquinista de cinema e vídeo',
	},
	{
		value: '374215 - Maquinista de teatro e espetáculos',
		label: '374215 - Maquinista de teatro e espetáculos',
	},
	{
		value: '374310 - Operador-mantenedor de projetor cinematográfico',
		label: '374310 - Operador-mantenedor de projetor cinematográfico',
	},
	{
		value: '374305 - Operador de projetor cinematográfico',
		label: '374305 - Operador de projetor cinematográfico',
	},
	{
		value: '374415 - Finalizador de vídeo',
		label: '374415 - Finalizador de vídeo',
	},
	{
		value: '374410 - Finalizador de filmes',
		label: '374410 - Finalizador de filmes',
	},
	{
		value: '374420 - Montador de filmes',
		label: '374420 - Montador de filmes',
	},
	{
		value: '374405 - Editor de tv  e vídeo',
		label: '374405 - Editor de tv  e vídeo',
	},
	{
		value: '375105 - Designer de interiores',
		label: '375105 - Designer de interiores',
	},
	{
		value: '375120 - Decorador de eventos',
		label: '375120 - Decorador de eventos',
	},
	{
		value: '375115 - Visual merchandiser',
		label: '375115 - Visual merchandiser',
	},
	{
		value: '375110 - Designer de vitrines',
		label: '375110 - Designer de vitrines',
	},
	{
		value: '376105 - Dançarino tradicional',
		label: '376105 - Dançarino tradicional',
	},
	{
		value: '376110 - Dançarino popular',
		label: '376110 - Dançarino popular',
	},
	{ value: '376210 - Artista aéreo', label: '376210 - Artista aéreo' },
	{ value: '376205 - Acrobata', label: '376205 - Acrobata' },
	{ value: '376250 - Titeriteiro', label: '376250 - Titeriteiro' },
	{ value: '376245 - Palhaço', label: '376245 - Palhaço' },
	{
		value: '376225 - Domador de animais (circense)',
		label: '376225 - Domador de animais (circense)',
	},
	{ value: '376230 - Equilibrista', label: '376230 - Equilibrista' },
	{ value: '376235 - Mágico', label: '376235 - Mágico' },
	{ value: '376240 - Malabarista', label: '376240 - Malabarista' },
	{
		value: '376215 - Artista de circo (outros)',
		label: '376215 - Artista de circo (outros)',
	},
	{ value: '376220 - Contorcionista', label: '376220 - Contorcionista' },
	{ value: '376255 - Trapezista', label: '376255 - Trapezista' },
	{
		value: '376330 - Mestre de cerimonias',
		label: '376330 - Mestre de cerimonias',
	},
	{
		value: '376325 - Apresentador de circo',
		label: '376325 - Apresentador de circo',
	},
	{
		value: '376315 - Apresentador de programas de rádio',
		label: '376315 - Apresentador de programas de rádio',
	},
	{
		value: '376310 - Apresentador de festas populares',
		label: '376310 - Apresentador de festas populares',
	},
	{
		value: '376305 - Apresentador de eventos',
		label: '376305 - Apresentador de eventos',
	},
	{
		value: '376320 - Apresentador de programas de televisão',
		label: '376320 - Apresentador de programas de televisão',
	},
	{ value: '376405 - Modelo artístico', label: '376405 - Modelo artístico' },
	{ value: '376410 - Modelo de modas', label: '376410 - Modelo de modas' },
	{
		value: '376415 - Modelo publicitário',
		label: '376415 - Modelo publicitário',
	},
	{
		value: '377120 - Atleta profissional de luta',
		label: '377120 - Atleta profissional de luta',
	},
	{
		value: '377125 - Atleta profissional de tênis',
		label: '377125 - Atleta profissional de tênis',
	},
	{ value: '377130 - Jóquei', label: '377130 - Jóquei' },
	{
		value: '377135 - Piloto de competição automobilística',
		label: '377135 - Piloto de competição automobilística',
	},
	{
		value: '377140 - Profissional de atletismo',
		label: '377140 - Profissional de atletismo',
	},
	{ value: '377145 - Pugilista', label: '377145 - Pugilista' },
	{
		value: '377105 - Atleta profissional (outras modalidades)',
		label: '377105 - Atleta profissional (outras modalidades)',
	},
	{
		value: '377110 - Atleta profissional de futebol',
		label: '377110 - Atleta profissional de futebol',
	},
	{
		value: '377115 - Atleta profissional de golfe',
		label: '377115 - Atleta profissional de golfe',
	},
	{
		value: '377205 - Árbitro desportivo',
		label: '377205 - Árbitro desportivo',
	},
	{
		value: '377210 - Árbitro de atletismo',
		label: '377210 - Árbitro de atletismo',
	},
	{
		value: '377215 - Árbitro de basquete',
		label: '377215 - Árbitro de basquete',
	},
	{
		value: '377220 - Árbitro de futebol',
		label: '377220 - Árbitro de futebol',
	},
	{ value: '377245 - Árbitro de vôlei', label: '377245 - Árbitro de vôlei' },
	{ value: '377230 - Árbitro de judô', label: '377230 - Árbitro de judô' },
	{
		value: '377235 - Árbitro de karatê',
		label: '377235 - Árbitro de karatê',
	},
	{
		value: '377240 - Árbitro de poló aquático',
		label: '377240 - Árbitro de poló aquático',
	},
	{
		value: '377225 - Árbitro de futebol de salão',
		label: '377225 - Árbitro de futebol de salão',
	},
	{ value: '391105 - Cronoanalista', label: '391105 - Cronoanalista' },
	{ value: '391110 - Cronometrista', label: '391110 - Cronometrista' },
	{
		value: '391115 - Controlador de entrada e saída',
		label: '391115 - Controlador de entrada e saída',
	},
	{ value: '391120 - Planejista', label: '391120 - Planejista' },
	{
		value: '391125 - Técnico de planejamento de produção',
		label: '391125 - Técnico de planejamento de produção',
	},
	{
		value: '391130 - Técnico de planejamento e programação da manutenção',
		label: '391130 - Técnico de planejamento e programação da manutenção',
	},
	{
		value: '391135 - Técnico de matéria-prima e material',
		label: '391135 - Técnico de matéria-prima e material',
	},
	{
		value: '391225 - Escolhedor de papel',
		label: '391225 - Escolhedor de papel',
	},
	{
		value: '391230 - Técnico operacional de serviços de correios',
		label: '391230 - Técnico operacional de serviços de correios',
	},
	{
		value: '391205 - Inspetor de qualidade',
		label: '391205 - Inspetor de qualidade',
	},
	{
		value: '391210 - Técnico de garantia da qualidade',
		label: '391210 - Técnico de garantia da qualidade',
	},
	{
		value: '391215 - Operador de inspeção de qualidade',
		label: '391215 - Operador de inspeção de qualidade',
	},
	{
		value: '391220 - Técnico de painel de controle',
		label: '391220 - Técnico de painel de controle',
	},
	{
		value: '395110 - Técnico de apoio em pesquisa e desenvolvimento agropecuário florestal',
		label: '395110 - Técnico de apoio em pesquisa e desenvolvimento agropecuário florestal',
	},
	{
		value: '395105 - Técnico de apoio em pesquisa e desenvolvimento (exceto agropecuário e florestal)',
		label: '395105 - Técnico de apoio em pesquisa e desenvolvimento (exceto agropecuário e florestal)',
	},
	{
		value: '410105 - Supervisor administrativo',
		label: '410105 - Supervisor administrativo',
	},
	{
		value: '410225 - Supervisor de crédito e cobrança',
		label: '410225 - Supervisor de crédito e cobrança',
	},
	{
		value: '410220 - Supervisor de controle patrimonial',
		label: '410220 - Supervisor de controle patrimonial',
	},
	{
		value: '410215 - Supervisor de contas a pagar',
		label: '410215 - Supervisor de contas a pagar',
	},
	{
		value: '410235 - Supervisor de tesouraria',
		label: '410235 - Supervisor de tesouraria',
	},
	{
		value: '410205 - Supervisor de almoxarifado',
		label: '410205 - Supervisor de almoxarifado',
	},
	{
		value: '410240 - Supervisor de logística',
		label: '410240 - Supervisor de logística',
	},
	{
		value: '410230 - Supervisor de orçamento',
		label: '410230 - Supervisor de orçamento',
	},
	{
		value: '410210 - Supervisor de câmbio',
		label: '410210 - Supervisor de câmbio',
	},
	{
		value: '411050 - Agente de microcrédito',
		label: '411050 - Agente de microcrédito',
	},
	{
		value: '411005 - Auxiliar de escritório',
		label: '411005 - Auxiliar de escritório',
	},
	{
		value: '411010 - Assistente administrativo',
		label: '411010 - Assistente administrativo',
	},
	{
		value: '411015 - Atendente de judiciário',
		label: '411015 - Atendente de judiciário',
	},
	{
		value: '411020 - Auxiliar de judiciário',
		label: '411020 - Auxiliar de judiciário',
	},
	{
		value: '411025 - Auxiliar de cartório',
		label: '411025 - Auxiliar de cartório',
	},
	{
		value: '411030 - Auxiliar de pessoal',
		label: '411030 - Auxiliar de pessoal',
	},
	{
		value: '411035 - Auxiliar de estatística',
		label: '411035 - Auxiliar de estatística',
	},
	{
		value: '411040 - Auxiliar de seguros',
		label: '411040 - Auxiliar de seguros',
	},
	{
		value: '411045 - Auxiliar de serviços de importação e exportação',
		label: '411045 - Auxiliar de serviços de importação e exportação',
	},
	{ value: '412105 - Datilógrafo', label: '412105 - Datilógrafo' },
	{ value: '412110 - Digitador', label: '412110 - Digitador' },
	{
		value: '412115 - Operador de mensagens de telecomunicações (correios)',
		label: '412115 - Operador de mensagens de telecomunicações (correios)',
	},
	{
		value: '412120 - Supervisor de digitação e operação',
		label: '412120 - Supervisor de digitação e operação',
	},
	{ value: '412205 - Contínuo', label: '412205 - Contínuo' },
	{
		value: '413105 - Analista de folha de pagamento',
		label: '413105 - Analista de folha de pagamento',
	},
	{
		value: '413110 - Auxiliar de contabilidade',
		label: '413110 - Auxiliar de contabilidade',
	},
	{
		value: '413115 - Auxiliar de faturamento',
		label: '413115 - Auxiliar de faturamento',
	},
	{
		value: '413205 - Atendente de agência',
		label: '413205 - Atendente de agência',
	},
	{ value: '413210 - Caixa de banco', label: '413210 - Caixa de banco' },
	{
		value: '413215 - Compensador de banco',
		label: '413215 - Compensador de banco',
	},
	{
		value: '413220 - Conferente de serviços bancários',
		label: '413220 - Conferente de serviços bancários',
	},
	{
		value: '413225 - Escriturário de banco',
		label: '413225 - Escriturário de banco',
	},
	{
		value: '413230 - Operador de cobrança bancária',
		label: '413230 - Operador de cobrança bancária',
	},
	{ value: '414125 - Estoquista', label: '414125 - Estoquista' },
	{
		value: '414135 - Expedidor de mercadorias',
		label: '414135 - Expedidor de mercadorias',
	},
	{
		value: '414140 - Auxiliar de logistica',
		label: '414140 - Auxiliar de logistica',
	},
	{ value: '414105 - Almoxarife', label: '414105 - Almoxarife' },
	{ value: '414110 - Armazenista', label: '414110 - Armazenista' },
	{ value: '414115 - Balanceiro', label: '414115 - Balanceiro' },
	{
		value: '414120 - Conferente mercadoria (exceto carga e descarga)',
		label: '414120 - Conferente mercadoria (exceto carga e descarga)',
	},
	{
		value: '414210 - Apontador de produção',
		label: '414210 - Apontador de produção',
	},
	{
		value: '414205 - Apontador de mão-de-obra',
		label: '414205 - Apontador de mão-de-obra',
	},
	{
		value: '414215 - Conferente de carga e descarga',
		label: '414215 - Conferente de carga e descarga',
	},
	{ value: '415125 - Kardexista', label: '415125 - Kardexista' },
	{
		value: '415130 - Operador de máquina copiadora (exceto operador de gráfica rápida)',
		label: '415130 - Operador de máquina copiadora (exceto operador de gráfica rápida)',
	},
	{ value: '415120 - Fitotecário', label: '415120 - Fitotecário' },
	{
		value: '415105 - Arquivista de documentos',
		label: '415105 - Arquivista de documentos',
	},
	{
		value: '415115 - Codificador de dados',
		label: '415115 - Codificador de dados',
	},
	{ value: '415205 - Carteiro', label: '415205 - Carteiro' },
	{
		value: '415215 - Entregador de publicações',
		label: '415215 - Entregador de publicações',
	},
	{
		value: '415210 - Operador de triagem e transbordo',
		label: '415210 - Operador de triagem e transbordo',
	},
	{
		value: '420135 - Supervisor de telemarketing e atendimento',
		label: '420135 - Supervisor de telemarketing e atendimento',
	},
	{
		value: '420130 - Supervisor de telefonistas',
		label: '420130 - Supervisor de telefonistas',
	},
	{
		value: '420125 - Supervisor de recepcionistas',
		label: '420125 - Supervisor de recepcionistas',
	},
	{
		value: '420120 - Supervisor de entrevistadores e recenseadores',
		label: '420120 - Supervisor de entrevistadores e recenseadores',
	},
	{
		value: '420115 - Supervisor de coletadores de apostas e de jogos',
		label: '420115 - Supervisor de coletadores de apostas e de jogos',
	},
	{
		value: '420105 - Supervisor de caixas e bilheteiros (exceto caixa de banco)',
		label: '420105 - Supervisor de caixas e bilheteiros (exceto caixa de banco)',
	},
	{
		value: '420110 - Supervisor de cobrança',
		label: '420110 - Supervisor de cobrança',
	},
	{
		value: '421120 - Emissor de passagens',
		label: '421120 - Emissor de passagens',
	},
	{
		value: '421125 - Operador de caixa',
		label: '421125 - Operador de caixa',
	},
	{
		value: '421115 - Bilheteiro no serviço de diversões',
		label: '421115 - Bilheteiro no serviço de diversões',
	},
	{
		value: '421110 - Bilheteiro de transportes coletivos',
		label: '421110 - Bilheteiro de transportes coletivos',
	},
	{
		value: '421105 - Atendente comercial (agência postal)',
		label: '421105 - Atendente comercial (agência postal)',
	},
	{
		value: '421210 - Recebedor de apostas (turfe)',
		label: '421210 - Recebedor de apostas (turfe)',
	},
	{
		value: '421205 - Recebedor de apostas (loteria)',
		label: '421205 - Recebedor de apostas (loteria)',
	},
	{
		value: '421315 - Localizador (cobrador)',
		label: '421315 - Localizador (cobrador)',
	},
	{ value: '421310 - Cobrador interno', label: '421310 - Cobrador interno' },
	{ value: '421305 - Cobrador externo', label: '421305 - Cobrador externo' },
	{
		value: '422125 - Recepcionista de banco',
		label: '422125 - Recepcionista de banco',
	},
	{
		value: '422120 - Recepcionista de hotel',
		label: '422120 - Recepcionista de hotel',
	},
	{
		value: '422115 - Recepcionista de seguro saúde',
		label: '422115 - Recepcionista de seguro saúde',
	},
	{ value: '422130 - Concierge', label: '422130 - Concierge' },
	{
		value: '422105 - Recepcionista, em geral',
		label: '422105 - Recepcionista, em geral',
	},
	{
		value: '422110 - Recepcionista de consultório médico ou dentário',
		label: '422110 - Recepcionista de consultório médico ou dentário',
	},
	{
		value: '422220 - Operador de rádio-chamada',
		label: '422220 - Operador de rádio-chamada',
	},
	{ value: '422205 - Telefonista', label: '422205 - Telefonista' },
	{ value: '422210 - Teleoperador', label: '422210 - Teleoperador' },
	{
		value: '422215 - Monitor de teleatendimento',
		label: '422215 - Monitor de teleatendimento',
	},
	{
		value: '422315 - Operador de telemarketing receptivo',
		label: '422315 - Operador de telemarketing receptivo',
	},
	{
		value: '422320 - Operador de telemarketing técnico',
		label: '422320 - Operador de telemarketing técnico',
	},
	{
		value: '422310 - Operador de telemarketing ativo e receptivo',
		label: '422310 - Operador de telemarketing ativo e receptivo',
	},
	{
		value: '422305 - Operador de telemarketing ativo',
		label: '422305 - Operador de telemarketing ativo',
	},
	{
		value: '423105 - Despachante documentalista',
		label: '423105 - Despachante documentalista',
	},
	{
		value: '423110 - Despachante de trânsito',
		label: '423110 - Despachante de trânsito',
	},
	{
		value: '424120 - Entrevistador de preços',
		label: '424120 - Entrevistador de preços',
	},
	{
		value: '424125 - Escriturário  em  estatística',
		label: '424125 - Escriturário  em  estatística',
	},
	{
		value: '424130 - Entrevistador social',
		label: '424130 - Entrevistador social',
	},
	{
		value: '424105 - Entrevistador censitário e de pesquisas amostrais',
		label: '424105 - Entrevistador censitário e de pesquisas amostrais',
	},
	{
		value: '424110 - Entrevistador de pesquisa de opinião e mídia',
		label: '424110 - Entrevistador de pesquisa de opinião e mídia',
	},
	{
		value: '424115 - Entrevistador de pesquisas de mercado',
		label: '424115 - Entrevistador de pesquisas de mercado',
	},
	{
		value: '424210 - Aplicador de provas (concurso, avaliação,exame)',
		label: '424210 - Aplicador de provas (concurso, avaliação,exame)',
	},
	{
		value: '424205 - Coordenador de provas (concurso, avaliação, exame)',
		label: '424205 - Coordenador de provas (concurso, avaliação, exame)',
	},
	{
		value: '510105 - Supervisor de transportes',
		label: '510105 - Supervisor de transportes',
	},
	{
		value: '510110 - Administrador de edifícios',
		label: '510110 - Administrador de edifícios',
	},
	{
		value: '510115 - Supervisor de andar',
		label: '510115 - Supervisor de andar',
	},
	{
		value: '510120 - Chefe de portaria de hotel',
		label: '510120 - Chefe de portaria de hotel',
	},
	{ value: '510130 - Chefe de bar', label: '510130 - Chefe de bar' },
	{ value: '510135 - Maître', label: '510135 - Maître' },
	{
		value: '510205 - Supervisor de lavanderia',
		label: '510205 - Supervisor de lavanderia',
	},
	{
		value: '510305 - Supervisor de bombeiros',
		label: '510305 - Supervisor de bombeiros',
	},
	{
		value: '510310 - Supervisor de vigilantes',
		label: '510310 - Supervisor de vigilantes',
	},
	{
		value: '511115 - Taifeiro (exceto militares)',
		label: '511115 - Taifeiro (exceto militares)',
	},
	{
		value: '511110 - Comissário de trem',
		label: '511110 - Comissário de trem',
	},
	{
		value: '511105 - Comissário de vôo',
		label: '511105 - Comissário de vôo',
	},
	{
		value: '511220 - Bilheteiro (estações de metrô, ferroviárias e assemelhadas)',
		label: '511220 - Bilheteiro (estações de metrô, ferroviárias e assemelhadas)',
	},
	{
		value: '511205 - Fiscal de transportes coletivos (exceto trem)',
		label: '511205 - Fiscal de transportes coletivos (exceto trem)',
	},
	{
		value: '511210 - Despachante de transportes coletivos (exceto trem)',
		label: '511210 - Despachante de transportes coletivos (exceto trem)',
	},
	{
		value: '511215 - Cobrador de transportes coletivos (exceto trem)',
		label: '511215 - Cobrador de transportes coletivos (exceto trem)',
	},
	{ value: '511405 - Guia de turismo', label: '511405 - Guia de turismo' },
	{
		value: '511510 - Condutor de turismo de pesca',
		label: '511510 - Condutor de turismo de pesca',
	},
	{
		value: '511505 - Condutor de turismo de aventura',
		label: '511505 - Condutor de turismo de aventura',
	},
	{
		value: '512105 - Empregado  doméstico  nos serviços gerais',
		label: '512105 - Empregado  doméstico  nos serviços gerais',
	},
	{
		value: '512120 - Empregado doméstico diarista',
		label: '512120 - Empregado doméstico diarista',
	},
	{
		value: '512115 - Empregado doméstico  faxineiro',
		label: '512115 - Empregado doméstico  faxineiro',
	},
	{
		value: '512110 - Empregado doméstico  arrumador',
		label: '512110 - Empregado doméstico  arrumador',
	},
	{
		value: '513105 - Mordomo de residência',
		label: '513105 - Mordomo de residência',
	},
	{
		value: '513110 - Mordomo de hotelaria',
		label: '513110 - Mordomo de hotelaria',
	},
	{
		value: '513115 - Governanta de hotelaria',
		label: '513115 - Governanta de hotelaria',
	},
	{ value: '513205 - Cozinheiro geral', label: '513205 - Cozinheiro geral' },
	{
		value: '513225 - Cozinheiro de embarcações',
		label: '513225 - Cozinheiro de embarcações',
	},
	{
		value: '513220 - Cozinheiro de hospital',
		label: '513220 - Cozinheiro de hospital',
	},
	{
		value: '513215 - Cozinheiro industrial',
		label: '513215 - Cozinheiro industrial',
	},
	{
		value: '513210 - Cozinheiro do serviço doméstico',
		label: '513210 - Cozinheiro do serviço doméstico',
	},
	{
		value: '513325 - Guarda-roupeira de cinema',
		label: '513325 - Guarda-roupeira de cinema',
	},
	{
		value: '513320 - Camareiro de embarcações',
		label: '513320 - Camareiro de embarcações',
	},
	{
		value: '513315 - Camareiro  de hotel',
		label: '513315 - Camareiro  de hotel',
	},
	{
		value: '513310 - Camareira de televisão',
		label: '513310 - Camareira de televisão',
	},
	{
		value: '513305 - Camareira de teatro',
		label: '513305 - Camareira de teatro',
	},
	{ value: '513440 - Barista', label: '513440 - Barista' },
	{
		value: '513430 - Copeiro de hospital',
		label: '513430 - Copeiro de hospital',
	},
	{ value: '513425 - Copeiro', label: '513425 - Copeiro' },
	{ value: '513420 - Barman', label: '513420 - Barman' },
	{ value: '513415 - Cumim', label: '513415 - Cumim' },
	{
		value: '513410 - Garçom (serviços de vinhos)',
		label: '513410 - Garçom (serviços de vinhos)',
	},
	{ value: '513405 - Garçom', label: '513405 - Garçom' },
	{
		value: '513435 - Atendente de lanchonete',
		label: '513435 - Atendente de lanchonete',
	},
	{
		value: '513505 - Auxiliar nos serviços de alimentação',
		label: '513505 - Auxiliar nos serviços de alimentação',
	},
	{ value: '513605 - Churrasqueiro', label: '513605 - Churrasqueiro' },
	{ value: '513610 - Pizzaiolo', label: '513610 - Pizzaiolo' },
	{ value: '513615 - Sushiman', label: '513615 - Sushiman' },
	{ value: '514105 - Ascensorista', label: '514105 - Ascensorista' },
	{
		value: '514120 - Zelador de edifício',
		label: '514120 - Zelador de edifício',
	},
	{ value: '514115 - Sacristão', label: '514115 - Sacristão' },
	{ value: '514110 - Garagista', label: '514110 - Garagista' },
	{ value: '514215 - Varredor de rua', label: '514215 - Varredor de rua' },
	{
		value: '514225 - Trabalhador de serviços de limpeza e conservação de áreas públicas',
		label: '514225 - Trabalhador de serviços de limpeza e conservação de áreas públicas',
	},
	{
		value: '514205 - Coletor de lixo domiciliar',
		label: '514205 - Coletor de lixo domiciliar',
	},
	{
		value: '514230 - Coletor de resíduos sólidos de serviços de saúde',
		label: '514230 - Coletor de resíduos sólidos de serviços de saúde',
	},
	{
		value: '514305 - Limpador de vidros',
		label: '514305 - Limpador de vidros',
	},
	{
		value: '514310 - Auxiliar de manutenção predial',
		label: '514310 - Auxiliar de manutenção predial',
	},
	{
		value: '514315 - Limpador de fachadas',
		label: '514315 - Limpador de fachadas',
	},
	{ value: '514320 - Faxineiro', label: '514320 - Faxineiro' },
	{
		value: '514330 - Limpador de piscinas',
		label: '514330 - Limpador de piscinas',
	},
	{
		value: '514325 - Trabalhador da manutenção de edificações',
		label: '514325 - Trabalhador da manutenção de edificações',
	},
	{
		value: '515140 - Agente de combate às endemias',
		label: '515140 - Agente de combate às endemias',
	},
	{
		value: '515105 - Agente comunitário de saúde',
		label: '515105 - Agente comunitário de saúde',
	},
	{
		value: '515110 - Atendente de enfermagem',
		label: '515110 - Atendente de enfermagem',
	},
	{
		value: '515135 - Socorrista (exceto médicos e enfermeiros)',
		label: '515135 - Socorrista (exceto médicos e enfermeiros)',
	},
	{
		value: '515120 - Visitador sanitário',
		label: '515120 - Visitador sanitário',
	},
	{
		value: '515125 - Agente indígena de saúde',
		label: '515125 - Agente indígena de saúde',
	},
	{
		value: '515130 - Agente indígena de saneamento',
		label: '515130 - Agente indígena de saneamento',
	},
	{ value: '515115 - Parteira leiga', label: '515115 - Parteira leiga' },
	{
		value: '515205 - Auxiliar de banco de sangue',
		label: '515205 - Auxiliar de banco de sangue',
	},
	{
		value: '515210 - Auxiliar de farmácia de manipulação',
		label: '515210 - Auxiliar de farmácia de manipulação',
	},
	{
		value: '515215 - Auxiliar de laboratório de análises clínicas',
		label: '515215 - Auxiliar de laboratório de análises clínicas',
	},
	{
		value: '515220 - Auxiliar de laboratório de imunobiológicos',
		label: '515220 - Auxiliar de laboratório de imunobiológicos',
	},
	{
		value: '515225 - Auxiliar de produção farmacêutica',
		label: '515225 - Auxiliar de produção farmacêutica',
	},
	{
		value: '515310 - Agente de ação social',
		label: '515310 - Agente de ação social',
	},
	{ value: '515325 - Sócioeducador', label: '515325 - Sócioeducador' },
	{
		value: '515320 - Conselheiro tutelar',
		label: '515320 - Conselheiro tutelar',
	},
	{
		value: '515315 - Monitor de dependente químico',
		label: '515315 - Monitor de dependente químico',
	},
	{ value: '515305 - Educador social', label: '515305 - Educador social' },
	{
		value: '515330 - Monitor de ressocialização prisional',
		label: '515330 - Monitor de ressocialização prisional',
	},
	{ value: '516110 - Cabeleireiro', label: '516110 - Cabeleireiro' },
	{ value: '516140 - Pedicure', label: '516140 - Pedicure' },
	{ value: '516105 - Barbeiro', label: '516105 - Barbeiro' },
	{ value: '516120 - Manicure', label: '516120 - Manicure' },
	{ value: '516125 - Maquiador', label: '516125 - Maquiador' },
	{
		value: '516130 - Maquiador de caracterização',
		label: '516130 - Maquiador de caracterização',
	},
	{
		value: '516220 - Cuidador em saúde',
		label: '516220 - Cuidador em saúde',
	},
	{ value: '516215 - Mãe social', label: '516215 - Mãe social' },
	{ value: '516205 - Babá', label: '516205 - Babá' },
	{
		value: '516210 - Cuidador de idosos',
		label: '516210 - Cuidador de idosos',
	},
	{
		value: '516305 - Lavadeiro, em geral',
		label: '516305 - Lavadeiro, em geral',
	},
	{
		value: '516310 - Lavador de roupas  a maquina',
		label: '516310 - Lavador de roupas  a maquina',
	},
	{
		value: '516345 - Auxiliar de lavanderia',
		label: '516345 - Auxiliar de lavanderia',
	},
	{
		value: '516340 - Atendente de lavanderia',
		label: '516340 - Atendente de lavanderia',
	},
	{
		value: '516335 - Conferente-expedidor de roupas (lavanderias)',
		label: '516335 - Conferente-expedidor de roupas (lavanderias)',
	},
	{
		value: '516330 - Tingidor de roupas',
		label: '516330 - Tingidor de roupas',
	},
	{
		value: '516325 - Passador de roupas em geral',
		label: '516325 - Passador de roupas em geral',
	},
	{
		value: '516315 - Lavador de artefatos de tapeçaria',
		label: '516315 - Lavador de artefatos de tapeçaria',
	},
	{
		value: '516320 - Limpador a seco, à máquina',
		label: '516320 - Limpador a seco, à máquina',
	},
	{
		value: '516415 - Passador de roupas, à mão',
		label: '516415 - Passador de roupas, à mão',
	},
	{
		value: '516410 - Limpador de roupas a seco, à mão',
		label: '516410 - Limpador de roupas a seco, à mão',
	},
	{
		value: '516405 - Lavador de roupas',
		label: '516405 - Lavador de roupas',
	},
	{ value: '516505 - Agente funerário', label: '516505 - Agente funerário' },
	{
		value: '516605 - Operador de forno (serviços funerários)',
		label: '516605 - Operador de forno (serviços funerários)',
	},
	{ value: '516610 - Sepultador', label: '516610 - Sepultador' },
	{ value: '516705 - Astrólogo', label: '516705 - Astrólogo' },
	{ value: '516710 - Numerólogo', label: '516710 - Numerólogo' },
	{ value: '516805 - Esotérico', label: '516805 - Esotérico' },
	{ value: '516810 - Paranormal', label: '516810 - Paranormal' },
	{ value: '517110 - Bombeiro civil', label: '517110 - Bombeiro civil' },
	{ value: '517115 - Salva-vidas', label: '517115 - Salva-vidas' },
	{
		value: '517105 - Bombeiro de aeródromo',
		label: '517105 - Bombeiro de aeródromo',
	},
	{
		value: '517220 - Agente de trânsito',
		label: '517220 - Agente de trânsito',
	},
	{
		value: '517210 - Policial rodoviário federal',
		label: '517210 - Policial rodoviário federal',
	},
	{
		value: '517205 - Agente de polícia federal',
		label: '517205 - Agente de polícia federal',
	},
	{
		value: '517215 - Guarda-civil municipal',
		label: '517215 - Guarda-civil municipal',
	},
	{ value: '517325 - Vigia portuário', label: '517325 - Vigia portuário' },
	{ value: '517335 - Guarda portuário', label: '517335 - Guarda portuário' },
	{ value: '517330 - Vigilante', label: '517330 - Vigilante' },
	{ value: '517320 - Vigia florestal', label: '517320 - Vigia florestal' },
	{
		value: '517315 - Agente de segurança penitenciária',
		label: '517315 - Agente de segurança penitenciária',
	},
	{
		value: '517310 - Agente de segurança',
		label: '517310 - Agente de segurança',
	},
	{
		value: '517305 - Agente de proteção de aeroporto',
		label: '517305 - Agente de proteção de aeroporto',
	},
	{ value: '517420 - Vigia', label: '517420 - Vigia' },
	{ value: '517425 - Fiscal de loja', label: '517425 - Fiscal de loja' },
	{ value: '517405 - Porteiro (hotel)', label: '517405 - Porteiro (hotel)' },
	{
		value: '517410 - Porteiro de edifícios',
		label: '517410 - Porteiro de edifícios',
	},
	{
		value: '517415 - Porteiro de locais de diversão',
		label: '517415 - Porteiro de locais de diversão',
	},
	{ value: '519115 - Mototaxista', label: '519115 - Mototaxista' },
	{
		value: '519105 - Ciclista mensageiro',
		label: '519105 - Ciclista mensageiro',
	},
	{ value: '519110 - Motofretista', label: '519110 - Motofretista' },
	{
		value: '519210 - Selecionador de material reciclável',
		label: '519210 - Selecionador de material reciclável',
	},
	{
		value: '519215 - Operador de prensa de material reciclável',
		label: '519215 - Operador de prensa de material reciclável',
	},
	{
		value: '519205 - Catador de material reciclável',
		label: '519205 - Catador de material reciclável',
	},
	{
		value: '519305 - Auxiliar de veterinário',
		label: '519305 - Auxiliar de veterinário',
	},
	{
		value: '519315 - Banhista de animais domésticos',
		label: '519315 - Banhista de animais domésticos',
	},
	{
		value: '519320 - Tosador de animais domésticos',
		label: '519320 - Tosador de animais domésticos',
	},
	{
		value: '519310 - Esteticista de animais domésticos',
		label: '519310 - Esteticista de animais domésticos',
	},
	{
		value: '519805 - Profissional do sexo',
		label: '519805 - Profissional do sexo',
	},
	{
		value: '519945 - Recepcionista de casas de espetáculos',
		label: '519945 - Recepcionista de casas de espetáculos',
	},
	{ value: '519940 - Leiturista', label: '519940 - Leiturista' },
	{
		value: '519930 - Lavador de garrafas, vidros e outros utensílios',
		label: '519930 - Lavador de garrafas, vidros e outros utensílios',
	},
	{
		value: '519925 - Guardador de veículos',
		label: '519925 - Guardador de veículos',
	},
	{ value: '519920 - Gandula', label: '519920 - Gandula' },
	{ value: '519915 - Engraxate', label: '519915 - Engraxate' },
	{
		value: '519910 - Controlador de pragas',
		label: '519910 - Controlador de pragas',
	},
	{ value: '519905 - Cartazeiro', label: '519905 - Cartazeiro' },
	{
		value: '519935 - Lavador de veículos',
		label: '519935 - Lavador de veículos',
	},
	{
		value: '520110 - Supervisor de vendas comercial',
		label: '520110 - Supervisor de vendas comercial',
	},
	{
		value: '520105 - Supervisor de vendas de serviços',
		label: '520105 - Supervisor de vendas de serviços',
	},
	{
		value: '521120 - Demonstrador de mercadorias',
		label: '521120 - Demonstrador de mercadorias',
	},
	{
		value: '521125 - Repositor de mercadorias',
		label: '521125 - Repositor de mercadorias',
	},
	{
		value: '521140 - Atendente de lojas e mercados',
		label: '521140 - Atendente de lojas e mercados',
	},
	{ value: '521135 - Frentista', label: '521135 - Frentista' },
	{
		value: '521105 - Vendedor em comércio atacadista',
		label: '521105 - Vendedor em comércio atacadista',
	},
	{
		value: '521115 - Promotor de vendas',
		label: '521115 - Promotor de vendas',
	},
	{
		value: '521110 - Vendedor de comércio varejista',
		label: '521110 - Vendedor de comércio varejista',
	},
	{
		value: '521130 - Atendente de farmácia - balconista',
		label: '521130 - Atendente de farmácia - balconista',
	},
	{ value: '523115 - Chaveiro', label: '523115 - Chaveiro' },
	{
		value: '523110 - Instalador de som e acessórios de veículos',
		label: '523110 - Instalador de som e acessórios de veículos',
	},
	{
		value: '523105 - Instalador de cortinas e persianas, portas sanfonadas e boxe',
		label: '523105 - Instalador de cortinas e persianas, portas sanfonadas e boxe',
	},
	{
		value: '524105 - Vendedor em domicílio',
		label: '524105 - Vendedor em domicílio',
	},
	{ value: '524205 - Feirante', label: '524205 - Feirante' },
	{
		value: '524210 - Jornaleiro (em banca de jornal)',
		label: '524210 - Jornaleiro (em banca de jornal)',
	},
	{
		value: '524215 - Vendedor  permissionário',
		label: '524215 - Vendedor  permissionário',
	},
	{
		value: '524315 - Baiana de acarajé',
		label: '524315 - Baiana de acarajé',
	},
	{
		value: '524305 - Vendedor ambulante',
		label: '524305 - Vendedor ambulante',
	},
	{
		value: '524310 - Pipoqueiro ambulante',
		label: '524310 - Pipoqueiro ambulante',
	},
	{
		value: '611005 - Produtor agropecuário, em geral',
		label: '611005 - Produtor agropecuário, em geral',
	},
	{
		value: '612005 - Produtor agrícola polivalente',
		label: '612005 - Produtor agrícola polivalente',
	},
	{
		value: '612120 - Produtor de gramíneas forrageiras',
		label: '612120 - Produtor de gramíneas forrageiras',
	},
	{
		value: '612115 - Produtor de cereais de inverno',
		label: '612115 - Produtor de cereais de inverno',
	},
	{
		value: '612105 - Produtor de arroz',
		label: '612105 - Produtor de arroz',
	},
	{
		value: '612110 - Produtor de cana-de-açúcar',
		label: '612110 - Produtor de cana-de-açúcar',
	},
	{
		value: '612125 - Produtor de milho e sorgo',
		label: '612125 - Produtor de milho e sorgo',
	},
	{
		value: '612210 - Produtor de curauá',
		label: '612210 - Produtor de curauá',
	},
	{ value: '612215 - Produtor de juta', label: '612215 - Produtor de juta' },
	{ value: '612220 - Produtor de rami', label: '612220 - Produtor de rami' },
	{
		value: '612225 - Produtor de sisal',
		label: '612225 - Produtor de sisal',
	},
	{
		value: '612205 - Produtor de algodão',
		label: '612205 - Produtor de algodão',
	},
	{
		value: '612315 - Produtor na olericultura de talos, folhas e flores',
		label: '612315 - Produtor na olericultura de talos, folhas e flores',
	},
	{
		value: '612320 - Produtor na olericultura de frutos e sementes',
		label: '612320 - Produtor na olericultura de frutos e sementes',
	},
	{
		value: '612310 - Produtor na olericultura de raízes, bulbos e tubérculos',
		label: '612310 - Produtor na olericultura de raízes, bulbos e tubérculos',
	},
	{
		value: '612305 - Produtor na olericultura de legumes',
		label: '612305 - Produtor na olericultura de legumes',
	},
	{
		value: '612415 - Produtor de forrações',
		label: '612415 - Produtor de forrações',
	},
	{
		value: '612405 - Produtor de flores de corte',
		label: '612405 - Produtor de flores de corte',
	},
	{
		value: '612410 - Produtor de flores em vaso',
		label: '612410 - Produtor de flores em vaso',
	},
	{
		value: '612420 - Produtor de plantas ornamentais',
		label: '612420 - Produtor de plantas ornamentais',
	},
	{
		value: '612510 - Produtor de espécies frutíferas rasteiras',
		label: '612510 - Produtor de espécies frutíferas rasteiras',
	},
	{
		value: '612505 - Produtor de árvores frutíferas',
		label: '612505 - Produtor de árvores frutíferas',
	},
	{
		value: '612515 - Produtor de espécies frutíferas trepadeiras',
		label: '612515 - Produtor de espécies frutíferas trepadeiras',
	},
	{ value: '612620 - Produtor de fumo', label: '612620 - Produtor de fumo' },
	{
		value: '612625 - Produtor de guaraná',
		label: '612625 - Produtor de guaraná',
	},
	{
		value: '612610 - Produtor de cacau',
		label: '612610 - Produtor de cacau',
	},
	{
		value: '612615 - Produtor de erva-mate',
		label: '612615 - Produtor de erva-mate',
	},
	{ value: '612605 - Cafeicultor', label: '612605 - Cafeicultor' },
	{
		value: '612730 - Produtor da cultura de linho',
		label: '612730 - Produtor da cultura de linho',
	},
	{
		value: '612725 - Produtor da cultura de girassol',
		label: '612725 - Produtor da cultura de girassol',
	},
	{
		value: '612705 - Produtor da cultura de amendoim',
		label: '612705 - Produtor da cultura de amendoim',
	},
	{
		value: '612710 - Produtor da cultura de canola',
		label: '612710 - Produtor da cultura de canola',
	},
	{
		value: '612715 - Produtor da cultura de coco-da-baia',
		label: '612715 - Produtor da cultura de coco-da-baia',
	},
	{
		value: '612720 - Produtor da cultura de dendê',
		label: '612720 - Produtor da cultura de dendê',
	},
	{
		value: '612735 - Produtor da cultura de mamona',
		label: '612735 - Produtor da cultura de mamona',
	},
	{
		value: '612740 - Produtor da cultura de soja',
		label: '612740 - Produtor da cultura de soja',
	},
	{
		value: '612810 - Produtor de plantas aromáticas e medicinais',
		label: '612810 - Produtor de plantas aromáticas e medicinais',
	},
	{
		value: '612805 - Produtor de especiarias',
		label: '612805 - Produtor de especiarias',
	},
	{
		value: '613010 - Criador de animais domésticos',
		label: '613010 - Criador de animais domésticos',
	},
	{
		value: '613005 - Criador em pecuária polivalente',
		label: '613005 - Criador em pecuária polivalente',
	},
	{
		value: '613105 - Criador de asininos e muares',
		label: '613105 - Criador de asininos e muares',
	},
	{
		value: '613130 - Criador de eqüínos',
		label: '613130 - Criador de eqüínos',
	},
	{
		value: '613125 - Criador de bubalinos (leite)',
		label: '613125 - Criador de bubalinos (leite)',
	},
	{
		value: '613120 - Criador de bubalinos (corte)',
		label: '613120 - Criador de bubalinos (corte)',
	},
	{
		value: '613115 - Criador de bovinos (leite)',
		label: '613115 - Criador de bovinos (leite)',
	},
	{
		value: '613110 - Criador de bovinos (corte)',
		label: '613110 - Criador de bovinos (corte)',
	},
	{
		value: '613205 - Criador de caprinos',
		label: '613205 - Criador de caprinos',
	},
	{
		value: '613215 - Criador de suínos',
		label: '613215 - Criador de suínos',
	},
	{
		value: '613210 - Criador de ovinos',
		label: '613210 - Criador de ovinos',
	},
	{ value: '613310 - Cunicultor', label: '613310 - Cunicultor' },
	{ value: '613305 - Avicultor', label: '613305 - Avicultor' },
	{ value: '613415 - Minhocultor', label: '613415 - Minhocultor' },
	{
		value: '613410 - Criador de animais produtores de veneno',
		label: '613410 - Criador de animais produtores de veneno',
	},
	{ value: '613405 - Apicultor', label: '613405 - Apicultor' },
	{ value: '613420 - Sericultor', label: '613420 - Sericultor' },
	{
		value: '620105 - Supervisor de exploração agrícola',
		label: '620105 - Supervisor de exploração agrícola',
	},
	{
		value: '620110 - Supervisor de exploração agropecuária',
		label: '620110 - Supervisor de exploração agropecuária',
	},
	{
		value: '620115 - Supervisor de exploração pecuária',
		label: '620115 - Supervisor de exploração pecuária',
	},
	{
		value: '621005 - Trabalhador agropecuário em geral',
		label: '621005 - Trabalhador agropecuário em geral',
	},
	{
		value: '622015 - Trabalhador na produção de mudas e sementes',
		label: '622015 - Trabalhador na produção de mudas e sementes',
	},
	{ value: '622010 - Jardineiro', label: '622010 - Jardineiro' },
	{
		value: '622005 - Caseiro (agricultura)',
		label: '622005 - Caseiro (agricultura)',
	},
	{
		value: '622020 - Trabalhador volante da agricultura',
		label: '622020 - Trabalhador volante da agricultura',
	},
	{
		value: '622120 - Trabalhador da cultura de trigo, aveia, cevada e triticale',
		label: '622120 - Trabalhador da cultura de trigo, aveia, cevada e triticale',
	},
	{
		value: '622115 - Trabalhador da cultura de milho e sorgo',
		label: '622115 - Trabalhador da cultura de milho e sorgo',
	},
	{
		value: '622105 - Trabalhador da cultura de arroz',
		label: '622105 - Trabalhador da cultura de arroz',
	},
	{
		value: '622110 - Trabalhador da cultura de cana-de-açúcar',
		label: '622110 - Trabalhador da cultura de cana-de-açúcar',
	},
	{
		value: '622210 - Trabalhador da cultura de sisal',
		label: '622210 - Trabalhador da cultura de sisal',
	},
	{
		value: '622205 - Trabalhador da cultura de algodão',
		label: '622205 - Trabalhador da cultura de algodão',
	},
	{
		value: '622215 - Trabalhador da cultura do rami',
		label: '622215 - Trabalhador da cultura do rami',
	},
	{
		value: '622310 - Trabalhador na olericultura (legumes)',
		label: '622310 - Trabalhador na olericultura (legumes)',
	},
	{
		value: '622305 - Trabalhador na olericultura (frutos e sementes)',
		label: '622305 - Trabalhador na olericultura (frutos e sementes)',
	},
	{
		value: '622315 - Trabalhador na olericultura (raízes, bulbos e tubérculos)',
		label: '622315 - Trabalhador na olericultura (raízes, bulbos e tubérculos)',
	},
	{
		value: '622320 - Trabalhador na olericultura (talos, folhas e flores)',
		label: '622320 - Trabalhador na olericultura (talos, folhas e flores)',
	},
	{
		value: '622405 - Trabalhador no cultivo de flores e folhagens de corte',
		label: '622405 - Trabalhador no cultivo de flores e folhagens de corte',
	},
	{
		value: '622410 - Trabalhador no cultivo de flores em vaso',
		label: '622410 - Trabalhador no cultivo de flores em vaso',
	},
	{
		value: '622415 - Trabalhador no cultivo de forrações',
		label: '622415 - Trabalhador no cultivo de forrações',
	},
	{
		value: '622420 - Trabalhador no cultivo de mudas',
		label: '622420 - Trabalhador no cultivo de mudas',
	},
	{
		value: '622425 - Trabalhador no cultivo de plantas ornamentais',
		label: '622425 - Trabalhador no cultivo de plantas ornamentais',
	},
	{
		value: '622505 - Trabalhador no cultivo de árvores frutíferas',
		label: '622505 - Trabalhador no cultivo de árvores frutíferas',
	},
	{
		value: '622510 - Trabalhador no cultivo de espécies frutíferas rasteiras',
		label: '622510 - Trabalhador no cultivo de espécies frutíferas rasteiras',
	},
	{
		value: '622515 - Trabalhador no cultivo de trepadeiras frutíferas',
		label: '622515 - Trabalhador no cultivo de trepadeiras frutíferas',
	},
	{
		value: '622615 - Trabalhador da cultura de erva-mate',
		label: '622615 - Trabalhador da cultura de erva-mate',
	},
	{
		value: '622620 - Trabalhador da cultura de fumo',
		label: '622620 - Trabalhador da cultura de fumo',
	},
	{
		value: '622625 - Trabalhador da cultura de guaraná',
		label: '622625 - Trabalhador da cultura de guaraná',
	},
	{
		value: '622610 - Trabalhador da cultura de café',
		label: '622610 - Trabalhador da cultura de café',
	},
	{
		value: '622605 - Trabalhador da cultura de cacau',
		label: '622605 - Trabalhador da cultura de cacau',
	},
	{
		value: '622715 - Trabalhador na cultura de coco-da-baía',
		label: '622715 - Trabalhador na cultura de coco-da-baía',
	},
	{
		value: '622710 - Trabalhador na cultura de canola',
		label: '622710 - Trabalhador na cultura de canola',
	},
	{
		value: '622725 - Trabalhador na cultura de mamona',
		label: '622725 - Trabalhador na cultura de mamona',
	},
	{
		value: '622730 - Trabalhador na cultura de soja',
		label: '622730 - Trabalhador na cultura de soja',
	},
	{
		value: '622735 - Trabalhador na cultura do girassol',
		label: '622735 - Trabalhador na cultura do girassol',
	},
	{
		value: '622740 - Trabalhador na cultura do linho',
		label: '622740 - Trabalhador na cultura do linho',
	},
	{
		value: '622705 - Trabalhador na cultura de amendoim',
		label: '622705 - Trabalhador na cultura de amendoim',
	},
	{
		value: '622720 - Trabalhador na cultura de dendê',
		label: '622720 - Trabalhador na cultura de dendê',
	},
	{
		value: '622810 - Trabalhador da cultura de plantas aromáticas e medicinais',
		label: '622810 - Trabalhador da cultura de plantas aromáticas e medicinais',
	},
	{
		value: '622805 - Trabalhador da cultura de especiarias',
		label: '622805 - Trabalhador da cultura de especiarias',
	},
	{
		value: '623025 - Casqueador de animais',
		label: '623025 - Casqueador de animais',
	},
	{
		value: '623030 - Ferrador de animais',
		label: '623030 - Ferrador de animais',
	},
	{
		value: '623015 - Trabalhador de pecuária polivalente',
		label: '623015 - Trabalhador de pecuária polivalente',
	},
	{ value: '623010 - Inseminador', label: '623010 - Inseminador' },
	{
		value: '623020 - Tratador de animais',
		label: '623020 - Tratador de animais',
	},
	{
		value: '623005 - Adestrador de animais',
		label: '623005 - Adestrador de animais',
	},
	{
		value: '623105 - Trabalhador da pecuária (asininos e muares)',
		label: '623105 - Trabalhador da pecuária (asininos e muares)',
	},
	{
		value: '623110 - Trabalhador da pecuária (bovinos corte)',
		label: '623110 - Trabalhador da pecuária (bovinos corte)',
	},
	{
		value: '623120 - Trabalhador da pecuária (bubalinos)',
		label: '623120 - Trabalhador da pecuária (bubalinos)',
	},
	{
		value: '623125 - Trabalhador da pecuária (eqüinos)',
		label: '623125 - Trabalhador da pecuária (eqüinos)',
	},
	{
		value: '623115 - Trabalhador da pecuária (bovinos leite)',
		label: '623115 - Trabalhador da pecuária (bovinos leite)',
	},
	{
		value: '623210 - Trabalhador da ovinocultura',
		label: '623210 - Trabalhador da ovinocultura',
	},
	{
		value: '623215 - Trabalhador da suinocultura',
		label: '623215 - Trabalhador da suinocultura',
	},
	{
		value: '623205 - Trabalhador da caprinocultura',
		label: '623205 - Trabalhador da caprinocultura',
	},
	{
		value: '623320 - Trabalhador da cunicultura',
		label: '623320 - Trabalhador da cunicultura',
	},
	{
		value: '623315 - Operador de incubadora',
		label: '623315 - Operador de incubadora',
	},
	{
		value: '623310 - Trabalhador da avicultura de postura',
		label: '623310 - Trabalhador da avicultura de postura',
	},
	{
		value: '623305 - Trabalhador da avicultura de corte',
		label: '623305 - Trabalhador da avicultura de corte',
	},
	{ value: '623325 - Sexador', label: '623325 - Sexador' },
	{
		value: '623405 - Trabalhador em criatórios de animais produtores de veneno',
		label: '623405 - Trabalhador em criatórios de animais produtores de veneno',
	},
	{
		value: '623415 - Trabalhador na minhocultura',
		label: '623415 - Trabalhador na minhocultura',
	},
	{
		value: '623420 - Trabalhador na sericicultura',
		label: '623420 - Trabalhador na sericicultura',
	},
	{
		value: '623410 - Trabalhador na apicultura',
		label: '623410 - Trabalhador na apicultura',
	},
	{
		value: '630110 - Supervisor da área florestal',
		label: '630110 - Supervisor da área florestal',
	},
	{
		value: '630105 - Supervisor da aqüicultura',
		label: '630105 - Supervisor da aqüicultura',
	},
	{
		value: '631015 - Pescador artesanal de lagostas',
		label: '631015 - Pescador artesanal de lagostas',
	},
	{
		value: '631005 - Catador de caranguejos e siris',
		label: '631005 - Catador de caranguejos e siris',
	},
	{
		value: '631010 - Catador de mariscos',
		label: '631010 - Catador de mariscos',
	},
	{
		value: '631020 - Pescador artesanal de peixes e camarões',
		label: '631020 - Pescador artesanal de peixes e camarões',
	},
	{
		value: '631105 - Pescador artesanal de água doce',
		label: '631105 - Pescador artesanal de água doce',
	},
	{
		value: '631205 - Pescador industrial',
		label: '631205 - Pescador industrial',
	},
	{
		value: '631210 - Pescador profissional',
		label: '631210 - Pescador profissional',
	},
	{ value: '631335 - Criador de rãs', label: '631335 - Criador de rãs' },
	{
		value: '631330 - Criador de quelônios',
		label: '631330 - Criador de quelônios',
	},
	{
		value: '631325 - Criador de peixes',
		label: '631325 - Criador de peixes',
	},
	{
		value: '631320 - Criador de ostras',
		label: '631320 - Criador de ostras',
	},
	{
		value: '631315 - Criador de mexilhões',
		label: '631315 - Criador de mexilhões',
	},
	{
		value: '631310 - Criador de jacarés',
		label: '631310 - Criador de jacarés',
	},
	{
		value: '631305 - Criador de camarões',
		label: '631305 - Criador de camarões',
	},
	{
		value: '631405 - Gelador industrial',
		label: '631405 - Gelador industrial',
	},
	{ value: '631420 - Redeiro (pesca)', label: '631420 - Redeiro (pesca)' },
	{ value: '631415 - Proeiro', label: '631415 - Proeiro' },
	{
		value: '631410 - Gelador profissional',
		label: '631410 - Gelador profissional',
	},
	{ value: '632010 - Raizeiro', label: '632010 - Raizeiro' },
	{
		value: '632015 - Viveirista florestal',
		label: '632015 - Viveirista florestal',
	},
	{ value: '632005 - Guia florestal', label: '632005 - Guia florestal' },
	{
		value: '632115 - Identificador florestal',
		label: '632115 - Identificador florestal',
	},
	{
		value: '632110 - Cubador de madeira',
		label: '632110 - Cubador de madeira',
	},
	{
		value: '632105 - Classificador de toras',
		label: '632105 - Classificador de toras',
	},
	{
		value: '632120 - Operador de motosserra',
		label: '632120 - Operador de motosserra',
	},
	{
		value: '632125 - Trabalhador de extração florestal, em geral',
		label: '632125 - Trabalhador de extração florestal, em geral',
	},
	{
		value: '632215 - Trabalhador da exploração de resinas',
		label: '632215 - Trabalhador da exploração de resinas',
	},
	{
		value: '632210 - Trabalhador da exploração de espécies produtoras de gomas não elásticas',
		label: '632210 - Trabalhador da exploração de espécies produtoras de gomas não elásticas',
	},
	{ value: '632205 - Seringueiro', label: '632205 - Seringueiro' },
	{
		value: '632370 - Trabalhador da exploração de tucum',
		label: '632370 - Trabalhador da exploração de tucum',
	},
	{
		value: '632365 - Trabalhador da exploração de piaçava',
		label: '632365 - Trabalhador da exploração de piaçava',
	},
	{
		value: '632360 - Trabalhador da exploração de pequi',
		label: '632360 - Trabalhador da exploração de pequi',
	},
	{
		value: '632355 - Trabalhador da exploração de ouricuri',
		label: '632355 - Trabalhador da exploração de ouricuri',
	},
	{
		value: '632350 - Trabalhador da exploração de oiticica',
		label: '632350 - Trabalhador da exploração de oiticica',
	},
	{
		value: '632345 - Trabalhador da exploração de murumuru',
		label: '632345 - Trabalhador da exploração de murumuru',
	},
	{
		value: '632340 - Trabalhador da exploração de malva (pãina)',
		label: '632340 - Trabalhador da exploração de malva (pãina)',
	},
	{
		value: '632335 - Trabalhador da exploração de copaíba',
		label: '632335 - Trabalhador da exploração de copaíba',
	},
	{
		value: '632330 - Trabalhador da exploração de coco-da-praia',
		label: '632330 - Trabalhador da exploração de coco-da-praia',
	},
	{
		value: '632325 - Trabalhador da exploração de carnaúba',
		label: '632325 - Trabalhador da exploração de carnaúba',
	},
	{
		value: '632320 - Trabalhador da exploração de buriti',
		label: '632320 - Trabalhador da exploração de buriti',
	},
	{
		value: '632315 - Trabalhador da exploração de bacaba',
		label: '632315 - Trabalhador da exploração de bacaba',
	},
	{
		value: '632305 - Trabalhador da exploração de andiroba',
		label: '632305 - Trabalhador da exploração de andiroba',
	},
	{
		value: '632310 - Trabalhador da exploração de babaçu',
		label: '632310 - Trabalhador da exploração de babaçu',
	},
	{
		value: '632405 - Trabalhador da exploração de açaí',
		label: '632405 - Trabalhador da exploração de açaí',
	},
	{
		value: '632410 - Trabalhador da exploração de castanha',
		label: '632410 - Trabalhador da exploração de castanha',
	},
	{
		value: '632415 - Trabalhador da exploração de pinhão',
		label: '632415 - Trabalhador da exploração de pinhão',
	},
	{
		value: '632420 - Trabalhador da exploração de pupunha',
		label: '632420 - Trabalhador da exploração de pupunha',
	},
	{
		value: '632505 - Trabalhador da exploração de árvores e arbustos produtores de substâncias aromát., Medic. E tóxicas',
		label: '632505 - Trabalhador da exploração de árvores e arbustos produtores de substâncias aromát., Medic. E tóxicas',
	},
	{
		value: '632510 - Trabalhador da exploração de cipós produtores de substâncias aromáticas, medicinais e tóxicas',
		label: '632510 - Trabalhador da exploração de cipós produtores de substâncias aromáticas, medicinais e tóxicas',
	},
	{
		value: '632525 - Trabalhador da extração de substâncias aromáticas, medicinais e tóxicas, em geral',
		label: '632525 - Trabalhador da extração de substâncias aromáticas, medicinais e tóxicas, em geral',
	},
	{
		value: '632520 - Trabalhador da exploração de raízes produtoras de substâncias aromáticas, medicinais e tóxicas',
		label: '632520 - Trabalhador da exploração de raízes produtoras de substâncias aromáticas, medicinais e tóxicas',
	},
	{
		value: '632515 - Trabalhador da exploração de madeiras tanantes',
		label: '632515 - Trabalhador da exploração de madeiras tanantes',
	},
	{ value: '632605 - Carvoeiro', label: '632605 - Carvoeiro' },
	{ value: '632610 - Carbonizador', label: '632610 - Carbonizador' },
	{
		value: '632615 - Ajudante de carvoaria',
		label: '632615 - Ajudante de carvoaria',
	},
	{
		value: '641010 - Operador de máquinas de beneficiamento de produtos agrícolas',
		label: '641010 - Operador de máquinas de beneficiamento de produtos agrícolas',
	},
	{
		value: '641005 - Operador de colheitadeira',
		label: '641005 - Operador de colheitadeira',
	},
	{
		value: '641015 - Tratorista agrícola',
		label: '641015 - Tratorista agrícola',
	},
	{
		value: '642010 - Operador de máquinas florestais estáticas',
		label: '642010 - Operador de máquinas florestais estáticas',
	},
	{
		value: '642005 - Operador de colhedor florestal',
		label: '642005 - Operador de colhedor florestal',
	},
	{
		value: '642015 - Operador de trator florestal',
		label: '642015 - Operador de trator florestal',
	},
	{
		value: '643005 - Trabalhador na operação de sistema de irrigação localizada (microaspersão e gotejamento)',
		label: '643005 - Trabalhador na operação de sistema de irrigação localizada (microaspersão e gotejamento)',
	},
	{
		value: '643010 - Trabalhador na operação de sistema de irrigação por aspersão (pivô central)',
		label: '643010 - Trabalhador na operação de sistema de irrigação por aspersão (pivô central)',
	},
	{
		value: '643015 - Trabalhador na operação de sistemas convencionais de irrigação por aspersão',
		label: '643015 - Trabalhador na operação de sistemas convencionais de irrigação por aspersão',
	},
	{
		value: '643020 - Trabalhador na operação de sistemas de irrigação e aspersão (alto propelido)',
		label: '643020 - Trabalhador na operação de sistemas de irrigação e aspersão (alto propelido)',
	},
	{
		value: '643025 - Trabalhador na operação de sistemas de irrigação por superfície e drenagem',
		label: '643025 - Trabalhador na operação de sistemas de irrigação por superfície e drenagem',
	},
	{
		value: '710125 - Supervisor de transporte na mineração',
		label: '710125 - Supervisor de transporte na mineração',
	},
	{
		value: '710105 - Supervisor de apoio operacional na mineração',
		label: '710105 - Supervisor de apoio operacional na mineração',
	},
	{
		value: '710110 - Supervisor de extração de sal',
		label: '710110 - Supervisor de extração de sal',
	},
	{
		value: '710115 - Supervisor de perfuração e desmonte',
		label: '710115 - Supervisor de perfuração e desmonte',
	},
	{
		value: '710120 - Supervisor de produção na mineração',
		label: '710120 - Supervisor de produção na mineração',
	},
	{
		value: '710205 - Mestre (construção civil)',
		label: '710205 - Mestre (construção civil)',
	},
	{
		value: '710210 - Mestre de linhas (ferrovias)',
		label: '710210 - Mestre de linhas (ferrovias)',
	},
	{
		value: '710225 - Fiscal de pátio de usina de concreto',
		label: '710225 - Fiscal de pátio de usina de concreto',
	},
	{
		value: '710220 - Supervisor de usina de concreto',
		label: '710220 - Supervisor de usina de concreto',
	},
	{
		value: '710215 - Inspetor de terraplenagem',
		label: '710215 - Inspetor de terraplenagem',
	},
	{
		value: '711125 - Escorador de minas',
		label: '711125 - Escorador de minas',
	},
	{ value: '711120 - Detonador', label: '711120 - Detonador' },
	{
		value: '711115 - Destroçador de pedra',
		label: '711115 - Destroçador de pedra',
	},
	{ value: '711110 - Canteiro', label: '711110 - Canteiro' },
	{
		value: '711105 - Amostrador de minérios',
		label: '711105 - Amostrador de minérios',
	},
	{ value: '711130 - Mineiro', label: '711130 - Mineiro' },
	{
		value: '711225 - Operador de máquina perfuradora (minas e pedreiras)',
		label: '711225 - Operador de máquina perfuradora (minas e pedreiras)',
	},
	{
		value: '711220 - Operador de máquina de extração contínua (minas de carvão)',
		label: '711220 - Operador de máquina de extração contínua (minas de carvão)',
	},
	{
		value: '711215 - Operador de máquina cortadora (minas e pedreiras)',
		label: '711215 - Operador de máquina cortadora (minas e pedreiras)',
	},
	{
		value: '711210 - Operador de carregadeira',
		label: '711210 - Operador de carregadeira',
	},
	{
		value: '711205 - Operador de caminhão (minas e pedreiras)',
		label: '711205 - Operador de caminhão (minas e pedreiras)',
	},
	{
		value: '711230 - Operador de máquina perfuratriz',
		label: '711230 - Operador de máquina perfuratriz',
	},
	{
		value: '711245 - Operador de trator (minas e pedreiras)',
		label: '711245 - Operador de trator (minas e pedreiras)',
	},
	{
		value: '711240 - Operador de schutthecar',
		label: '711240 - Operador de schutthecar',
	},
	{
		value: '711235 - Operador de motoniveladora (extração de minerais sólidos)',
		label: '711235 - Operador de motoniveladora (extração de minerais sólidos)',
	},
	{
		value: '711305 - Operador de sonda de percussão',
		label: '711305 - Operador de sonda de percussão',
	},
	{
		value: '711310 - Operador de sonda rotativa',
		label: '711310 - Operador de sonda rotativa',
	},
	{
		value: '711315 - Sondador (poços de petróleo e gás)',
		label: '711315 - Sondador (poços de petróleo e gás)',
	},
	{
		value: '711320 - Sondador de poços (exceto de petróleo e gás)',
		label: '711320 - Sondador de poços (exceto de petróleo e gás)',
	},
	{
		value: '711330 - Torrista (petróleo)',
		label: '711330 - Torrista (petróleo)',
	},
	{
		value: '711325 - Plataformista (petróleo)',
		label: '711325 - Plataformista (petróleo)',
	},
	{ value: '711405 - Garimpeiro', label: '711405 - Garimpeiro' },
	{
		value: '711410 - Operador de salina (sal marinho)',
		label: '711410 - Operador de salina (sal marinho)',
	},
	{
		value: '712105 - Moleiro de minérios',
		label: '712105 - Moleiro de minérios',
	},
	{
		value: '712110 - Operador de aparelho de flotação',
		label: '712110 - Operador de aparelho de flotação',
	},
	{
		value: '712115 - Operador de aparelho de precipitação (minas de ouro ou prata)',
		label: '712115 - Operador de aparelho de precipitação (minas de ouro ou prata)',
	},
	{
		value: '712120 - Operador de britador de mandíbulas',
		label: '712120 - Operador de britador de mandíbulas',
	},
	{
		value: '712125 - Operador de espessador',
		label: '712125 - Operador de espessador',
	},
	{
		value: '712130 - Operador de jig (minas)',
		label: '712130 - Operador de jig (minas)',
	},
	{
		value: '712135 - Operador de peneiras hidráulicas',
		label: '712135 - Operador de peneiras hidráulicas',
	},
	{
		value: '712205 - Cortador de pedras',
		label: '712205 - Cortador de pedras',
	},
	{
		value: '712210 - Gravador de inscrições em pedra',
		label: '712210 - Gravador de inscrições em pedra',
	},
	{
		value: '712215 - Gravador de relevos em pedra',
		label: '712215 - Gravador de relevos em pedra',
	},
	{
		value: '712220 - Polidor de pedras',
		label: '712220 - Polidor de pedras',
	},
	{
		value: '712225 - Torneiro (lavra de pedra)',
		label: '712225 - Torneiro (lavra de pedra)',
	},
	{
		value: '712230 - Traçador de pedras',
		label: '712230 - Traçador de pedras',
	},
	{
		value: '715115 - Operador de escavadeira',
		label: '715115 - Operador de escavadeira',
	},
	{
		value: '715110 - Operador de compactadora de solos',
		label: '715110 - Operador de compactadora de solos',
	},
	{
		value: '715105 - Operador de bate-estacas',
		label: '715105 - Operador de bate-estacas',
	},
	{
		value: '715145 - Operador de trator de lâmina',
		label: '715145 - Operador de trator de lâmina',
	},
	{
		value: '715120 - Operador de máquina de abrir valas',
		label: '715120 - Operador de máquina de abrir valas',
	},
	{
		value: '715135 - Operador de pá carregadeira',
		label: '715135 - Operador de pá carregadeira',
	},
	{
		value: '715130 - Operador de motoniveladora',
		label: '715130 - Operador de motoniveladora',
	},
	{
		value: '715125 - Operador de máquinas de construção civil e mineração',
		label: '715125 - Operador de máquinas de construção civil e mineração',
	},
	{
		value: '715140 - Operador de pavimentadora (asfalto, concreto e materiais similares)',
		label: '715140 - Operador de pavimentadora (asfalto, concreto e materiais similares)',
	},
	{
		value: '715230 - Pedreiro de edificações',
		label: '715230 - Pedreiro de edificações',
	},
	{
		value: '715225 - Pedreiro (mineração)',
		label: '715225 - Pedreiro (mineração)',
	},
	{
		value: '715220 - Pedreiro (material refratário)',
		label: '715220 - Pedreiro (material refratário)',
	},
	{
		value: '715215 - Pedreiro (chaminés industriais)',
		label: '715215 - Pedreiro (chaminés industriais)',
	},
	{ value: '715205 - Calceteiro', label: '715205 - Calceteiro' },
	{ value: '715210 - Pedreiro', label: '715210 - Pedreiro' },
	{
		value: '715310 - Moldador de corpos de prova em usinas de concreto',
		label: '715310 - Moldador de corpos de prova em usinas de concreto',
	},
	{
		value: '715305 - Armador de estrutura de concreto',
		label: '715305 - Armador de estrutura de concreto',
	},
	{
		value: '715315 - Armador de estrutura de concreto armado',
		label: '715315 - Armador de estrutura de concreto armado',
	},
	{
		value: '715405 - Operador de betoneira',
		label: '715405 - Operador de betoneira',
	},
	{
		value: '715410 - Operador de bomba de concreto',
		label: '715410 - Operador de bomba de concreto',
	},
	{
		value: '715415 - Operador de central de concreto',
		label: '715415 - Operador de central de concreto',
	},
	{ value: '715505 - Carpinteiro', label: '715505 - Carpinteiro' },
	{
		value: '715510 - Carpinteiro (esquadrias)',
		label: '715510 - Carpinteiro (esquadrias)',
	},
	{
		value: '715545 - Montador de andaimes (edificações)',
		label: '715545 - Montador de andaimes (edificações)',
	},
	{
		value: '715540 - Carpinteiro de obras civis de arte (pontes, túneis, barragens)',
		label: '715540 - Carpinteiro de obras civis de arte (pontes, túneis, barragens)',
	},
	{
		value: '715535 - Carpinteiro de fôrmas para concreto',
		label: '715535 - Carpinteiro de fôrmas para concreto',
	},
	{
		value: '715530 - Carpinteiro (telhados)',
		label: '715530 - Carpinteiro (telhados)',
	},
	{
		value: '715525 - Carpinteiro de obras',
		label: '715525 - Carpinteiro de obras',
	},
	{
		value: '715520 - Carpinteiro (mineração)',
		label: '715520 - Carpinteiro (mineração)',
	},
	{
		value: '715515 - Carpinteiro (cenários)',
		label: '715515 - Carpinteiro (cenários)',
	},
	{
		value: '715610 - Eletricista de instalações (edifícios)',
		label: '715610 - Eletricista de instalações (edifícios)',
	},
	{
		value: '715615 - Eletricista de instalações',
		label: '715615 - Eletricista de instalações',
	},
	{
		value: '715605 - Eletricista de instalações (cenários)',
		label: '715605 - Eletricista de instalações (cenários)',
	},
	{
		value: '715730 - Instalador de material isolante, a máquina (edificações)',
		label: '715730 - Instalador de material isolante, a máquina (edificações)',
	},
	{
		value: '715705 - Aplicador de asfalto impermeabilizante (coberturas)',
		label: '715705 - Aplicador de asfalto impermeabilizante (coberturas)',
	},
	{
		value: '715715 - Instalador de isolantes térmicos (refrigeração e climatização)',
		label: '715715 - Instalador de isolantes térmicos (refrigeração e climatização)',
	},
	{
		value: '715720 - Instalador de isolantes térmicos de caldeira e tubulações',
		label: '715720 - Instalador de isolantes térmicos de caldeira e tubulações',
	},
	{
		value: '715725 - Instalador de material isolante, a mão (edificações)',
		label: '715725 - Instalador de material isolante, a mão (edificações)',
	},
	{
		value: '715710 - Instalador de isolantes acústicos',
		label: '715710 - Instalador de isolantes acústicos',
	},
	{
		value: '716105 - Acabador de superfícies de concreto',
		label: '716105 - Acabador de superfícies de concreto',
	},
	{
		value: '716110 - Revestidor de superfícies de concreto',
		label: '716110 - Revestidor de superfícies de concreto',
	},
	{
		value: '716205 - Telhador (telhas de argila e materiais similares)',
		label: '716205 - Telhador (telhas de argila e materiais similares)',
	},
	{
		value: '716210 - Telhador (telhas de cimento-amianto)',
		label: '716210 - Telhador (telhas de cimento-amianto)',
	},
	{
		value: '716215 - Telhador (telhas metálicas)',
		label: '716215 - Telhador (telhas metálicas)',
	},
	{
		value: '716220 - Telhador (telhas plásticas)',
		label: '716220 - Telhador (telhas plásticas)',
	},
	{ value: '716305 - Vidraceiro', label: '716305 - Vidraceiro' },
	{
		value: '716310 - Vidraceiro (edificações)',
		label: '716310 - Vidraceiro (edificações)',
	},
	{
		value: '716315 - Vidraceiro (vitrais)',
		label: '716315 - Vidraceiro (vitrais)',
	},
	{ value: '716405 - Gesseiro', label: '716405 - Gesseiro' },
	{
		value: '716520 - Lustrador de piso',
		label: '716520 - Lustrador de piso',
	},
	{ value: '716515 - Pastilheiro', label: '716515 - Pastilheiro' },
	{ value: '716510 - Ladrilheiro', label: '716510 - Ladrilheiro' },
	{ value: '716505 - Assoalhador', label: '716505 - Assoalhador' },
	{ value: '716535 - Taqueiro', label: '716535 - Taqueiro' },
	{
		value: '716525 - Marmorista (construção)',
		label: '716525 - Marmorista (construção)',
	},
	{ value: '716530 - Mosaísta', label: '716530 - Mosaísta' },
	{ value: '716605 - Calafetador', label: '716605 - Calafetador' },
	{ value: '716610 - Pintor de obras', label: '716610 - Pintor de obras' },
	{
		value: '716615 - Revestidor de interiores (papel, material plástico e emborrachados)',
		label: '716615 - Revestidor de interiores (papel, material plástico e emborrachados)',
	},
	{
		value: '717005 - Demolidor de edificações',
		label: '717005 - Demolidor de edificações',
	},
	{
		value: '717010 - Operador de martelete',
		label: '717010 - Operador de martelete',
	},
	{ value: '717025 - Vibradorista', label: '717025 - Vibradorista' },
	{
		value: '717020 - Servente de obras',
		label: '717020 - Servente de obras',
	},
	{
		value: '717015 - Poceiro (edificações)',
		label: '717015 - Poceiro (edificações)',
	},
	{
		value: '720110 - Mestre de caldeiraria',
		label: '720110 - Mestre de caldeiraria',
	},
	{
		value: '720105 - Mestre (afiador de ferramentas)',
		label: '720105 - Mestre (afiador de ferramentas)',
	},
	{
		value: '720160 - Supervisor de controle de tratamento térmico',
		label: '720160 - Supervisor de controle de tratamento térmico',
	},
	{
		value: '720155 - Mestre serralheiro',
		label: '720155 - Mestre serralheiro',
	},
	{
		value: '720150 - Mestre de usinagem',
		label: '720150 - Mestre de usinagem',
	},
	{
		value: '720115 - Mestre de ferramentaria',
		label: '720115 - Mestre de ferramentaria',
	},
	{
		value: '720120 - Mestre de forjaria',
		label: '720120 - Mestre de forjaria',
	},
	{
		value: '720125 - Mestre de fundição',
		label: '720125 - Mestre de fundição',
	},
	{
		value: '720130 - Mestre de galvanoplastia',
		label: '720130 - Mestre de galvanoplastia',
	},
	{
		value: '720135 - Mestre de pintura (tratamento de superfícies)',
		label: '720135 - Mestre de pintura (tratamento de superfícies)',
	},
	{
		value: '720140 - Mestre de soldagem',
		label: '720140 - Mestre de soldagem',
	},
	{
		value: '720145 - Mestre de trefilação de metais',
		label: '720145 - Mestre de trefilação de metais',
	},
	{
		value: '720210 - Mestre (indústria de automotores e material de transportes)',
		label: '720210 - Mestre (indústria de automotores e material de transportes)',
	},
	{
		value: '720205 - Mestre (construção naval)',
		label: '720205 - Mestre (construção naval)',
	},
	{
		value: '720215 - Mestre (indústria de máquinas e outros equipamentos mecânicos)',
		label: '720215 - Mestre (indústria de máquinas e outros equipamentos mecânicos)',
	},
	{
		value: '720220 - Mestre de construção de fornos',
		label: '720220 - Mestre de construção de fornos',
	},
	{
		value: '721110 - Ferramenteiro de mandris, calibradores e outros dispositivos',
		label: '721110 - Ferramenteiro de mandris, calibradores e outros dispositivos',
	},
	{ value: '721105 - Ferramenteiro', label: '721105 - Ferramenteiro' },
	{
		value: '721115 - Modelador de metais (fundição)',
		label: '721115 - Modelador de metais (fundição)',
	},
	{
		value: '721220 - Operador de usinagem convencional por abrasão',
		label: '721220 - Operador de usinagem convencional por abrasão',
	},
	{
		value: '721215 - Operador de máquinas-ferramenta convencionais',
		label: '721215 - Operador de máquinas-ferramenta convencionais',
	},
	{
		value: '721210 - Operador de máquinas operatrizes',
		label: '721210 - Operador de máquinas operatrizes',
	},
	{
		value: '721205 - Operador de máquina de eletroerosão',
		label: '721205 - Operador de máquina de eletroerosão',
	},
	{
		value: '721225 - Preparador de máquinas-ferramenta',
		label: '721225 - Preparador de máquinas-ferramenta',
	},
	{
		value: '721320 - Afiador de serras',
		label: '721320 - Afiador de serras',
	},
	{
		value: '721315 - Afiador de ferramentas',
		label: '721315 - Afiador de ferramentas',
	},
	{
		value: '721310 - Afiador de cutelaria',
		label: '721310 - Afiador de cutelaria',
	},
	{
		value: '721305 - Afiador de cardas',
		label: '721305 - Afiador de cardas',
	},
	{
		value: '721325 - Polidor de metais',
		label: '721325 - Polidor de metais',
	},
	{
		value: '721405 - Operador de centro de usinagem com comando numérico',
		label: '721405 - Operador de centro de usinagem com comando numérico',
	},
	{
		value: '721410 - Operador de fresadora com comando numérico',
		label: '721410 - Operador de fresadora com comando numérico',
	},
	{
		value: '721415 - Operador de mandriladora com comando numérico',
		label: '721415 - Operador de mandriladora com comando numérico',
	},
	{
		value: '721420 - Operador de máquina eletroerosão, à fio, com comando numérico',
		label: '721420 - Operador de máquina eletroerosão, à fio, com comando numérico',
	},
	{
		value: '721425 - Operador de retificadora com comando numérico',
		label: '721425 - Operador de retificadora com comando numérico',
	},
	{
		value: '721430 - Operador de torno com comando numérico',
		label: '721430 - Operador de torno com comando numérico',
	},
	{ value: '722105 - Forjador', label: '722105 - Forjador' },
	{
		value: '722110 - Forjador a martelo',
		label: '722110 - Forjador a martelo',
	},
	{
		value: '722115 - Forjador prensista',
		label: '722115 - Forjador prensista',
	},
	{
		value: '722215 - Operador de acabamento de peças fundidas',
		label: '722215 - Operador de acabamento de peças fundidas',
	},
	{
		value: '722220 - Operador de máquina centrifugadora de fundição',
		label: '722220 - Operador de máquina centrifugadora de fundição',
	},
	{
		value: '722225 - Operador de máquina de fundir sob pressão',
		label: '722225 - Operador de máquina de fundir sob pressão',
	},
	{
		value: '722230 - Operador de vazamento (lingotamento)',
		label: '722230 - Operador de vazamento (lingotamento)',
	},
	{
		value: '722235 - Preparador de panelas (lingotamento)',
		label: '722235 - Preparador de panelas (lingotamento)',
	},
	{
		value: '722205 - Fundidor de metais',
		label: '722205 - Fundidor de metais',
	},
	{ value: '722210 - Lingotador', label: '722210 - Lingotador' },
	{ value: '722305 - Macheiro, a mão', label: '722305 - Macheiro, a mão' },
	{
		value: '722310 - Macheiro, a  máquina',
		label: '722310 - Macheiro, a  máquina',
	},
	{ value: '722315 - Moldador, a  mão', label: '722315 - Moldador, a  mão' },
	{
		value: '722320 - Moldador, a  máquina',
		label: '722320 - Moldador, a  máquina',
	},
	{
		value: '722325 - Operador de equipamentos de preparação de areia',
		label: '722325 - Operador de equipamentos de preparação de areia',
	},
	{
		value: '722330 - Operador de máquina de moldar automatizada',
		label: '722330 - Operador de máquina de moldar automatizada',
	},
	{ value: '722405 - Cableador', label: '722405 - Cableador' },
	{
		value: '722410 - Estirador de tubos de metal sem costura',
		label: '722410 - Estirador de tubos de metal sem costura',
	},
	{
		value: '722415 - Trefilador de metais, à máquina',
		label: '722415 - Trefilador de metais, à máquina',
	},
	{
		value: '723120 - Operador de forno de tratamento térmico de metais',
		label: '723120 - Operador de forno de tratamento térmico de metais',
	},
	{
		value: '723115 - Operador de equipamento para resfriamento',
		label: '723115 - Operador de equipamento para resfriamento',
	},
	{
		value: '723110 - Normalizador de metais e de compósitos',
		label: '723110 - Normalizador de metais e de compósitos',
	},
	{
		value: '723105 - Cementador de metais',
		label: '723105 - Cementador de metais',
	},
	{
		value: '723125 - Temperador de metais e de compósitos',
		label: '723125 - Temperador de metais e de compósitos',
	},
	{
		value: '723220 - Metalizador a pistola',
		label: '723220 - Metalizador a pistola',
	},
	{ value: '723215 - Galvanizador', label: '723215 - Galvanizador' },
	{ value: '723210 - Fosfatizador', label: '723210 - Fosfatizador' },
	{ value: '723205 - Decapador', label: '723205 - Decapador' },
	{
		value: '723225 - Metalizador (banho quente)',
		label: '723225 - Metalizador (banho quente)',
	},
	{ value: '723240 - Oxidador', label: '723240 - Oxidador' },
	{
		value: '723235 - Operador de zincagem (processo eletrolítico)',
		label: '723235 - Operador de zincagem (processo eletrolítico)',
	},
	{
		value: '723230 - Operador de máquina recobridora de arame',
		label: '723230 - Operador de máquina recobridora de arame',
	},
	{
		value: '723305 - Operador de equipamento de secagem de pintura',
		label: '723305 - Operador de equipamento de secagem de pintura',
	},
	{
		value: '723310 - Pintor a pincel e rolo (exceto obras e estruturas metálicas)',
		label: '723310 - Pintor a pincel e rolo (exceto obras e estruturas metálicas)',
	},
	{
		value: '723325 - Pintor por imersão',
		label: '723325 - Pintor por imersão',
	},
	{
		value: '723320 - Pintor de veículos (fabricação)',
		label: '723320 - Pintor de veículos (fabricação)',
	},
	{
		value: '723315 - Pintor de estruturas metálicas',
		label: '723315 - Pintor de estruturas metálicas',
	},
	{
		value: '723330 - Pintor, a  pistola (exceto obras e estruturas metálicas)',
		label: '723330 - Pintor, a  pistola (exceto obras e estruturas metálicas)',
	},
	{
		value: '724135 - Instalador de tubulações de vapor (produção e distribuição)',
		label: '724135 - Instalador de tubulações de vapor (produção e distribuição)',
	},
	{
		value: '724105 - Assentador de canalização (edificações)',
		label: '724105 - Assentador de canalização (edificações)',
	},
	{ value: '724110 - Encanador', label: '724110 - Encanador' },
	{
		value: '724115 - Instalador de tubulações',
		label: '724115 - Instalador de tubulações',
	},
	{
		value: '724120 - Instalador de tubulações (aeronaves)',
		label: '724120 - Instalador de tubulações (aeronaves)',
	},
	{
		value: '724130 - Instalador de tubulações de gás combustível (produção e distribuição)',
		label: '724130 - Instalador de tubulações de gás combustível (produção e distribuição)',
	},
	{
		value: '724125 - Instalador de tubulações (embarcações)',
		label: '724125 - Instalador de tubulações (embarcações)',
	},
	{
		value: '724230 - Rebitador, a  mão',
		label: '724230 - Rebitador, a  mão',
	},
	{
		value: '724225 - Riscador de estruturas metálicas',
		label: '724225 - Riscador de estruturas metálicas',
	},
	{
		value: '724220 - Preparador de estruturas metálicas',
		label: '724220 - Preparador de estruturas metálicas',
	},
	{
		value: '724215 - Rebitador a  martelo pneumático',
		label: '724215 - Rebitador a  martelo pneumático',
	},
	{
		value: '724205 - Montador de estruturas metálicas',
		label: '724205 - Montador de estruturas metálicas',
	},
	{
		value: '724210 - Montador de estruturas metálicas de embarcações',
		label: '724210 - Montador de estruturas metálicas de embarcações',
	},
	{ value: '724305 - Brasador', label: '724305 - Brasador' },
	{
		value: '724325 - Soldador elétrico',
		label: '724325 - Soldador elétrico',
	},
	{
		value: '724320 - Soldador a  oxigás',
		label: '724320 - Soldador a  oxigás',
	},
	{ value: '724315 - Soldador', label: '724315 - Soldador' },
	{
		value: '724310 - Oxicortador a mão e a  máquina',
		label: '724310 - Oxicortador a mão e a  máquina',
	},
	{ value: '724440 - Serralheiro', label: '724440 - Serralheiro' },
	{
		value: '724405 - Caldeireiro (chapas de cobre)',
		label: '724405 - Caldeireiro (chapas de cobre)',
	},
	{
		value: '724435 - Funileiro industrial',
		label: '724435 - Funileiro industrial',
	},
	{
		value: '724430 - Chapeador de aeronaves',
		label: '724430 - Chapeador de aeronaves',
	},
	{ value: '724425 - Chapeador naval', label: '724425 - Chapeador naval' },
	{
		value: '724410 - Caldeireiro (chapas de ferro e aço)',
		label: '724410 - Caldeireiro (chapas de ferro e aço)',
	},
	{ value: '724415 - Chapeador', label: '724415 - Chapeador' },
	{
		value: '724420 - Chapeador de carrocerias metálicas (fabricação)',
		label: '724420 - Chapeador de carrocerias metálicas (fabricação)',
	},
	{
		value: '724515 - Prensista (operador de prensa)',
		label: '724515 - Prensista (operador de prensa)',
	},
	{
		value: '724510 - Operador de máquina de dobrar chapas',
		label: '724510 - Operador de máquina de dobrar chapas',
	},
	{
		value: '724505 - Operador de máquina de cilindrar chapas',
		label: '724505 - Operador de máquina de cilindrar chapas',
	},
	{
		value: '724605 - Operador de laços de cabos de aço',
		label: '724605 - Operador de laços de cabos de aço',
	},
	{
		value: '724610 - Trançador de cabos de aço',
		label: '724610 - Trançador de cabos de aço',
	},
	{
		value: '725005 - Ajustador ferramenteiro',
		label: '725005 - Ajustador ferramenteiro',
	},
	{
		value: '725010 - Ajustador mecânico',
		label: '725010 - Ajustador mecânico',
	},
	{
		value: '725015 - Ajustador mecânico (usinagem em bancada e em máquinas-ferramentas)',
		label: '725015 - Ajustador mecânico (usinagem em bancada e em máquinas-ferramentas)',
	},
	{
		value: '725020 - Ajustador mecânico em bancada',
		label: '725020 - Ajustador mecânico em bancada',
	},
	{
		value: '725025 - Ajustador naval (reparo e construção)',
		label: '725025 - Ajustador naval (reparo e construção)',
	},
	{
		value: '725105 - Montador de máquinas, motores e acessórios (montagem em série)',
		label: '725105 - Montador de máquinas, motores e acessórios (montagem em série)',
	},
	{
		value: '725205 - Montador de máquinas',
		label: '725205 - Montador de máquinas',
	},
	{
		value: '725210 - Montador de máquinas gráficas',
		label: '725210 - Montador de máquinas gráficas',
	},
	{
		value: '725225 - Montador de máquinas-ferramentas (usinagem de metais)',
		label: '725225 - Montador de máquinas-ferramentas (usinagem de metais)',
	},
	{
		value: '725220 - Montador de máquinas têxteis',
		label: '725220 - Montador de máquinas têxteis',
	},
	{
		value: '725215 - Montador de máquinas operatrizes para madeira',
		label: '725215 - Montador de máquinas operatrizes para madeira',
	},
	{
		value: '725315 - Montador de máquinas de minas e pedreiras',
		label: '725315 - Montador de máquinas de minas e pedreiras',
	},
	{
		value: '725310 - Montador de máquinas agrícolas',
		label: '725310 - Montador de máquinas agrícolas',
	},
	{
		value: '725320 - Montador de máquinas de terraplenagem',
		label: '725320 - Montador de máquinas de terraplenagem',
	},
	{
		value: '725305 - Montador de equipamento de levantamento',
		label: '725305 - Montador de equipamento de levantamento',
	},
	{
		value: '725410 - Mecânico montador de motores de embarcações',
		label: '725410 - Mecânico montador de motores de embarcações',
	},
	{
		value: '725405 - Mecânico montador de motores de aeronaves',
		label: '725405 - Mecânico montador de motores de aeronaves',
	},
	{
		value: '725415 - Mecânico montador de motores de explosão e diesel',
		label: '725415 - Mecânico montador de motores de explosão e diesel',
	},
	{
		value: '725420 - Mecânico montador de turboalimentadores',
		label: '725420 - Mecânico montador de turboalimentadores',
	},
	{
		value: '725505 - Montador de veículos (linha de montagem)',
		label: '725505 - Montador de veículos (linha de montagem)',
	},
	{
		value: '725510 - Operador de time de montagem',
		label: '725510 - Operador de time de montagem',
	},
	{
		value: '725605 - Montador de estruturas de aeronaves',
		label: '725605 - Montador de estruturas de aeronaves',
	},
	{
		value: '725610 - Montador de sistemas de combustível de aeronaves',
		label: '725610 - Montador de sistemas de combustível de aeronaves',
	},
	{
		value: '725705 - Mecânico de refrigeração',
		label: '725705 - Mecânico de refrigeração',
	},
	{
		value: '730105 - Supervisor de montagem e instalação eletroeletrônica',
		label: '730105 - Supervisor de montagem e instalação eletroeletrônica',
	},
	{
		value: '731115 - Montador de equipamentos elétricos (instrumentos de medição)',
		label: '731115 - Montador de equipamentos elétricos (instrumentos de medição)',
	},
	{
		value: '731120 - Montador de equipamentos elétricos (aparelhos eletrodomésticos)',
		label: '731120 - Montador de equipamentos elétricos (aparelhos eletrodomésticos)',
	},
	{
		value: '731125 - Montador de equipamentos elétricos (centrais elétricas)',
		label: '731125 - Montador de equipamentos elétricos (centrais elétricas)',
	},
	{
		value: '731130 - Montador de equipamentos elétricos (motores e dínamos)',
		label: '731130 - Montador de equipamentos elétricos (motores e dínamos)',
	},
	{
		value: '731135 - Montador de equipamentos elétricos',
		label: '731135 - Montador de equipamentos elétricos',
	},
	{
		value: '731140 - Montador de equipamentos eletrônicos (instalações de sinalização)',
		label: '731140 - Montador de equipamentos eletrônicos (instalações de sinalização)',
	},
	{
		value: '731145 - Montador de equipamentos eletrônicos (máquinas industriais)',
		label: '731145 - Montador de equipamentos eletrônicos (máquinas industriais)',
	},
	{
		value: '731150 - Montador de equipamentos eletrônicos',
		label: '731150 - Montador de equipamentos eletrônicos',
	},
	{
		value: '731155 - Montador de equipamentos elétricos (elevadores e equipamentos similares)',
		label: '731155 - Montador de equipamentos elétricos (elevadores e equipamentos similares)',
	},
	{
		value: '731160 - Montador de equipamentos elétricos (transformadores)',
		label: '731160 - Montador de equipamentos elétricos (transformadores)',
	},
	{
		value: '731165 - Bobinador eletricista, à mão',
		label: '731165 - Bobinador eletricista, à mão',
	},
	{
		value: '731170 - Bobinador eletricista, à máquina',
		label: '731170 - Bobinador eletricista, à máquina',
	},
	{
		value: '731175 - Operador de linha de montagem (aparelhos elétricos)',
		label: '731175 - Operador de linha de montagem (aparelhos elétricos)',
	},
	{
		value: '731180 - Operador de linha de montagem (aparelhos eletrônicos)',
		label: '731180 - Operador de linha de montagem (aparelhos eletrônicos)',
	},
	{
		value: '731105 - Montador de equipamentos eletrônicos (aparelhos médicos)',
		label: '731105 - Montador de equipamentos eletrônicos (aparelhos médicos)',
	},
	{
		value: '731110 - Montador de equipamentos eletrônicos (computadores e equipamentos auxiliares)',
		label: '731110 - Montador de equipamentos eletrônicos (computadores e equipamentos auxiliares)',
	},
	{
		value: '731205 - Montador de equipamentos eletrônicos (estação de rádio, tv e equipamentos de radar)',
		label: '731205 - Montador de equipamentos eletrônicos (estação de rádio, tv e equipamentos de radar)',
	},
	{
		value: '731310 - Instalador-reparador de equipamentos de energia em telefonia',
		label: '731310 - Instalador-reparador de equipamentos de energia em telefonia',
	},
	{
		value: '731315 - Instalador-reparador de equipamentos de transmissão em telefonia',
		label: '731315 - Instalador-reparador de equipamentos de transmissão em telefonia',
	},
	{
		value: '731320 - Instalador-reparador de linhas e aparelhos de telecomunicações',
		label: '731320 - Instalador-reparador de linhas e aparelhos de telecomunicações',
	},
	{
		value: '731325 - Instalador-reparador de redes e cabos telefônicos',
		label: '731325 - Instalador-reparador de redes e cabos telefônicos',
	},
	{
		value: '731305 - Instalador-reparador de equipamentos de comutação em telefonia',
		label: '731305 - Instalador-reparador de equipamentos de comutação em telefonia',
	},
	{
		value: '731330 - Reparador de aparelhos de telecomunicações em laboratório',
		label: '731330 - Reparador de aparelhos de telecomunicações em laboratório',
	},
	{
		value: '732105 - Eletricista de manutenção de linhas elétricas, telefônicas e de comunicação de dados',
		label: '732105 - Eletricista de manutenção de linhas elétricas, telefônicas e de comunicação de dados',
	},
	{
		value: '732110 - Emendador de cabos elétricos e telefônicos (aéreos e subterrâneos)',
		label: '732110 - Emendador de cabos elétricos e telefônicos (aéreos e subterrâneos)',
	},
	{
		value: '732115 - Examinador de cabos, linhas elétricas e telefônicas',
		label: '732115 - Examinador de cabos, linhas elétricas e telefônicas',
	},
	{
		value: '732120 - Instalador de linhas elétricas de alta e baixa - tensão (rede aérea e subterrânea)',
		label: '732120 - Instalador de linhas elétricas de alta e baixa - tensão (rede aérea e subterrânea)',
	},
	{
		value: '732125 - Instalador eletricista (tração de veículos)',
		label: '732125 - Instalador eletricista (tração de veículos)',
	},
	{
		value: '732130 - Instalador-reparador de redes telefônicas e de comunicação de dados',
		label: '732130 - Instalador-reparador de redes telefônicas e de comunicação de dados',
	},
	{
		value: '732135 - Ligador de linhas telefônicas',
		label: '732135 - Ligador de linhas telefônicas',
	},
	{
		value: '740110 - Supervisor de fabricação de instrumentos musicais',
		label: '740110 - Supervisor de fabricação de instrumentos musicais',
	},
	{
		value: '740105 - Supervisor da mecânica de precisão',
		label: '740105 - Supervisor da mecânica de precisão',
	},
	{
		value: '741125 - Relojoeiro (reparação)',
		label: '741125 - Relojoeiro (reparação)',
	},
	{
		value: '741120 - Relojoeiro (fabricação)',
		label: '741120 - Relojoeiro (fabricação)',
	},
	{
		value: '741115 - Montador de instrumentos de precisão',
		label: '741115 - Montador de instrumentos de precisão',
	},
	{
		value: '741110 - Montador de instrumentos de óptica',
		label: '741110 - Montador de instrumentos de óptica',
	},
	{
		value: '741105 - Ajustador de instrumentos de precisão',
		label: '741105 - Ajustador de instrumentos de precisão',
	},
	{
		value: '742135 - Confeccionador de órgão',
		label: '742135 - Confeccionador de órgão',
	},
	{
		value: '742130 - Confeccionador de instrumentos de sopro (metal)',
		label: '742130 - Confeccionador de instrumentos de sopro (metal)',
	},
	{
		value: '742125 - Confeccionador de instrumentos de sopro (madeira)',
		label: '742125 - Confeccionador de instrumentos de sopro (madeira)',
	},
	{
		value: '742120 - Confeccionador de instrumentos de percussão (pele, couro ou plástico)',
		label: '742120 - Confeccionador de instrumentos de percussão (pele, couro ou plástico)',
	},
	{
		value: '742115 - Confeccionador de instrumentos de corda',
		label: '742115 - Confeccionador de instrumentos de corda',
	},
	{
		value: '742110 - Confeccionador de acordeão',
		label: '742110 - Confeccionador de acordeão',
	},
	{
		value: '742140 - Confeccionador de piano',
		label: '742140 - Confeccionador de piano',
	},
	{
		value: '742105 - Afinador de instrumentos musicais',
		label: '742105 - Afinador de instrumentos musicais',
	},
	{
		value: '750105 - Supervisor de joalheria',
		label: '750105 - Supervisor de joalheria',
	},
	{
		value: '750205 - Supervisor da indústria de minerais não metálicos (exceto os derivados de petróleo e carvão)',
		label: '750205 - Supervisor da indústria de minerais não metálicos (exceto os derivados de petróleo e carvão)',
	},
	{
		value: '751005 - Engastador (jóias)',
		label: '751005 - Engastador (jóias)',
	},
	{ value: '751010 - Joalheiro', label: '751010 - Joalheiro' },
	{
		value: '751015 - Joalheiro (reparações)',
		label: '751015 - Joalheiro (reparações)',
	},
	{
		value: '751020 - Lapidador (jóias)',
		label: '751020 - Lapidador (jóias)',
	},
	{
		value: '751105 - Bate-folha a  máquina',
		label: '751105 - Bate-folha a  máquina',
	},
	{
		value: '751110 - Fundidor (joalheria e ourivesaria)',
		label: '751110 - Fundidor (joalheria e ourivesaria)',
	},
	{
		value: '751130 - Trefilador (joalheria e ourivesaria)',
		label: '751130 - Trefilador (joalheria e ourivesaria)',
	},
	{ value: '751125 - Ourives', label: '751125 - Ourives' },
	{
		value: '751120 - Laminador de metais preciosos a  mão',
		label: '751120 - Laminador de metais preciosos a  mão',
	},
	{
		value: '751115 - Gravador (joalheria e ourivesaria)',
		label: '751115 - Gravador (joalheria e ourivesaria)',
	},
	{
		value: '752110 - Moldador (vidros)',
		label: '752110 - Moldador (vidros)',
	},
	{
		value: '752105 - Artesão modelador (vidros)',
		label: '752105 - Artesão modelador (vidros)',
	},
	{
		value: '752115 - Soprador de vidro',
		label: '752115 - Soprador de vidro',
	},
	{
		value: '752120 - Transformador de tubos de vidro',
		label: '752120 - Transformador de tubos de vidro',
	},
	{
		value: '752230 - Lapidador de vidros e cristais',
		label: '752230 - Lapidador de vidros e cristais',
	},
	{ value: '752235 - Surfassagista', label: '752235 - Surfassagista' },
	{
		value: '752205 - Aplicador serigráfico em vidros',
		label: '752205 - Aplicador serigráfico em vidros',
	},
	{
		value: '752210 - Cortador de vidro',
		label: '752210 - Cortador de vidro',
	},
	{
		value: '752215 - Gravador de vidro a  água-forte',
		label: '752215 - Gravador de vidro a  água-forte',
	},
	{
		value: '752220 - Gravador de vidro a  esmeril',
		label: '752220 - Gravador de vidro a  esmeril',
	},
	{
		value: '752225 - Gravador de vidro a  jato de areia',
		label: '752225 - Gravador de vidro a  jato de areia',
	},
	{ value: '752305 - Ceramista', label: '752305 - Ceramista' },
	{
		value: '752310 - Ceramista (torno de pedal e motor)',
		label: '752310 - Ceramista (torno de pedal e motor)',
	},
	{
		value: '752315 - Ceramista (torno semi-automático)',
		label: '752315 - Ceramista (torno semi-automático)',
	},
	{
		value: '752320 - Ceramista modelador',
		label: '752320 - Ceramista modelador',
	},
	{
		value: '752325 - Ceramista moldador',
		label: '752325 - Ceramista moldador',
	},
	{
		value: '752330 - Ceramista prensador',
		label: '752330 - Ceramista prensador',
	},
	{
		value: '752405 - Decorador de cerâmica',
		label: '752405 - Decorador de cerâmica',
	},
	{
		value: '752410 - Decorador de vidro',
		label: '752410 - Decorador de vidro',
	},
	{
		value: '752415 - Decorador de vidro à pincel',
		label: '752415 - Decorador de vidro à pincel',
	},
	{
		value: '752420 - Operador de esmaltadeira',
		label: '752420 - Operador de esmaltadeira',
	},
	{
		value: '752425 - Operador de espelhamento',
		label: '752425 - Operador de espelhamento',
	},
	{
		value: '752430 - Pintor de cerâmica, a  pincel',
		label: '752430 - Pintor de cerâmica, a  pincel',
	},
	{
		value: '760110 - Contramestre de fiação (indústria têxtil)',
		label: '760110 - Contramestre de fiação (indústria têxtil)',
	},
	{
		value: '760120 - Contramestre de tecelagem (indústria têxtil)',
		label: '760120 - Contramestre de tecelagem (indústria têxtil)',
	},
	{
		value: '760105 - Contramestre de acabamento (indústria têxtil)',
		label: '760105 - Contramestre de acabamento (indústria têxtil)',
	},
	{
		value: '760125 - Mestre (indústria têxtil e de confecções)',
		label: '760125 - Mestre (indústria têxtil e de confecções)',
	},
	{
		value: '760115 - Contramestre de malharia (indústria têxtil)',
		label: '760115 - Contramestre de malharia (indústria têxtil)',
	},
	{
		value: '760205 - Supervisor de curtimento',
		label: '760205 - Supervisor de curtimento',
	},
	{
		value: '760310 - Encarregado de costura na confecção do vestuário',
		label: '760310 - Encarregado de costura na confecção do vestuário',
	},
	{
		value: '760305 - Encarregado de corte na confecção do vestuário',
		label: '760305 - Encarregado de corte na confecção do vestuário',
	},
	{
		value: '760405 - Supervisor  (indústria de calçados e artefatos de couro)',
		label: '760405 - Supervisor  (indústria de calçados e artefatos de couro)',
	},
	{
		value: '760505 - Supervisor da confecção de artefatos de tecidos, couros e afins',
		label: '760505 - Supervisor da confecção de artefatos de tecidos, couros e afins',
	},
	{
		value: '760605 - Supervisor das artes gráficas  (indústria editorial e gráfica)',
		label: '760605 - Supervisor das artes gráficas  (indústria editorial e gráfica)',
	},
	{
		value: '761005 - Operador polivalente da indústria têxtil',
		label: '761005 - Operador polivalente da indústria têxtil',
	},
	{ value: '761110 - Lavador de lã', label: '761110 - Lavador de lã' },
	{
		value: '761105 - Classificador de fibras têxteis',
		label: '761105 - Classificador de fibras têxteis',
	},
	{
		value: '761210 - Operador de binadeira',
		label: '761210 - Operador de binadeira',
	},
	{
		value: '761260 - Operador de retorcedeira',
		label: '761260 - Operador de retorcedeira',
	},
	{
		value: '761255 - Operador de penteadeira',
		label: '761255 - Operador de penteadeira',
	},
	{
		value: '761250 - Operador de passador (fiação)',
		label: '761250 - Operador de passador (fiação)',
	},
	{
		value: '761245 - Operador de open-end',
		label: '761245 - Operador de open-end',
	},
	{
		value: '761240 - Operador de maçaroqueira',
		label: '761240 - Operador de maçaroqueira',
	},
	{
		value: '761235 - Operador de laminadeira e reunideira',
		label: '761235 - Operador de laminadeira e reunideira',
	},
	{
		value: '761230 - Operador de filatório',
		label: '761230 - Operador de filatório',
	},
	{
		value: '761225 - Operador de conicaleira',
		label: '761225 - Operador de conicaleira',
	},
	{
		value: '761220 - Operador de cardas',
		label: '761220 - Operador de cardas',
	},
	{
		value: '761215 - Operador de bobinadeira',
		label: '761215 - Operador de bobinadeira',
	},
	{
		value: '761205 - Operador de abertura (fiação)',
		label: '761205 - Operador de abertura (fiação)',
	},
	{
		value: '761312 - Tecelão (tear jacquard)',
		label: '761312 - Tecelão (tear jacquard)',
	},
	{
		value: '761321 - Tecelão (tear mecânico liso)',
		label: '761321 - Tecelão (tear mecânico liso)',
	},
	{
		value: '761330 - Tecelão de malhas (máquina circular)',
		label: '761330 - Tecelão de malhas (máquina circular)',
	},
	{
		value: '761333 - Tecelão de malhas (máquina retilínea)',
		label: '761333 - Tecelão de malhas (máquina retilínea)',
	},
	{
		value: '761348 - Operador de engomadeira de urdume',
		label: '761348 - Operador de engomadeira de urdume',
	},
	{
		value: '761351 - Operador de espuladeira',
		label: '761351 - Operador de espuladeira',
	},
	{
		value: '761357 - Operador de urdideira',
		label: '761357 - Operador de urdideira',
	},
	{
		value: '761360 - Passamaneiro a  máquina',
		label: '761360 - Passamaneiro a  máquina',
	},
	{
		value: '761363 - Remetedor de fios',
		label: '761363 - Remetedor de fios',
	},
	{ value: '761303 - Tecelão (redes)', label: '761303 - Tecelão (redes)' },
	{
		value: '761306 - Tecelão (rendas e bordados)',
		label: '761306 - Tecelão (rendas e bordados)',
	},
	{
		value: '761315 - Tecelão (tear mecânico de maquineta)',
		label: '761315 - Tecelão (tear mecânico de maquineta)',
	},
	{
		value: '761318 - Tecelão (tear mecânico de xadrez)',
		label: '761318 - Tecelão (tear mecânico de xadrez)',
	},
	{
		value: '761324 - Tecelão (tear mecânico, exceto jacquard)',
		label: '761324 - Tecelão (tear mecânico, exceto jacquard)',
	},
	{
		value: '761327 - Tecelão de malhas, a  máquina',
		label: '761327 - Tecelão de malhas, a  máquina',
	},
	{
		value: '761336 - Tecelão de meias, a  máquina',
		label: '761336 - Tecelão de meias, a  máquina',
	},
	{
		value: '761339 - Tecelão de meias (máquina circular)',
		label: '761339 - Tecelão de meias (máquina circular)',
	},
	{
		value: '761342 - Tecelão de meias (máquina retilínea)',
		label: '761342 - Tecelão de meias (máquina retilínea)',
	},
	{
		value: '761345 - Tecelão de tapetes, a  máquina',
		label: '761345 - Tecelão de tapetes, a  máquina',
	},
	{
		value: '761354 - Operador de máquina de cordoalha',
		label: '761354 - Operador de máquina de cordoalha',
	},
	{
		value: '761366 - Picotador de cartões jacquard',
		label: '761366 - Picotador de cartões jacquard',
	},
	{
		value: '761309 - Tecelão (tear automático)',
		label: '761309 - Tecelão (tear automático)',
	},
	{
		value: '761405 - Alvejador (tecidos)',
		label: '761405 - Alvejador (tecidos)',
	},
	{
		value: '761410 - Estampador de tecido',
		label: '761410 - Estampador de tecido',
	},
	{
		value: '761415 - Operador de calandras (tecidos)',
		label: '761415 - Operador de calandras (tecidos)',
	},
	{
		value: '761420 - Operador de chamuscadeira de tecidos',
		label: '761420 - Operador de chamuscadeira de tecidos',
	},
	{
		value: '761425 - Operador de impermeabilizador de tecidos',
		label: '761425 - Operador de impermeabilizador de tecidos',
	},
	{
		value: '761430 - Operador de máquina de lavar fios e tecidos',
		label: '761430 - Operador de máquina de lavar fios e tecidos',
	},
	{
		value: '761435 - Operador de rameuse',
		label: '761435 - Operador de rameuse',
	},
	{
		value: '761805 - Inspetor de estamparia (produção têxtil)',
		label: '761805 - Inspetor de estamparia (produção têxtil)',
	},
	{
		value: '761810 - Revisor de fios (produção têxtil)',
		label: '761810 - Revisor de fios (produção têxtil)',
	},
	{
		value: '761815 - Revisor de tecidos acabados',
		label: '761815 - Revisor de tecidos acabados',
	},
	{
		value: '761820 - Revisor de tecidos crus',
		label: '761820 - Revisor de tecidos crus',
	},
	{
		value: '762005 - Trabalhador polivalente do curtimento de couros e peles',
		label: '762005 - Trabalhador polivalente do curtimento de couros e peles',
	},
	{
		value: '762110 - Descarnador de couros e peles, à maquina',
		label: '762110 - Descarnador de couros e peles, à maquina',
	},
	{
		value: '762105 - Classificador de peles',
		label: '762105 - Classificador de peles',
	},
	{
		value: '762115 - Estirador de couros e peles (preparação)',
		label: '762115 - Estirador de couros e peles (preparação)',
	},
	{ value: '762120 - Fuloneiro', label: '762120 - Fuloneiro' },
	{
		value: '762125 - Rachador de couros e peles',
		label: '762125 - Rachador de couros e peles',
	},
	{
		value: '762215 - Enxugador de couros',
		label: '762215 - Enxugador de couros',
	},
	{
		value: '762210 - Classificador de couros',
		label: '762210 - Classificador de couros',
	},
	{
		value: '762205 - Curtidor (couros e peles)',
		label: '762205 - Curtidor (couros e peles)',
	},
	{
		value: '762220 - Rebaixador de couros',
		label: '762220 - Rebaixador de couros',
	},
	{
		value: '762305 - Estirador de couros e peles (acabamento)',
		label: '762305 - Estirador de couros e peles (acabamento)',
	},
	{
		value: '762310 - Fuloneiro no acabamento de couros e peles',
		label: '762310 - Fuloneiro no acabamento de couros e peles',
	},
	{
		value: '762315 - Lixador de couros e peles',
		label: '762315 - Lixador de couros e peles',
	},
	{
		value: '762320 - Matizador de couros e peles',
		label: '762320 - Matizador de couros e peles',
	},
	{
		value: '762345 - Vaqueador de couros e peles',
		label: '762345 - Vaqueador de couros e peles',
	},
	{
		value: '762330 - Prensador de couros e peles',
		label: '762330 - Prensador de couros e peles',
	},
	{
		value: '762335 - Palecionador de couros e peles',
		label: '762335 - Palecionador de couros e peles',
	},
	{
		value: '762340 - Preparador de couros curtidos',
		label: '762340 - Preparador de couros curtidos',
	},
	{
		value: '762325 - Operador de máquinas do acabamento de couros e peles',
		label: '762325 - Operador de máquinas do acabamento de couros e peles',
	},
	{
		value: '763020 - Costureiro de roupa de couro e pele',
		label: '763020 - Costureiro de roupa de couro e pele',
	},
	{ value: '763005 - Alfaiate', label: '763005 - Alfaiate' },
	{
		value: '763010 - Costureira de peças sob encomenda',
		label: '763010 - Costureira de peças sob encomenda',
	},
	{
		value: '763015 - Costureira de reparação de roupas',
		label: '763015 - Costureira de reparação de roupas',
	},
	{
		value: '763125 - Ajudante de confecção',
		label: '763125 - Ajudante de confecção',
	},
	{
		value: '763120 - Riscador de roupas',
		label: '763120 - Riscador de roupas',
	},
	{
		value: '763115 - Enfestador de roupas',
		label: '763115 - Enfestador de roupas',
	},
	{
		value: '763105 - Auxiliar de corte (preparação da confecção de roupas)',
		label: '763105 - Auxiliar de corte (preparação da confecção de roupas)',
	},
	{
		value: '763110 - Cortador de roupas',
		label: '763110 - Cortador de roupas',
	},
	{
		value: '763215 - Costureiro, a  máquina  na confecção em série',
		label: '763215 - Costureiro, a  máquina  na confecção em série',
	},
	{
		value: '763210 - Costureiro na confecção em série',
		label: '763210 - Costureiro na confecção em série',
	},
	{
		value: '763205 - Costureiro de roupas de couro e pele, a  máquina na  confecção em série',
		label: '763205 - Costureiro de roupas de couro e pele, a  máquina na  confecção em série',
	},
	{
		value: '763310 - Bordador, à máquina',
		label: '763310 - Bordador, à máquina',
	},
	{
		value: '763315 - Marcador de peças confeccionadas para bordar',
		label: '763315 - Marcador de peças confeccionadas para bordar',
	},
	{
		value: '763320 - Operador de máquina de costura de acabamento',
		label: '763320 - Operador de máquina de costura de acabamento',
	},
	{
		value: '763325 - Passadeira de peças confeccionadas',
		label: '763325 - Passadeira de peças confeccionadas',
	},
	{ value: '763305 - Arrematadeira', label: '763305 - Arrematadeira' },
	{
		value: '764005 - Trabalhador polivalente da confecção de calçados',
		label: '764005 - Trabalhador polivalente da confecção de calçados',
	},
	{
		value: '764110 - Cortador de solas e palmilhas, a  máquina',
		label: '764110 - Cortador de solas e palmilhas, a  máquina',
	},
	{
		value: '764105 - Cortador de calçados, a  máquina (exceto solas e palmilhas)',
		label: '764105 - Cortador de calçados, a  máquina (exceto solas e palmilhas)',
	},
	{
		value: '764115 - Preparador de calçados',
		label: '764115 - Preparador de calçados',
	},
	{
		value: '764120 - Preparador de solas e palmilhas',
		label: '764120 - Preparador de solas e palmilhas',
	},
	{
		value: '764205 - Costurador de calçados, a  máquina',
		label: '764205 - Costurador de calçados, a  máquina',
	},
	{
		value: '764210 - Montador de calçados',
		label: '764210 - Montador de calçados',
	},
	{
		value: '764305 - Acabador de calçados',
		label: '764305 - Acabador de calçados',
	},
	{
		value: '765010 - Chapeleiro de senhoras',
		label: '765010 - Chapeleiro de senhoras',
	},
	{
		value: '765005 - Confeccionador de artefatos de couro (exceto sapatos)',
		label: '765005 - Confeccionador de artefatos de couro (exceto sapatos)',
	},
	{ value: '765015 - Boneleiro', label: '765015 - Boneleiro' },
	{
		value: '765105 - Cortador de artefatos de couro (exceto roupas e calçados)',
		label: '765105 - Cortador de artefatos de couro (exceto roupas e calçados)',
	},
	{
		value: '765110 - Cortador de tapeçaria',
		label: '765110 - Cortador de tapeçaria',
	},
	{
		value: '765240 - Tapeceiro de autos',
		label: '765240 - Tapeceiro de autos',
	},
	{
		value: '765235 - Estofador de móveis',
		label: '765235 - Estofador de móveis',
	},
	{
		value: '765225 - Confeccionador de velas náuticas, barracas e toldos',
		label: '765225 - Confeccionador de velas náuticas, barracas e toldos',
	},
	{
		value: '765215 - Confeccionador de brinquedos de pano',
		label: '765215 - Confeccionador de brinquedos de pano',
	},
	{
		value: '765205 - Colchoeiro (confecção de colchões)',
		label: '765205 - Colchoeiro (confecção de colchões)',
	},
	{
		value: '765230 - Estofador de aviões',
		label: '765230 - Estofador de aviões',
	},
	{
		value: '765310 - Costurador de artefatos de couro, a  máquina (exceto roupas e calçados)',
		label: '765310 - Costurador de artefatos de couro, a  máquina (exceto roupas e calçados)',
	},
	{
		value: '765315 - Montador de artefatos de couro (exceto roupas e calçados)',
		label: '765315 - Montador de artefatos de couro (exceto roupas e calçados)',
	},
	{
		value: '765405 - Trabalhador do acabamento de artefatos de tecidos e couros',
		label: '765405 - Trabalhador do acabamento de artefatos de tecidos e couros',
	},
	{
		value: '766115 - Gravador de matriz para flexografia (clicherista)',
		label: '766115 - Gravador de matriz para flexografia (clicherista)',
	},
	{
		value: '766105 - Copiador de chapa',
		label: '766105 - Copiador de chapa',
	},
	{
		value: '766155 - Programador visual gráfico',
		label: '766155 - Programador visual gráfico',
	},
	{
		value: '766150 - Operador de processo de tratamento de imagem',
		label: '766150 - Operador de processo de tratamento de imagem',
	},
	{
		value: '766145 - Operador de sistemas de prova (analógico e digital)',
		label: '766145 - Operador de sistemas de prova (analógico e digital)',
	},
	{
		value: '766140 - Gravador de matriz serigráfica',
		label: '766140 - Gravador de matriz serigráfica',
	},
	{
		value: '766135 - Gravador de matriz calcográfica',
		label: '766135 - Gravador de matriz calcográfica',
	},
	{
		value: '766130 - Gravador de matriz para rotogravura (eletromecânico e químico)',
		label: '766130 - Gravador de matriz para rotogravura (eletromecânico e químico)',
	},
	{
		value: '766125 - Montador de fotolito (analógico e digital)',
		label: '766125 - Montador de fotolito (analógico e digital)',
	},
	{
		value: '766120 - Editor de texto e imagem',
		label: '766120 - Editor de texto e imagem',
	},
	{
		value: '766230 - Impressor digital',
		label: '766230 - Impressor digital',
	},
	{
		value: '766225 - Impressor de rotogravura',
		label: '766225 - Impressor de rotogravura',
	},
	{
		value: '766220 - Impressor de rotativa',
		label: '766220 - Impressor de rotativa',
	},
	{
		value: '766215 - Impressor de ofsete (plano e rotativo)',
		label: '766215 - Impressor de ofsete (plano e rotativo)',
	},
	{
		value: '766240 - Impressor letterset',
		label: '766240 - Impressor letterset',
	},
	{
		value: '766205 - Impressor (serigrafia)',
		label: '766205 - Impressor (serigrafia)',
	},
	{
		value: '766235 - Impressor flexográfico',
		label: '766235 - Impressor flexográfico',
	},
	{
		value: '766245 - Impressor tampográfico',
		label: '766245 - Impressor tampográfico',
	},
	{
		value: '766250 - Impressor tipográfico',
		label: '766250 - Impressor tipográfico',
	},
	{
		value: '766210 - Impressor calcográfico',
		label: '766210 - Impressor calcográfico',
	},
	{
		value: '766310 - Impressor de corte e vinco',
		label: '766310 - Impressor de corte e vinco',
	},
	{
		value: '766305 - Acabador de embalagens (flexíveis e cartotécnicas)',
		label: '766305 - Acabador de embalagens (flexíveis e cartotécnicas)',
	},
	{
		value: '766320 - Operador de guilhotina (corte de papel)',
		label: '766320 - Operador de guilhotina (corte de papel)',
	},
	{
		value: '766315 - Operador de acabamento (indústria gráfica)',
		label: '766315 - Operador de acabamento (indústria gráfica)',
	},
	{
		value: '766325 - Preparador de matrizes de corte e vinco',
		label: '766325 - Preparador de matrizes de corte e vinco',
	},
	{
		value: '766405 - Laboratorista fotográfico',
		label: '766405 - Laboratorista fotográfico',
	},
	{
		value: '766410 - Revelador de filmes fotográficos, em preto e branco',
		label: '766410 - Revelador de filmes fotográficos, em preto e branco',
	},
	{
		value: '766420 - Auxiliar de radiologia (revelação fotográfica)',
		label: '766420 - Auxiliar de radiologia (revelação fotográfica)',
	},
	{
		value: '766415 - Revelador de filmes fotográficos, em cores',
		label: '766415 - Revelador de filmes fotográficos, em cores',
	},
	{
		value: '768105 - Tecelão (tear manual)',
		label: '768105 - Tecelão (tear manual)',
	},
	{
		value: '768130 - Crocheteiro, a  mão',
		label: '768130 - Crocheteiro, a  mão',
	},
	{
		value: '768125 - Chapeleiro (chapéus de palha)',
		label: '768125 - Chapeleiro (chapéus de palha)',
	},
	{ value: '768120 - Redeiro', label: '768120 - Redeiro' },
	{
		value: '768115 - Tricoteiro, à mão',
		label: '768115 - Tricoteiro, à mão',
	},
	{
		value: '768110 - Tecelão de tapetes, a  mão',
		label: '768110 - Tecelão de tapetes, a  mão',
	},
	{ value: '768205 - Bordador, a  mão', label: '768205 - Bordador, a  mão' },
	{ value: '768210 - Cerzidor', label: '768210 - Cerzidor' },
	{
		value: '768315 - Costurador de artefatos de couro, a  mão (exceto roupas e calçados)',
		label: '768315 - Costurador de artefatos de couro, a  mão (exceto roupas e calçados)',
	},
	{
		value: '768320 - Sapateiro (calçados sob medida)',
		label: '768320 - Sapateiro (calçados sob medida)',
	},
	{ value: '768325 - Seleiro', label: '768325 - Seleiro' },
	{
		value: '768305 - Artífice do couro',
		label: '768305 - Artífice do couro',
	},
	{
		value: '768310 - Cortador de calçados, a  mão (exceto solas)',
		label: '768310 - Cortador de calçados, a  mão (exceto solas)',
	},
	{ value: '768605 - Tipógrafo', label: '768605 - Tipógrafo' },
	{
		value: '768630 - Confeccionador de carimbos de borracha',
		label: '768630 - Confeccionador de carimbos de borracha',
	},
	{
		value: '768625 - Pintor de letreiros',
		label: '768625 - Pintor de letreiros',
	},
	{ value: '768620 - Paginador', label: '768620 - Paginador' },
	{ value: '768615 - Monotipista', label: '768615 - Monotipista' },
	{ value: '768610 - Linotipista', label: '768610 - Linotipista' },
	{
		value: '768705 - Gravador, à mão (encadernação)',
		label: '768705 - Gravador, à mão (encadernação)',
	},
	{
		value: '768710 - Restaurador de livros',
		label: '768710 - Restaurador de livros',
	},
	{
		value: '770105 - Mestre (indústria de madeira e mobiliário)',
		label: '770105 - Mestre (indústria de madeira e mobiliário)',
	},
	{
		value: '770110 - Mestre carpinteiro',
		label: '770110 - Mestre carpinteiro',
	},
	{ value: '771120 - Tanoeiro', label: '771120 - Tanoeiro' },
	{
		value: '771115 - Maquetista na marcenaria',
		label: '771115 - Maquetista na marcenaria',
	},
	{
		value: '771110 - Modelador de madeira',
		label: '771110 - Modelador de madeira',
	},
	{ value: '771105 - Marceneiro', label: '771105 - Marceneiro' },
	{
		value: '772105 - Classificador de madeira',
		label: '772105 - Classificador de madeira',
	},
	{
		value: '772110 - Impregnador de madeira',
		label: '772110 - Impregnador de madeira',
	},
	{
		value: '772115 - Secador de madeira',
		label: '772115 - Secador de madeira',
	},
	{
		value: '773125 - Serrador de madeira (serra circular múltipla)',
		label: '773125 - Serrador de madeira (serra circular múltipla)',
	},
	{
		value: '773130 - Serrador de madeira (serra de fita múltipla)',
		label: '773130 - Serrador de madeira (serra de fita múltipla)',
	},
	{
		value: '773120 - Serrador de madeira',
		label: '773120 - Serrador de madeira',
	},
	{
		value: '773115 - Serrador de bordas no desdobramento de madeira',
		label: '773115 - Serrador de bordas no desdobramento de madeira',
	},
	{
		value: '773105 - Cortador de laminados de madeira',
		label: '773105 - Cortador de laminados de madeira',
	},
	{
		value: '773110 - Operador de serras no desdobramento de madeira',
		label: '773110 - Operador de serras no desdobramento de madeira',
	},
	{
		value: '773220 - Preparador de aglomerantes',
		label: '773220 - Preparador de aglomerantes',
	},
	{
		value: '773215 - Prensista de compensados',
		label: '773215 - Prensista de compensados',
	},
	{
		value: '773210 - Prensista de aglomerados',
		label: '773210 - Prensista de aglomerados',
	},
	{
		value: '773205 - Operador de máquina intercaladora e placas (compensados)',
		label: '773205 - Operador de máquina intercaladora e placas (compensados)',
	},
	{
		value: '773315 - Operador de fresadora (usinagem de madeira)',
		label: '773315 - Operador de fresadora (usinagem de madeira)',
	},
	{
		value: '773355 - Torneiro na usinagem convencional de madeira',
		label: '773355 - Torneiro na usinagem convencional de madeira',
	},
	{
		value: '773350 - Operador de tupia (usinagem de madeira)',
		label: '773350 - Operador de tupia (usinagem de madeira)',
	},
	{
		value: '773345 - Operador de torno automático (usinagem de madeira)',
		label: '773345 - Operador de torno automático (usinagem de madeira)',
	},
	{
		value: '773340 - Operador de serras (usinagem de madeira)',
		label: '773340 - Operador de serras (usinagem de madeira)',
	},
	{
		value: '773335 - Operador de plaina desengrossadeira',
		label: '773335 - Operador de plaina desengrossadeira',
	},
	{
		value: '773330 - Operador de molduradora (usinagem de madeira)',
		label: '773330 - Operador de molduradora (usinagem de madeira)',
	},
	{
		value: '773325 - Operador de máquina de usinagem madeira, em geral',
		label: '773325 - Operador de máquina de usinagem madeira, em geral',
	},
	{
		value: '773320 - Operador de lixadeira (usinagem de madeira)',
		label: '773320 - Operador de lixadeira (usinagem de madeira)',
	},
	{
		value: '773310 - Operador de entalhadeira (usinagem de madeira)',
		label: '773310 - Operador de entalhadeira (usinagem de madeira)',
	},
	{
		value: '773305 - Operador de desempenadeira na usinagem convencional de madeira',
		label: '773305 - Operador de desempenadeira na usinagem convencional de madeira',
	},
	{
		value: '773410 - Operador de máquina de cortina d´água (produção de móveis)',
		label: '773410 - Operador de máquina de cortina d´água (produção de móveis)',
	},
	{
		value: '773405 - Operador de máquina bordatriz',
		label: '773405 - Operador de máquina bordatriz',
	},
	{
		value: '773415 - Operador de máquina de usinagem de madeira (produção em série)',
		label: '773415 - Operador de máquina de usinagem de madeira (produção em série)',
	},
	{
		value: '773420 - Operador de prensa de alta freqüência na usinagem de madeira',
		label: '773420 - Operador de prensa de alta freqüência na usinagem de madeira',
	},
	{
		value: '773505 - Operador de centro de usinagem de madeira (cnc)',
		label: '773505 - Operador de centro de usinagem de madeira (cnc)',
	},
	{
		value: '773510 - Operador de máquinas de usinar madeira (cnc)',
		label: '773510 - Operador de máquinas de usinar madeira (cnc)',
	},
	{
		value: '774105 - Montador de móveis e artefatos de madeira',
		label: '774105 - Montador de móveis e artefatos de madeira',
	},
	{
		value: '775115 - Lustrador de peças de madeira',
		label: '775115 - Lustrador de peças de madeira',
	},
	{
		value: '775110 - Folheador de móveis de madeira',
		label: '775110 - Folheador de móveis de madeira',
	},
	{
		value: '775105 - Entalhador  de madeira',
		label: '775105 - Entalhador  de madeira',
	},
	{ value: '775120 - Marcheteiro', label: '775120 - Marcheteiro' },
	{ value: '776430 - Vassoureiro', label: '776430 - Vassoureiro' },
	{
		value: '776415 - Confeccionador de escovas, pincéis e produtos similares (a máquina)',
		label: '776415 - Confeccionador de escovas, pincéis e produtos similares (a máquina)',
	},
	{
		value: '776420 - Confeccionador de móveis de vime, junco e bambu',
		label: '776420 - Confeccionador de móveis de vime, junco e bambu',
	},
	{
		value: '776410 - Confeccionador de escovas, pincéis e produtos similares (a mão)',
		label: '776410 - Confeccionador de escovas, pincéis e produtos similares (a mão)',
	},
	{ value: '776425 - Esteireiro', label: '776425 - Esteireiro' },
	{ value: '776405 - Cesteiro', label: '776405 - Cesteiro' },
	{
		value: '777110 - Carpinteiro naval (embarcações)',
		label: '777110 - Carpinteiro naval (embarcações)',
	},
	{
		value: '777115 - Carpinteiro naval (estaleiros)',
		label: '777115 - Carpinteiro naval (estaleiros)',
	},
	{
		value: '777105 - Carpinteiro naval (construção de pequenas embarcações)',
		label: '777105 - Carpinteiro naval (construção de pequenas embarcações)',
	},
	{
		value: '777205 - Carpinteiro de carretas',
		label: '777205 - Carpinteiro de carretas',
	},
	{
		value: '777210 - Carpinteiro de carrocerias',
		label: '777210 - Carpinteiro de carrocerias',
	},
	{
		value: '780105 - Supervisor de embalagem e etiquetagem',
		label: '780105 - Supervisor de embalagem e etiquetagem',
	},
	{
		value: '781110 - Condutor de processos robotizados de soldagem',
		label: '781110 - Condutor de processos robotizados de soldagem',
	},
	{
		value: '781105 - Condutor de processos robotizados de pintura',
		label: '781105 - Condutor de processos robotizados de pintura',
	},
	{
		value: '781305 - Operador de veículos subaquáticos controlados remotamente',
		label: '781305 - Operador de veículos subaquáticos controlados remotamente',
	},
	{
		value: '781705 - Mergulhador profissional (raso e profundo)',
		label: '781705 - Mergulhador profissional (raso e profundo)',
	},
	{
		value: '782115 - Operador de guindaste móvel',
		label: '782115 - Operador de guindaste móvel',
	},
	{
		value: '782110 - Operador de guindaste (fixo)',
		label: '782110 - Operador de guindaste (fixo)',
	},
	{
		value: '782105 - Operador de draga',
		label: '782105 - Operador de draga',
	},
	{
		value: '782120 - Operador de máquina rodoferroviária',
		label: '782120 - Operador de máquina rodoferroviária',
	},
	{
		value: '782140 - Operador de talha elétrica',
		label: '782140 - Operador de talha elétrica',
	},
	{
		value: '782145 - Sinaleiro (ponte-rolante)',
		label: '782145 - Sinaleiro (ponte-rolante)',
	},
	{
		value: '782135 - Operador de pórtico rolante',
		label: '782135 - Operador de pórtico rolante',
	},
	{
		value: '782130 - Operador de ponte rolante',
		label: '782130 - Operador de ponte rolante',
	},
	{
		value: '782125 - Operador de monta-cargas (construção civil)',
		label: '782125 - Operador de monta-cargas (construção civil)',
	},
	{
		value: '782205 - Guincheiro (construção civil)',
		label: '782205 - Guincheiro (construção civil)',
	},
	{
		value: '782210 - Operador de docagem',
		label: '782210 - Operador de docagem',
	},
	{
		value: '782220 - Operador de empilhadeira',
		label: '782220 - Operador de empilhadeira',
	},
	{
		value: '782320 - Condutor de ambulância',
		label: '782320 - Condutor de ambulância',
	},
	{
		value: '782305 - Motorista de carro de passeio',
		label: '782305 - Motorista de carro de passeio',
	},
	{
		value: '782310 - Motorista de furgão ou veículo similar',
		label: '782310 - Motorista de furgão ou veículo similar',
	},
	{
		value: '782315 - Motorista de táxi',
		label: '782315 - Motorista de táxi',
	},
	{
		value: '782410 - Motorista de ônibus urbano',
		label: '782410 - Motorista de ônibus urbano',
	},
	{
		value: '782405 - Motorista de ônibus rodoviário',
		label: '782405 - Motorista de ônibus rodoviário',
	},
	{
		value: '782415 - Motorista de trólebus',
		label: '782415 - Motorista de trólebus',
	},
	{
		value: '782505 - Caminhoneiro autônomo (rotas regionais e internacionais)',
		label: '782505 - Caminhoneiro autônomo (rotas regionais e internacionais)',
	},
	{
		value: '782510 - Motorista de caminhão (rotas regionais e internacionais)',
		label: '782510 - Motorista de caminhão (rotas regionais e internacionais)',
	},
	{
		value: '782515 - Motorista operacional de guincho',
		label: '782515 - Motorista operacional de guincho',
	},
	{
		value: '782615 - Maquinista de trem metropolitano',
		label: '782615 - Maquinista de trem metropolitano',
	},
	{
		value: '782610 - Maquinista de trem',
		label: '782610 - Maquinista de trem',
	},
	{
		value: '782630 - Operador de teleférico (passageiros)',
		label: '782630 - Operador de teleférico (passageiros)',
	},
	{
		value: '782605 - Operador de trem de metrô',
		label: '782605 - Operador de trem de metrô',
	},
	{
		value: '782625 - Auxiliar de maquinista de trem',
		label: '782625 - Auxiliar de maquinista de trem',
	},
	{ value: '782620 - Motorneiro', label: '782620 - Motorneiro' },
	{
		value: '782735 - Marinheiro auxiliar de máquinas (marítimo e aquaviário)',
		label: '782735 - Marinheiro auxiliar de máquinas (marítimo e aquaviário)',
	},
	{
		value: '782730 - Marinheiro auxiliar de convés (marítimo e aquaviario)',
		label: '782730 - Marinheiro auxiliar de convés (marítimo e aquaviario)',
	},
	{
		value: '782725 - Marinheiro de esporte e recreio',
		label: '782725 - Marinheiro de esporte e recreio',
	},
	{
		value: '782720 - Moço de máquinas (marítimo e fluviário)',
		label: '782720 - Moço de máquinas (marítimo e fluviário)',
	},
	{
		value: '782715 - Moço de convés (marítimo e fluviário)',
		label: '782715 - Moço de convés (marítimo e fluviário)',
	},
	{
		value: '782705 - Marinheiro de convés (marítimo e fluviário)',
		label: '782705 - Marinheiro de convés (marítimo e fluviário)',
	},
	{
		value: '782710 - Marinheiro de máquinas',
		label: '782710 - Marinheiro de máquinas',
	},
	{
		value: '782820 - Condutor de veículos a pedais',
		label: '782820 - Condutor de veículos a pedais',
	},
	{ value: '782815 - Boiadeiro', label: '782815 - Boiadeiro' },
	{ value: '782810 - Tropeiro', label: '782810 - Tropeiro' },
	{
		value: '782805 - Condutor de veículos de tração animal (ruas e estradas)',
		label: '782805 - Condutor de veículos de tração animal (ruas e estradas)',
	},
	{ value: '783105 - Agente de pátio', label: '783105 - Agente de pátio' },
	{ value: '783110 - Manobrador', label: '783110 - Manobrador' },
	{
		value: '783205 - Carregador (aeronaves)',
		label: '783205 - Carregador (aeronaves)',
	},
	{
		value: '783210 - Carregador (armazém)',
		label: '783210 - Carregador (armazém)',
	},
	{
		value: '783215 - Carregador (veículos de transportes terrestres)',
		label: '783215 - Carregador (veículos de transportes terrestres)',
	},
	{ value: '783220 - Estivador', label: '783220 - Estivador' },
	{
		value: '783235 - Trabalhador portuário de capatazia',
		label: '783235 - Trabalhador portuário de capatazia',
	},
	{
		value: '783230 - Bloqueiro (trabalhador portuário)',
		label: '783230 - Bloqueiro (trabalhador portuário)',
	},
	{
		value: '783225 - Ajudante de motorista',
		label: '783225 - Ajudante de motorista',
	},
	{ value: '784105 - Embalador, a mão', label: '784105 - Embalador, a mão' },
	{
		value: '784110 - Embalador, a máquina',
		label: '784110 - Embalador, a máquina',
	},
	{
		value: '784115 - Operador de máquina de etiquetar',
		label: '784115 - Operador de máquina de etiquetar',
	},
	{
		value: '784120 - Operador de máquina de envasar líquidos',
		label: '784120 - Operador de máquina de envasar líquidos',
	},
	{
		value: '784125 - Operador de prensa de enfardamento',
		label: '784125 - Operador de prensa de enfardamento',
	},
	{
		value: '784205 - Alimentador de linha de produção',
		label: '784205 - Alimentador de linha de produção',
	},
	{ value: '791105 - Artesão bordador', label: '791105 - Artesão bordador' },
	{
		value: '791110 - Artesão ceramista',
		label: '791110 - Artesão ceramista',
	},
	{
		value: '791115 - Artesão com material reciclável',
		label: '791115 - Artesão com material reciclável',
	},
	{
		value: '791120 - Artesão confeccionador de biojóias e ecojóias',
		label: '791120 - Artesão confeccionador de biojóias e ecojóias',
	},
	{ value: '791125 - Artesão do couro', label: '791125 - Artesão do couro' },
	{ value: '791160 - Artesão rendeiro', label: '791160 - Artesão rendeiro' },
	{
		value: '791135 - Artesão moveleiro (exceto reciclado)',
		label: '791135 - Artesão moveleiro (exceto reciclado)',
	},
	{ value: '791140 - Artesão tecelão', label: '791140 - Artesão tecelão' },
	{
		value: '791145 - Artesão trançador',
		label: '791145 - Artesão trançador',
	},
	{
		value: '791150 - Artesão crocheteiro',
		label: '791150 - Artesão crocheteiro',
	},
	{
		value: '791155 - Artesão tricoteiro',
		label: '791155 - Artesão tricoteiro',
	},
	{ value: '791130 - Artesão escultor', label: '791130 - Artesão escultor' },
	{
		value: '810110 - Mestre de produção química',
		label: '810110 - Mestre de produção química',
	},
	{
		value: '810105 - Mestre (indústria petroquímica e carboquímica)',
		label: '810105 - Mestre (indústria petroquímica e carboquímica)',
	},
	{
		value: '810205 - Mestre (indústria de borracha e plástico)',
		label: '810205 - Mestre (indústria de borracha e plástico)',
	},
	{
		value: '810305 - Mestre de produção farmacêutica',
		label: '810305 - Mestre de produção farmacêutica',
	},
	{
		value: '811005 - Operador de processos químicos e petroquímicos',
		label: '811005 - Operador de processos químicos e petroquímicos',
	},
	{
		value: '811010 - Operador de sala de controle de instalações químicas, petroquímicas e afins',
		label: '811010 - Operador de sala de controle de instalações químicas, petroquímicas e afins',
	},
	{
		value: '811105 - Moleiro (tratamentos químicos e afins)',
		label: '811105 - Moleiro (tratamentos químicos e afins)',
	},
	{
		value: '811115 - Operador de britadeira (tratamentos químicos e afins)',
		label: '811115 - Operador de britadeira (tratamentos químicos e afins)',
	},
	{
		value: '811120 - Operador de concentração',
		label: '811120 - Operador de concentração',
	},
	{
		value: '811125 - Trabalhador da fabricação de resinas e vernizes',
		label: '811125 - Trabalhador da fabricação de resinas e vernizes',
	},
	{
		value: '811130 - Trabalhador de fabricação de tintas',
		label: '811130 - Trabalhador de fabricação de tintas',
	},
	{
		value: '811110 - Operador de máquina misturadeira (tratamentos químicos e afins)',
		label: '811110 - Operador de máquina misturadeira (tratamentos químicos e afins)',
	},
	{
		value: '811215 - Operador de tratamento químico de materiais radioativos',
		label: '811215 - Operador de tratamento químico de materiais radioativos',
	},
	{
		value: '811205 - Operador de calcinação (tratamento químico e afins)',
		label: '811205 - Operador de calcinação (tratamento químico e afins)',
	},
	{
		value: '811330 - Operador de filtro-prensa (tratamentos químicos e afins)',
		label: '811330 - Operador de filtro-prensa (tratamentos químicos e afins)',
	},
	{
		value: '811335 - Operador de filtros de parafina (tratamentos químicos e afins)',
		label: '811335 - Operador de filtros de parafina (tratamentos químicos e afins)',
	},
	{
		value: '811325 - Operador de filtro-esteira (mineração)',
		label: '811325 - Operador de filtro-esteira (mineração)',
	},
	{
		value: '811320 - Operador de filtro de tambor rotativo (tratamentos químicos e afins)',
		label: '811320 - Operador de filtro de tambor rotativo (tratamentos químicos e afins)',
	},
	{
		value: '811315 - Operador de filtro de secagem (mineração)',
		label: '811315 - Operador de filtro de secagem (mineração)',
	},
	{
		value: '811310 - Operador de exploração de petróleo',
		label: '811310 - Operador de exploração de petróleo',
	},
	{
		value: '811305 - Operador de centrifugadora (tratamentos químicos e afins)',
		label: '811305 - Operador de centrifugadora (tratamentos químicos e afins)',
	},
	{
		value: '811410 - Destilador de produtos químicos (exceto petróleo)',
		label: '811410 - Destilador de produtos químicos (exceto petróleo)',
	},
	{
		value: '811405 - Destilador de madeira',
		label: '811405 - Destilador de madeira',
	},
	{
		value: '811415 - Operador de alambique de funcionamento contínuo (produtos químicos, exceto petróleo)',
		label: '811415 - Operador de alambique de funcionamento contínuo (produtos químicos, exceto petróleo)',
	},
	{
		value: '811420 - Operador de aparelho de reação e conversão (produtos químicos, exceto petróleo)',
		label: '811420 - Operador de aparelho de reação e conversão (produtos químicos, exceto petróleo)',
	},
	{
		value: '811425 - Operador de equipamento de destilação de álcool',
		label: '811425 - Operador de equipamento de destilação de álcool',
	},
	{
		value: '811430 - Operador de evaporador na destilação',
		label: '811430 - Operador de evaporador na destilação',
	},
	{
		value: '811505 - Operador de painel de controle (refinação de petróleo)',
		label: '811505 - Operador de painel de controle (refinação de petróleo)',
	},
	{
		value: '811510 - Operador de transferência e estocagem - na refinação do petróleo',
		label: '811510 - Operador de transferência e estocagem - na refinação do petróleo',
	},
	{
		value: '811610 - Operador de carro de apagamento e coque',
		label: '811610 - Operador de carro de apagamento e coque',
	},
	{
		value: '811605 - Operador de britador de coque',
		label: '811605 - Operador de britador de coque',
	},
	{
		value: '811615 - Operador de destilação e subprodutos de coque',
		label: '811615 - Operador de destilação e subprodutos de coque',
	},
	{
		value: '811650 - Operador de sistema de reversão (coqueria)',
		label: '811650 - Operador de sistema de reversão (coqueria)',
	},
	{
		value: '811645 - Operador de refrigeração (coqueria)',
		label: '811645 - Operador de refrigeração (coqueria)',
	},
	{
		value: '811640 - Operador de reator de coque de petróleo',
		label: '811640 - Operador de reator de coque de petróleo',
	},
	{
		value: '811635 - Operador de preservação e controle térmico',
		label: '811635 - Operador de preservação e controle térmico',
	},
	{
		value: '811630 - Operador de painel de controle',
		label: '811630 - Operador de painel de controle',
	},
	{
		value: '811625 - Operador de exaustor (coqueria)',
		label: '811625 - Operador de exaustor (coqueria)',
	},
	{
		value: '811620 - Operador de enfornamento e desenfornamento de coque',
		label: '811620 - Operador de enfornamento e desenfornamento de coque',
	},
	{ value: '811705 - Bamburista', label: '811705 - Bamburista' },
	{
		value: '811710 - Calandrista de borracha',
		label: '811710 - Calandrista de borracha',
	},
	{
		value: '811715 - Confeccionador de pneumáticos',
		label: '811715 - Confeccionador de pneumáticos',
	},
	{
		value: '811725 - Confeccionador de velas por imersão',
		label: '811725 - Confeccionador de velas por imersão',
	},
	{
		value: '811775 - Trefilador de borracha',
		label: '811775 - Trefilador de borracha',
	},
	{
		value: '811745 - Laminador de plástico',
		label: '811745 - Laminador de plástico',
	},
	{
		value: '811750 - Moldador de borracha por compressão',
		label: '811750 - Moldador de borracha por compressão',
	},
	{
		value: '811760 - Moldador de plástico por compressão',
		label: '811760 - Moldador de plástico por compressão',
	},
	{
		value: '811770 - Moldador de plástico por injeção',
		label: '811770 - Moldador de plástico por injeção',
	},
	{
		value: '811735 - Confeccionador de velas por moldagem',
		label: '811735 - Confeccionador de velas por moldagem',
	},
	{
		value: '811805 - Operador de máquina de produtos farmacêuticos',
		label: '811805 - Operador de máquina de produtos farmacêuticos',
	},
	{
		value: '811810 - Drageador (medicamentos)',
		label: '811810 - Drageador (medicamentos)',
	},
	{
		value: '811820 - Operador de máquina de fabricação de produtos de higiene e limpeza (sabão, sabonete, detergente, absorvente, fraldas cotonetes e outros)',
		label: '811820 - Operador de máquina de fabricação de produtos de higiene e limpeza (sabão, sabonete, detergente, absorvente, fraldas cotonetes e outros)',
	},
	{
		value: '811815 - Operador de máquina de fabricação de cosméticos',
		label: '811815 - Operador de máquina de fabricação de cosméticos',
	},
	{ value: '812105 - Pirotécnico', label: '812105 - Pirotécnico' },
	{
		value: '812110 - Trabalhador da fabricação de munição e explosivos',
		label: '812110 - Trabalhador da fabricação de munição e explosivos',
	},
	{
		value: '813125 - Operador de produção (química, petroquímica e afins)',
		label: '813125 - Operador de produção (química, petroquímica e afins)',
	},
	{
		value: '813110 - Operador de calandra (química, petroquímica e afins)',
		label: '813110 - Operador de calandra (química, petroquímica e afins)',
	},
	{
		value: '813130 - Técnico de operação (química, petroquímica e afins)',
		label: '813130 - Técnico de operação (química, petroquímica e afins)',
	},
	{
		value: '813120 - Operador de processo (química, petroquímica e afins)',
		label: '813120 - Operador de processo (química, petroquímica e afins)',
	},
	{
		value: '813115 - Operador de extrusora (química, petroquímica e afins)',
		label: '813115 - Operador de extrusora (química, petroquímica e afins)',
	},
	{
		value: '813105 - Cilindrista (petroquímica e afins)',
		label: '813105 - Cilindrista (petroquímica e afins)',
	},
	{
		value: '818110 - Auxiliar de laboratório de análises físico-químicas',
		label: '818110 - Auxiliar de laboratório de análises físico-químicas',
	},
	{
		value: '818105 - Assistente de laboratório industrial',
		label: '818105 - Assistente de laboratório industrial',
	},
	{
		value: '820105 - Mestre de siderurgia',
		label: '820105 - Mestre de siderurgia',
	},
	{
		value: '820110 - Mestre de aciaria',
		label: '820110 - Mestre de aciaria',
	},
	{
		value: '820115 - Mestre de alto-forno',
		label: '820115 - Mestre de alto-forno',
	},
	{
		value: '820120 - Mestre de forno elétrico',
		label: '820120 - Mestre de forno elétrico',
	},
	{
		value: '820125 - Mestre de laminação',
		label: '820125 - Mestre de laminação',
	},
	{
		value: '820205 - Supervisor de fabricação de produtos cerâmicos, porcelanatos e afins',
		label: '820205 - Supervisor de fabricação de produtos cerâmicos, porcelanatos e afins',
	},
	{
		value: '820210 - Supervisor de fabricação de produtos de vidro',
		label: '820210 - Supervisor de fabricação de produtos de vidro',
	},
	{
		value: '821105 - Operador de centro de controle',
		label: '821105 - Operador de centro de controle',
	},
	{
		value: '821110 - Operador de máquina de sinterizar',
		label: '821110 - Operador de máquina de sinterizar',
	},
	{
		value: '821210 - Forneiro e operador (conversor a oxigênio)',
		label: '821210 - Forneiro e operador (conversor a oxigênio)',
	},
	{
		value: '821215 - Forneiro e operador (forno elétrico)',
		label: '821215 - Forneiro e operador (forno elétrico)',
	},
	{
		value: '821220 - Forneiro e operador (refino de metais não-ferrosos)',
		label: '821220 - Forneiro e operador (refino de metais não-ferrosos)',
	},
	{
		value: '821225 - Forneiro e operador de forno de redução direta',
		label: '821225 - Forneiro e operador de forno de redução direta',
	},
	{
		value: '821230 - Operador de aciaria (basculamento de convertedor)',
		label: '821230 - Operador de aciaria (basculamento de convertedor)',
	},
	{
		value: '821235 - Operador de aciaria (dessulfuração de gusa)',
		label: '821235 - Operador de aciaria (dessulfuração de gusa)',
	},
	{
		value: '821240 - Operador de aciaria (recebimento de gusa)',
		label: '821240 - Operador de aciaria (recebimento de gusa)',
	},
	{
		value: '821245 - Operador de área de corrida',
		label: '821245 - Operador de área de corrida',
	},
	{
		value: '821250 - Operador de desgaseificação',
		label: '821250 - Operador de desgaseificação',
	},
	{
		value: '821255 - Soprador de convertedor',
		label: '821255 - Soprador de convertedor',
	},
	{
		value: '821205 - Forneiro e operador (alto-forno)',
		label: '821205 - Forneiro e operador (alto-forno)',
	},
	{
		value: '821315 - Operador de laminador de barras a quente',
		label: '821315 - Operador de laminador de barras a quente',
	},
	{
		value: '821310 - Operador de laminador de barras a frio',
		label: '821310 - Operador de laminador de barras a frio',
	},
	{
		value: '821305 - Operador de laminador',
		label: '821305 - Operador de laminador',
	},
	{
		value: '821320 - Operador de laminador de metais não-ferrosos',
		label: '821320 - Operador de laminador de metais não-ferrosos',
	},
	{
		value: '821325 - Operador de laminador de tubos',
		label: '821325 - Operador de laminador de tubos',
	},
	{
		value: '821330 - Operador de montagem de cilindros e mancais',
		label: '821330 - Operador de montagem de cilindros e mancais',
	},
	{
		value: '821335 - Recuperador de guias e cilindros',
		label: '821335 - Recuperador de guias e cilindros',
	},
	{
		value: '821415 - Marcador de produtos (siderúrgico e metalúrgico)',
		label: '821415 - Marcador de produtos (siderúrgico e metalúrgico)',
	},
	{ value: '821410 - Escarfador', label: '821410 - Escarfador' },
	{
		value: '821405 - Encarregado de acabamento de chapas e metais  (têmpera)',
		label: '821405 - Encarregado de acabamento de chapas e metais  (têmpera)',
	},
	{
		value: '821420 - Operador de bobinadeira de tiras a quente, no acabamento de chapas e metais',
		label: '821420 - Operador de bobinadeira de tiras a quente, no acabamento de chapas e metais',
	},
	{
		value: '821450 - Rebarbador de metal',
		label: '821450 - Rebarbador de metal',
	},
	{
		value: '821445 - Preparador de sucata e aparas',
		label: '821445 - Preparador de sucata e aparas',
	},
	{
		value: '821440 - Operador de tesoura mecânica e máquina de corte, no acabamento de chapas e metais',
		label: '821440 - Operador de tesoura mecânica e máquina de corte, no acabamento de chapas e metais',
	},
	{
		value: '821435 - Operador de jato abrasivo',
		label: '821435 - Operador de jato abrasivo',
	},
	{
		value: '821425 - Operador de cabine de laminação (fio-máquina)',
		label: '821425 - Operador de cabine de laminação (fio-máquina)',
	},
	{
		value: '821430 - Operador de escória e sucata',
		label: '821430 - Operador de escória e sucata',
	},
	{
		value: '822110 - Forneiro de forno-poço',
		label: '822110 - Forneiro de forno-poço',
	},
	{
		value: '822105 - Forneiro de cubilô',
		label: '822105 - Forneiro de cubilô',
	},
	{
		value: '822120 - Forneiro de reaquecimento e tratamento térmico na metalurgia',
		label: '822120 - Forneiro de reaquecimento e tratamento térmico na metalurgia',
	},
	{
		value: '822115 - Forneiro de fundição (forno de redução)',
		label: '822115 - Forneiro de fundição (forno de redução)',
	},
	{
		value: '822125 - Forneiro de revérbero',
		label: '822125 - Forneiro de revérbero',
	},
	{
		value: '823105 - Preparador de massa (fabricação de abrasivos)',
		label: '823105 - Preparador de massa (fabricação de abrasivos)',
	},
	{
		value: '823135 - Operador de atomizador',
		label: '823135 - Operador de atomizador',
	},
	{
		value: '823130 - Preparador de aditivos',
		label: '823130 - Preparador de aditivos',
	},
	{
		value: '823125 - Preparador de esmaltes (cerâmica)',
		label: '823125 - Preparador de esmaltes (cerâmica)',
	},
	{
		value: '823120 - Preparador de barbotina',
		label: '823120 - Preparador de barbotina',
	},
	{
		value: '823115 - Preparador de massa de argila',
		label: '823115 - Preparador de massa de argila',
	},
	{
		value: '823110 - Preparador de massa (fabricação de vidro)',
		label: '823110 - Preparador de massa (fabricação de vidro)',
	},
	{
		value: '823210 - Extrusor de fios ou fibras de vidro',
		label: '823210 - Extrusor de fios ou fibras de vidro',
	},
	{
		value: '823215 - Forneiro na fundição de vidro',
		label: '823215 - Forneiro na fundição de vidro',
	},
	{
		value: '823265 - Trabalhador na fabricação de produtos abrasivos',
		label: '823265 - Trabalhador na fabricação de produtos abrasivos',
	},
	{
		value: '823255 - Temperador de vidro',
		label: '823255 - Temperador de vidro',
	},
	{
		value: '823250 - Operador de prensa de moldar vidro',
		label: '823250 - Operador de prensa de moldar vidro',
	},
	{
		value: '823245 - Operador de máquina extrusora de varetas e tubos de vidro',
		label: '823245 - Operador de máquina extrusora de varetas e tubos de vidro',
	},
	{
		value: '823240 - Operador de máquina de soprar vidro',
		label: '823240 - Operador de máquina de soprar vidro',
	},
	{
		value: '823235 - Operador de banho metálico de vidro por flutuação',
		label: '823235 - Operador de banho metálico de vidro por flutuação',
	},
	{
		value: '823220 - Forneiro no recozimento de vidro',
		label: '823220 - Forneiro no recozimento de vidro',
	},
	{
		value: '823230 - Moldador de abrasivos na fabricação de cerâmica, vidro e porcelana',
		label: '823230 - Moldador de abrasivos na fabricação de cerâmica, vidro e porcelana',
	},
	{
		value: '823320 - Trabalhador da elaboração de pré-fabricados (cimento amianto)',
		label: '823320 - Trabalhador da elaboração de pré-fabricados (cimento amianto)',
	},
	{
		value: '823325 - Trabalhador da elaboração de pré-fabricados (concreto armado)',
		label: '823325 - Trabalhador da elaboração de pré-fabricados (concreto armado)',
	},
	{
		value: '823330 - Trabalhador da fabricação de pedras artificiais',
		label: '823330 - Trabalhador da fabricação de pedras artificiais',
	},
	{
		value: '823305 - Classificador e empilhador de tijolos refratários',
		label: '823305 - Classificador e empilhador de tijolos refratários',
	},
	{
		value: '823315 - Forneiro (materiais de construção)',
		label: '823315 - Forneiro (materiais de construção)',
	},
	{
		value: '828105 - Oleiro (fabricação de telhas)',
		label: '828105 - Oleiro (fabricação de telhas)',
	},
	{
		value: '828110 - Oleiro (fabricação de tijolos)',
		label: '828110 - Oleiro (fabricação de tijolos)',
	},
	{
		value: '830105 - Mestre (indústria de celulose, papel e papelão)',
		label: '830105 - Mestre (indústria de celulose, papel e papelão)',
	},
	{
		value: '831105 - Cilindreiro na preparação de pasta para fabricação de papel',
		label: '831105 - Cilindreiro na preparação de pasta para fabricação de papel',
	},
	{
		value: '831110 - Operador de branqueador de pasta para fabricação de papel',
		label: '831110 - Operador de branqueador de pasta para fabricação de papel',
	},
	{
		value: '831115 - Operador de digestor de pasta para fabricação de papel',
		label: '831115 - Operador de digestor de pasta para fabricação de papel',
	},
	{
		value: '831120 - Operador de lavagem e depuração de pasta para fabricação de papel',
		label: '831120 - Operador de lavagem e depuração de pasta para fabricação de papel',
	},
	{
		value: '831125 - Operador de máquina de secar celulose',
		label: '831125 - Operador de máquina de secar celulose',
	},
	{
		value: '832110 - Operador de cortadeira de papel',
		label: '832110 - Operador de cortadeira de papel',
	},
	{
		value: '832105 - Calandrista de papel',
		label: '832105 - Calandrista de papel',
	},
	{
		value: '832115 - Operador de máquina de fabricar papel  (fase úmida)',
		label: '832115 - Operador de máquina de fabricar papel  (fase úmida)',
	},
	{
		value: '832135 - Operador de rebobinadeira na fabricação de papel e papelão',
		label: '832135 - Operador de rebobinadeira na fabricação de papel e papelão',
	},
	{
		value: '832125 - Operador de máquina de fabricar papel e papelão',
		label: '832125 - Operador de máquina de fabricar papel e papelão',
	},
	{
		value: '832120 - Operador de máquina de fabricar papel (fase seca)',
		label: '832120 - Operador de máquina de fabricar papel (fase seca)',
	},
	{
		value: '833105 - Cartonageiro, a máquina',
		label: '833105 - Cartonageiro, a máquina',
	},
	{
		value: '833110 - Confeccionador de bolsas, sacos e sacolas e papel, a máquina',
		label: '833110 - Confeccionador de bolsas, sacos e sacolas e papel, a máquina',
	},
	{
		value: '833125 - Operador de prensa de embutir papelão',
		label: '833125 - Operador de prensa de embutir papelão',
	},
	{
		value: '833120 - Operador de máquina de cortar e dobrar papelão',
		label: '833120 - Operador de máquina de cortar e dobrar papelão',
	},
	{
		value: '833115 - Confeccionador de sacos de celofane, a máquina',
		label: '833115 - Confeccionador de sacos de celofane, a máquina',
	},
	{
		value: '833205 - Cartonageiro, a mão (caixas de papelão)',
		label: '833205 - Cartonageiro, a mão (caixas de papelão)',
	},
	{
		value: '840110 - Supervisor da indústria de bebidas',
		label: '840110 - Supervisor da indústria de bebidas',
	},
	{
		value: '840120 - Chefe de confeitaria',
		label: '840120 - Chefe de confeitaria',
	},
	{
		value: '840115 - Supervisor da indústria de fumo',
		label: '840115 - Supervisor da indústria de fumo',
	},
	{
		value: '840105 - Supervisor de produção da indústria alimentícia',
		label: '840105 - Supervisor de produção da indústria alimentícia',
	},
	{
		value: '841105 - Moleiro de cereais (exceto arroz)',
		label: '841105 - Moleiro de cereais (exceto arroz)',
	},
	{
		value: '841110 - Moleiro de especiarias',
		label: '841110 - Moleiro de especiarias',
	},
	{
		value: '841115 - Operador de processo de moagem',
		label: '841115 - Operador de processo de moagem',
	},
	{ value: '841210 - Refinador de sal', label: '841210 - Refinador de sal' },
	{ value: '841205 - Moedor de sal', label: '841205 - Moedor de sal' },
	{
		value: '841310 - Operador de equipamentos de refinação de açúcar (processo contínuo)',
		label: '841310 - Operador de equipamentos de refinação de açúcar (processo contínuo)',
	},
	{
		value: '841305 - Operador de cristalização na refinação de açucar',
		label: '841305 - Operador de cristalização na refinação de açucar',
	},
	{
		value: '841320 - Operador de tratamento de calda na refinação de açúcar',
		label: '841320 - Operador de tratamento de calda na refinação de açúcar',
	},
	{
		value: '841315 - Operador de moenda na fabricação de açúcar',
		label: '841315 - Operador de moenda na fabricação de açúcar',
	},
	{
		value: '841484 - Trabalhador de preparação de pescados (limpeza)',
		label: '841484 - Trabalhador de preparação de pescados (limpeza)',
	},
	{
		value: '841476 - Trabalhador de fabricação de margarina',
		label: '841476 - Trabalhador de fabricação de margarina',
	},
	{
		value: '841472 - Refinador de óleo e gordura',
		label: '841472 - Refinador de óleo e gordura',
	},
	{
		value: '841468 - Preparador de rações',
		label: '841468 - Preparador de rações',
	},
	{
		value: '841464 - Prensador de frutas (exceto oleaginosas)',
		label: '841464 - Prensador de frutas (exceto oleaginosas)',
	},
	{
		value: '841460 - Operador de preparação de grãos vegetais (óleos e gorduras)',
		label: '841460 - Operador de preparação de grãos vegetais (óleos e gorduras)',
	},
	{
		value: '841456 - Operador de câmaras frias',
		label: '841456 - Operador de câmaras frias',
	},
	{
		value: '841444 - Hidrogenador de óleos e gorduras',
		label: '841444 - Hidrogenador de óleos e gorduras',
	},
	{
		value: '841440 - Esterilizador de alimentos',
		label: '841440 - Esterilizador de alimentos',
	},
	{
		value: '841432 - Desidratador de alimentos',
		label: '841432 - Desidratador de alimentos',
	},
	{
		value: '841428 - Cozinhador de pescado',
		label: '841428 - Cozinhador de pescado',
	},
	{
		value: '841420 - Cozinhador de frutas e legumes',
		label: '841420 - Cozinhador de frutas e legumes',
	},
	{
		value: '841416 - Cozinhador de carnes',
		label: '841416 - Cozinhador de carnes',
	},
	{
		value: '841408 - Cozinhador (conservação de alimentos)',
		label: '841408 - Cozinhador (conservação de alimentos)',
	},
	{ value: '841448 - Lagareiro', label: '841448 - Lagareiro' },
	{
		value: '841505 - Trabalhador de tratamento do leite e fabricação de laticínios e afins',
		label: '841505 - Trabalhador de tratamento do leite e fabricação de laticínios e afins',
	},
	{
		value: '841620 - Operador de extração de café solúvel',
		label: '841620 - Operador de extração de café solúvel',
	},
	{
		value: '841630 - Misturador de chá ou mate',
		label: '841630 - Misturador de chá ou mate',
	},
	{
		value: '841625 - Torrador de cacau',
		label: '841625 - Torrador de cacau',
	},
	{
		value: '841605 - Misturador de café',
		label: '841605 - Misturador de café',
	},
	{ value: '841610 - Torrador de café', label: '841610 - Torrador de café' },
	{ value: '841615 - Moedor de café', label: '841615 - Moedor de café' },
	{
		value: '841735 - Dessecador de malte',
		label: '841735 - Dessecador de malte',
	},
	{ value: '841740 - Vinagreiro', label: '841740 - Vinagreiro' },
	{ value: '841745 - Xaropeiro', label: '841745 - Xaropeiro' },
	{
		value: '841725 - Malteiro (germinação)',
		label: '841725 - Malteiro (germinação)',
	},
	{
		value: '841730 - Cozinhador de malte',
		label: '841730 - Cozinhador de malte',
	},
	{
		value: '841720 - Trabalhador de fabricação de vinhos',
		label: '841720 - Trabalhador de fabricação de vinhos',
	},
	{ value: '841705 - Alambiqueiro', label: '841705 - Alambiqueiro' },
	{
		value: '841710 - Filtrador de cerveja',
		label: '841710 - Filtrador de cerveja',
	},
	{ value: '841715 - Fermentador', label: '841715 - Fermentador' },
	{
		value: '841810 - Operador de máquinas de fabricação de doces, salgados e massas alimentícias',
		label: '841810 - Operador de máquinas de fabricação de doces, salgados e massas alimentícias',
	},
	{
		value: '841805 - Operador de forno (fabricação de pães, biscoitos e similares)',
		label: '841805 - Operador de forno (fabricação de pães, biscoitos e similares)',
	},
	{
		value: '841815 - Operador de máquinas de fabricação de chocolates e achocolatados',
		label: '841815 - Operador de máquinas de fabricação de chocolates e achocolatados',
	},
	{
		value: '842135 - Operador de máquina de preparação de matéria prima para produção de cigarros',
		label: '842135 - Operador de máquina de preparação de matéria prima para produção de cigarros',
	},
	{
		value: '842125 - Operador de máquina (fabricação de cigarros)',
		label: '842125 - Operador de máquina (fabricação de cigarros)',
	},
	{
		value: '842120 - Auxiliar de processamento de fumo',
		label: '842120 - Auxiliar de processamento de fumo',
	},
	{
		value: '842115 - Classificador de fumo',
		label: '842115 - Classificador de fumo',
	},
	{
		value: '842105 - Preparador de melado e essência de fumo',
		label: '842105 - Preparador de melado e essência de fumo',
	},
	{
		value: '842110 - Processador de fumo',
		label: '842110 - Processador de fumo',
	},
	{
		value: '842205 - Preparador de fumo na fabricação de charutos',
		label: '842205 - Preparador de fumo na fabricação de charutos',
	},
	{
		value: '842210 - Operador de máquina de fabricar charutos e cigarrilhas',
		label: '842210 - Operador de máquina de fabricar charutos e cigarrilhas',
	},
	{
		value: '842215 - Classificador de charutos',
		label: '842215 - Classificador de charutos',
	},
	{
		value: '842220 - Cortador de charutos',
		label: '842220 - Cortador de charutos',
	},
	{
		value: '842225 - Celofanista na fabricação de charutos',
		label: '842225 - Celofanista na fabricação de charutos',
	},
	{
		value: '842235 - Degustador de charutos',
		label: '842235 - Degustador de charutos',
	},
	{ value: '842230 - Charuteiro a mão', label: '842230 - Charuteiro a mão' },
	{
		value: '848110 - Salgador de alimentos',
		label: '848110 - Salgador de alimentos',
	},
	{
		value: '848105 - Defumador de carnes e pescados',
		label: '848105 - Defumador de carnes e pescados',
	},
	{
		value: '848115 - Salsicheiro (fabricação de lingüiça, salsicha e produtos similares)',
		label: '848115 - Salsicheiro (fabricação de lingüiça, salsicha e produtos similares)',
	},
	{ value: '848205 - Pasteurizador', label: '848205 - Pasteurizador' },
	{
		value: '848210 - Queijeiro na fabricação de laticínio',
		label: '848210 - Queijeiro na fabricação de laticínio',
	},
	{
		value: '848215 - Manteigueiro na fabricação de laticínio',
		label: '848215 - Manteigueiro na fabricação de laticínio',
	},
	{ value: '848305 - Padeiro', label: '848305 - Padeiro' },
	{ value: '848310 - Confeiteiro', label: '848310 - Confeiteiro' },
	{
		value: '848315 - Masseiro (massas alimentícias)',
		label: '848315 - Masseiro (massas alimentícias)',
	},
	{
		value: '848325 - Trabalhador de fabricação de sorvete',
		label: '848325 - Trabalhador de fabricação de sorvete',
	},
	{
		value: '848425 - Classificador de grãos',
		label: '848425 - Classificador de grãos',
	},
	{
		value: '848420 - Degustador de vinhos ou licores',
		label: '848420 - Degustador de vinhos ou licores',
	},
	{
		value: '848415 - Degustador de derivados de cacau',
		label: '848415 - Degustador de derivados de cacau',
	},
	{
		value: '848405 - Degustador de café',
		label: '848405 - Degustador de café',
	},
	{
		value: '848410 - Degustador de chá',
		label: '848410 - Degustador de chá',
	},
	{
		value: '848525 - Retalhador de carne',
		label: '848525 - Retalhador de carne',
	},
	{ value: '848515 - Desossador', label: '848515 - Desossador' },
	{ value: '848510 - Açougueiro', label: '848510 - Açougueiro' },
	{ value: '848505 - Abatedor', label: '848505 - Abatedor' },
	{ value: '848520 - Magarefe', label: '848520 - Magarefe' },
	{
		value: '848605 - Trabalhador do beneficiamento de fumo',
		label: '848605 - Trabalhador do beneficiamento de fumo',
	},
	{
		value: '860105 - Supervisor de manutenção eletromecânica (utilidades)',
		label: '860105 - Supervisor de manutenção eletromecânica (utilidades)',
	},
	{
		value: '860110 - Supervisor de operação de fluidos (distribuição, captação, tratamento de água, gases, vapor)',
		label: '860110 - Supervisor de operação de fluidos (distribuição, captação, tratamento de água, gases, vapor)',
	},
	{
		value: '860115 - Supervisor de operação elétrica (geração, transmissão e distribuição de energia elétrica)',
		label: '860115 - Supervisor de operação elétrica (geração, transmissão e distribuição de energia elétrica)',
	},
	{
		value: '861120 - Operador de reator nuclear',
		label: '861120 - Operador de reator nuclear',
	},
	{
		value: '861115 - Operador de central termoelétrica',
		label: '861115 - Operador de central termoelétrica',
	},
	{
		value: '861110 - Operador de quadro de distribuição de energia elétrica',
		label: '861110 - Operador de quadro de distribuição de energia elétrica',
	},
	{
		value: '861105 - Operador de central hidrelétrica',
		label: '861105 - Operador de central hidrelétrica',
	},
	{
		value: '861205 - Operador de subestação',
		label: '861205 - Operador de subestação',
	},
	{
		value: '862155 - Operador de utilidade (produção e distribuição de vapor, gás, óleo, combustível, energia, oxigênio)',
		label: '862155 - Operador de utilidade (produção e distribuição de vapor, gás, óleo, combustível, energia, oxigênio)',
	},
	{
		value: '862150 - Operador de máquinas fixas, em geral',
		label: '862150 - Operador de máquinas fixas, em geral',
	},
	{
		value: '862140 - Operador de estação de bombeamento',
		label: '862140 - Operador de estação de bombeamento',
	},
	{
		value: '862130 - Operador de compressor de ar',
		label: '862130 - Operador de compressor de ar',
	},
	{
		value: '862120 - Operador de caldeira',
		label: '862120 - Operador de caldeira',
	},
	{
		value: '862115 - Operador de bateria de gás de hulha',
		label: '862115 - Operador de bateria de gás de hulha',
	},
	{
		value: '862105 - Foguista (locomotivas a vapor)',
		label: '862105 - Foguista (locomotivas a vapor)',
	},
	{
		value: '862160 - Operador de abastecimento de combustível de aeronave',
		label: '862160 - Operador de abastecimento de combustível de aeronave',
	},
	{
		value: '862110 - Maquinista de embarcações',
		label: '862110 - Maquinista de embarcações',
	},
	{
		value: '862205 - Operador de estação de captação, tratamento e distribuição de água',
		label: '862205 - Operador de estação de captação, tratamento e distribuição de água',
	},
	{
		value: '862305 - Operador de estação de tratamento de água e efluentes',
		label: '862305 - Operador de estação de tratamento de água e efluentes',
	},
	{
		value: '862310 - Operador de forno de incineração no tratamento de água, efluentes e resíduos industriais',
		label: '862310 - Operador de forno de incineração no tratamento de água, efluentes e resíduos industriais',
	},
	{
		value: '862405 - Operador de instalação de extração, processamento, envasamento e distribuição de gases',
		label: '862405 - Operador de instalação de extração, processamento, envasamento e distribuição de gases',
	},
	{
		value: '862505 - Operador de instalação de refrigeração',
		label: '862505 - Operador de instalação de refrigeração',
	},
	{
		value: '862510 - Operador de refrigeração com amônia',
		label: '862510 - Operador de refrigeração com amônia',
	},
	{
		value: '862515 - Operador de instalação de ar-condicionado',
		label: '862515 - Operador de instalação de ar-condicionado',
	},
	{
		value: '910130 - Supervisor de manutenção de máquinas operatrizes e de usinagem',
		label: '910130 - Supervisor de manutenção de máquinas operatrizes e de usinagem',
	},
	{
		value: '910110 - Supervisor de manutenção de aparelhos térmicos, de climatização e de refrigeração',
		label: '910110 - Supervisor de manutenção de aparelhos térmicos, de climatização e de refrigeração',
	},
	{
		value: '910105 - Encarregado de manutenção mecânica de sistemas operacionais',
		label: '910105 - Encarregado de manutenção mecânica de sistemas operacionais',
	},
	{
		value: '910115 - Supervisor de manutenção de bombas, motores, compressores e equipamentos de transmissão',
		label: '910115 - Supervisor de manutenção de bombas, motores, compressores e equipamentos de transmissão',
	},
	{
		value: '910120 - Supervisor de manutenção de máquinas gráficas',
		label: '910120 - Supervisor de manutenção de máquinas gráficas',
	},
	{
		value: '910125 - Supervisor de manutenção de máquinas industriais têxteis',
		label: '910125 - Supervisor de manutenção de máquinas industriais têxteis',
	},
	{
		value: '910205 - Supervisor da manutenção e reparação de veículos leves',
		label: '910205 - Supervisor da manutenção e reparação de veículos leves',
	},
	{
		value: '910210 - Supervisor da manutenção e reparação de veículos pesados',
		label: '910210 - Supervisor da manutenção e reparação de veículos pesados',
	},
	{
		value: '910910 - Supervisor de manutenção de vias férreas',
		label: '910910 - Supervisor de manutenção de vias férreas',
	},
	{
		value: '910905 - Supervisor de reparos linhas férreas',
		label: '910905 - Supervisor de reparos linhas férreas',
	},
	{
		value: '911125 - Mecânico de manutenção de redutores',
		label: '911125 - Mecânico de manutenção de redutores',
	},
	{
		value: '911120 - Mecânico de manutenção de motores diesel (exceto de veículos automotores)',
		label: '911120 - Mecânico de manutenção de motores diesel (exceto de veículos automotores)',
	},
	{
		value: '911115 - Mecânico de manutenção de compressores de ar',
		label: '911115 - Mecânico de manutenção de compressores de ar',
	},
	{
		value: '911110 - Mecânico de manutenção de bombas',
		label: '911110 - Mecânico de manutenção de bombas',
	},
	{
		value: '911105 - Mecânico de manutenção de bomba injetora (exceto de veículos automotores)',
		label: '911105 - Mecânico de manutenção de bomba injetora (exceto de veículos automotores)',
	},
	{
		value: '911130 - Mecânico de manutenção de turbinas (exceto de aeronaves)',
		label: '911130 - Mecânico de manutenção de turbinas (exceto de aeronaves)',
	},
	{
		value: '911135 - Mecânico de manutenção de turbocompressores',
		label: '911135 - Mecânico de manutenção de turbocompressores',
	},
	{
		value: '911205 - Mecânico de manutenção e instalação de aparelhos de climatização e  refrigeração',
		label: '911205 - Mecânico de manutenção e instalação de aparelhos de climatização e  refrigeração',
	},
	{
		value: '911305 - Mecânico de manutenção de máquinas, em geral',
		label: '911305 - Mecânico de manutenção de máquinas, em geral',
	},
	{
		value: '911310 - Mecânico de manutenção de máquinas gráficas',
		label: '911310 - Mecânico de manutenção de máquinas gráficas',
	},
	{
		value: '911315 - Mecânico de manutenção de máquinas operatrizes (lavra de madeira)',
		label: '911315 - Mecânico de manutenção de máquinas operatrizes (lavra de madeira)',
	},
	{
		value: '911320 - Mecânico de manutenção de máquinas têxteis',
		label: '911320 - Mecânico de manutenção de máquinas têxteis',
	},
	{
		value: '911325 - Mecânico de manutenção de máquinas-ferramentas (usinagem de metais)',
		label: '911325 - Mecânico de manutenção de máquinas-ferramentas (usinagem de metais)',
	},
	{
		value: '913110 - Mecânico de manutenção de equipamento de mineração',
		label: '913110 - Mecânico de manutenção de equipamento de mineração',
	},
	{
		value: '913105 - Mecânico de manutenção de aparelhos de levantamento',
		label: '913105 - Mecânico de manutenção de aparelhos de levantamento',
	},
	{
		value: '913115 - Mecânico de manutenção de máquinas agrícolas',
		label: '913115 - Mecânico de manutenção de máquinas agrícolas',
	},
	{
		value: '913120 - Mecânico de manutenção de máquinas de construção e terraplenagem',
		label: '913120 - Mecânico de manutenção de máquinas de construção e terraplenagem',
	},
	{
		value: '914105 - Mecânico de manutenção de aeronaves, em geral',
		label: '914105 - Mecânico de manutenção de aeronaves, em geral',
	},
	{
		value: '914110 - Mecânico de manutenção de sistema hidráulico de aeronaves (serviços de pista e hangar)',
		label: '914110 - Mecânico de manutenção de sistema hidráulico de aeronaves (serviços de pista e hangar)',
	},
	{
		value: '914205 - Mecânico de manutenção de motores e equipamentos navais',
		label: '914205 - Mecânico de manutenção de motores e equipamentos navais',
	},
	{
		value: '914305 - Mecânico de manutenção de veículos ferroviários',
		label: '914305 - Mecânico de manutenção de veículos ferroviários',
	},
	{
		value: '914420 - Mecânico de manutenção de tratores',
		label: '914420 - Mecânico de manutenção de tratores',
	},
	{
		value: '914415 - Mecânico de manutenção de motocicletas',
		label: '914415 - Mecânico de manutenção de motocicletas',
	},
	{
		value: '914410 - Mecânico de manutenção de empilhadeiras e outros veículos de cargas leves',
		label: '914410 - Mecânico de manutenção de empilhadeiras e outros veículos de cargas leves',
	},
	{
		value: '914425 - Mecânico de veículos automotores a diesel (exceto tratores)',
		label: '914425 - Mecânico de veículos automotores a diesel (exceto tratores)',
	},
	{
		value: '914405 - Mecânico de manutenção de automóveis, motocicletas e veículos similares',
		label: '914405 - Mecânico de manutenção de automóveis, motocicletas e veículos similares',
	},
	{
		value: '915110 - Técnico em manutenção de hidrômetros',
		label: '915110 - Técnico em manutenção de hidrômetros',
	},
	{
		value: '915105 - Técnico em manutenção de instrumentos de medição e precisão',
		label: '915105 - Técnico em manutenção de instrumentos de medição e precisão',
	},
	{
		value: '915115 - Técnico em manutenção de balanças',
		label: '915115 - Técnico em manutenção de balanças',
	},
	{
		value: '915205 - Restaurador de instrumentos musicais (exceto cordas arcadas)',
		label: '915205 - Restaurador de instrumentos musicais (exceto cordas arcadas)',
	},
	{
		value: '915210 - Reparador de instrumentos musicais',
		label: '915210 - Reparador de instrumentos musicais',
	},
	{
		value: '915215 - Luthier (restauração de cordas arcadas)',
		label: '915215 - Luthier (restauração de cordas arcadas)',
	},
	{
		value: '915305 - Técnico em manutenção de equipamentos e instrumentos médico-hospitalares',
		label: '915305 - Técnico em manutenção de equipamentos e instrumentos médico-hospitalares',
	},
	{
		value: '915405 - Reparador de equipamentos fotográficos',
		label: '915405 - Reparador de equipamentos fotográficos',
	},
	{
		value: '919105 - Lubrificador industrial',
		label: '919105 - Lubrificador industrial',
	},
	{
		value: '919115 - Lubrificador de embarcações',
		label: '919115 - Lubrificador de embarcações',
	},
	{
		value: '919110 - Lubrificador de veículos automotores (exceto embarcações)',
		label: '919110 - Lubrificador de veículos automotores (exceto embarcações)',
	},
	{
		value: '919205 - Mecânico de manutenção de máquinas cortadoras de grama, roçadeiras, motosserras e similares',
		label: '919205 - Mecânico de manutenção de máquinas cortadoras de grama, roçadeiras, motosserras e similares',
	},
	{
		value: '919310 - Mecânico de manutenção de bicicletas e veículos similares',
		label: '919310 - Mecânico de manutenção de bicicletas e veículos similares',
	},
	{
		value: '919305 - Mecânico de manutenção de aparelhos esportivos e de ginástica',
		label: '919305 - Mecânico de manutenção de aparelhos esportivos e de ginástica',
	},
	{
		value: '919315 - Montador de bicicletas',
		label: '919315 - Montador de bicicletas',
	},
	{
		value: '950105 - Supervisor de manutenção elétrica de alta tensão industrial',
		label: '950105 - Supervisor de manutenção elétrica de alta tensão industrial',
	},
	{
		value: '950110 - Supervisor de manutenção eletromecânica industrial, comercial e predial',
		label: '950110 - Supervisor de manutenção eletromecânica industrial, comercial e predial',
	},
	{
		value: '950205 - Encarregado de manutenção elétrica de veículos',
		label: '950205 - Encarregado de manutenção elétrica de veículos',
	},
	{
		value: '950305 - Supervisor de manutenção eletromecânica',
		label: '950305 - Supervisor de manutenção eletromecânica',
	},
	{
		value: '951105 - Eletricista de manutenção eletroeletrônica',
		label: '951105 - Eletricista de manutenção eletroeletrônica',
	},
	{
		value: '951315 - Monitor de sistemas eletrônicos de segurança interno',
		label: '951315 - Monitor de sistemas eletrônicos de segurança interno',
	},
	{
		value: '951320 - Monitor de sistemas eletrônicos de segurança externo',
		label: '951320 - Monitor de sistemas eletrônicos de segurança externo',
	},
	{
		value: '951310 - Mantenedor de sistemas eletroeletrônicos de segurança',
		label: '951310 - Mantenedor de sistemas eletroeletrônicos de segurança',
	},
	{
		value: '951305 - Instalador de sistemas eletroeletrônicos de segurança',
		label: '951305 - Instalador de sistemas eletroeletrônicos de segurança',
	},
	{
		value: '953105 - Eletricista de instalações (aeronaves)',
		label: '953105 - Eletricista de instalações (aeronaves)',
	},
	{
		value: '953115 - Eletricista de instalações (veículos automotores e máquinas operatrizes, exceto aeronaves e embarcações)',
		label: '953115 - Eletricista de instalações (veículos automotores e máquinas operatrizes, exceto aeronaves e embarcações)',
	},
	{
		value: '953110 - Eletricista de instalações (embarcações)',
		label: '953110 - Eletricista de instalações (embarcações)',
	},
	{
		value: '954105 - Eletromecânico de manutenção de elevadores',
		label: '954105 - Eletromecânico de manutenção de elevadores',
	},
	{
		value: '954110 - Eletromecânico de manutenção de escadas rolantes',
		label: '954110 - Eletromecânico de manutenção de escadas rolantes',
	},
	{
		value: '954115 - Eletromecânico de manutenção de portas automáticas',
		label: '954115 - Eletromecânico de manutenção de portas automáticas',
	},
	{
		value: '954120 - Mecânico de manutenção de instalações mecânicas de edifícios',
		label: '954120 - Mecânico de manutenção de instalações mecânicas de edifícios',
	},
	{
		value: '954125 - Operador eletromecânico',
		label: '954125 - Operador eletromecânico',
	},
	{
		value: '954205 - Reparador de aparelhos eletrodomésticos (exceto imagem e som)',
		label: '954205 - Reparador de aparelhos eletrodomésticos (exceto imagem e som)',
	},
	{
		value: '954210 - Reparador de rádio, tv e som',
		label: '954210 - Reparador de rádio, tv e som',
	},
	{
		value: '954305 - Reparador de equipamentos de escritório',
		label: '954305 - Reparador de equipamentos de escritório',
	},
	{
		value: '991105 - Conservador de via permanente (trilhos)',
		label: '991105 - Conservador de via permanente (trilhos)',
	},
	{
		value: '991110 - Inspetor de via permanente (trilhos)',
		label: '991110 - Inspetor de via permanente (trilhos)',
	},
	{
		value: '991115 - Operador de máquinas especiais em conservação de via permanente (trilhos)',
		label: '991115 - Operador de máquinas especiais em conservação de via permanente (trilhos)',
	},
	{
		value: '991120 - Soldador aluminotérmico em conservação de trilhos',
		label: '991120 - Soldador aluminotérmico em conservação de trilhos',
	},
	{
		value: '991205 - Mantenedor de equipamentos de parques de diversões e similares',
		label: '991205 - Mantenedor de equipamentos de parques de diversões e similares',
	},
	{
		value: '991305 - Funileiro de veículos (reparação)',
		label: '991305 - Funileiro de veículos (reparação)',
	},
	{
		value: '991310 - Montador de veículos (reparação)',
		label: '991310 - Montador de veículos (reparação)',
	},
	{
		value: '991315 - Pintor de veículos (reparação)',
		label: '991315 - Pintor de veículos (reparação)',
	},
	{
		value: '992105 - Alinhador de pneus',
		label: '992105 - Alinhador de pneus',
	},
	{ value: '992120 - Lavador de peças', label: '992120 - Lavador de peças' },
	{ value: '992115 - Borracheiro', label: '992115 - Borracheiro' },
	{ value: '992110 - Balanceador', label: '992110 - Balanceador' },
	{
		value: '992205 - Encarregado geral de operações de conservação de vias permanentes (exceto trilhos)',
		label: '992205 - Encarregado geral de operações de conservação de vias permanentes (exceto trilhos)',
	},
	{
		value: '992220 - Pedreiro de conservação de vias permanentes (exceto trilhos)',
		label: '992220 - Pedreiro de conservação de vias permanentes (exceto trilhos)',
	},
	{
		value: '992215 - Operador de ceifadeira na conservação de vias permanentes',
		label: '992215 - Operador de ceifadeira na conservação de vias permanentes',
	},
	{
		value: '992210 - Encarregado de equipe de conservação de vias permanentes (exceto trilhos)',
		label: '992210 - Encarregado de equipe de conservação de vias permanentes (exceto trilhos)',
	},
	{
		value: '992225 - Auxiliar geral de conservação de vias permanentes (exceto trilhos)',
		label: '992225 - Auxiliar geral de conservação de vias permanentes (exceto trilhos)',
	},
];



// WEBPACK FOOTER //
// ./src/assets/js/cbo.js